"use strict";

import { urls } from "../constants";

const lang = "en";

export default [
        {
            id: "pound-4-pound",
            menuItem: {
                en: {
                    title: "Pound 4 Pound",
                    url: "fastfoot-residential/projects/pound-4-pound",
                    metaTitle: "Pound 4 Pound and Fastfoot | Efficient Footing Forming in Whistler, BC",
                    metaDescription: "Learn how Pound 4 Pound used Fastfoot® to form over 600' of footing with ease in Whistler, BC. See how Fastfoot® improved project efficiency and protected against rising damp.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Pound 4 Pound and Fastfoot",
            cardDescription: `Five levels on a single site?!...`,
            cardImage: "/images/pound-4-pound.webp",
            title: "Pound 4 Pound - First time using Fastfoot",
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/vi0DVl3nQ1I",
                    title: "Forming stepped concrete footings efficiently"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<p>Tim Sprague, Owner, 
                    <a rel="noreferrer" href="https://www.lb4lbframeform.com" onclick="window.open(this.href,'_blank');return false;">Pound 4 Pound Forming and Framing</a>,
                    talks about their first time use of the Fastfoot footing form.</p>`,
                    image: ""
                },
                {
                    title: "",
                    body: `<p>This residential project, located up in the mountains of Whistler, BC had over 600' of footing 
                        24" x 10". Large elevation changes required over 30 steps in the footing. 
			            Which were formed with just 7 rolls and 28 corners of Fastfoot 62".</p>`,
                    image: "/images/projects/pound-4-pound-1.webp"
                },
                {
                    title: "",
                    body: `<p>Footings were supposed to be 10" in depth. With the excavation out 6-7", 
                        Fastfoot made adjusting the footing depth incredibly easy.</p>`,
                    image: "/images/projects/pound-4-pound-2.webp"
                },
                {
                    title: "",
                    body: `<p>Tim averaged about 1 hour to form these steps with Fastfoot. If using plywood and threaded rod, 
                        Tim believes it would have taken many more hours per step to form.</p>`,
                    image: "/images/projects/pound-4-pound-3.webp"
                },
                {
                    title: "",
                    body: `<p>Fastfoot also protects the lumber from concrete splash. This means a large amount of the lumber 
                        will be reused in the framing of the house later on.</p>`,
                    image: "/images/projects/pound-4-pound-4.webp"
                },
                {
                    title: "",
                    body: `<p>Fastfoot also prevents ground moisture from wicking up into the home through the footing. This is a 
			            very inexpensive insurance to prevent mold and mildew in the basement. <a href="/${lang}/${urls.fastFoot.residential.risingDamp}">Learn more about rising damp</a>.</p>`,
                    image: "/images/projects/pound-4-pound-5.webp"
                },
                {
                    title: "",
                    body: `<p>Finishing the concrete footing is much easier with Fastfoot as the concrete slump can be 6" instead of the traditional 4" slump 
			            used with dimensional lumber to prevent leakage between the lumber and uneven ground.</p>`,
                    image: "/images/projects/pound-4-pound-6.webp"
                }
            ]
        },
        {
            id: "versa",
            menuItem: {
                en: {
                    title: "Versa",
                    url: "fastfoot-residential/projects/versa",
                    metaTitle: "Versa | Save 50% on Lumber Costs with Fastfoot Footings",
                    metaDescription: "Discover how Versa used Fastfoot® to save 50% on lumber costs for their residential footing project in Langley, BC. Learn about the benefits of using Fastfoot® over traditional wood framing.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Fastfoot 50% lumber price",
            cardDescription: `With sky high lumber prices...`,
            cardImage: "/images/versa.webp",
            title: "Versa",
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/okizuEjhbjE",
                    title: "Fastfoot footings vs conventional wood framed footings",
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<p>With lumber prices up 130% since April, the cost of forming with Fastfoot is now 
                        approximately 50% of using lumber.</p>`,
                    image: "/images/projects/versa-1.webp"
                },
                {
                    title: "",
                    body: `<p>This residential project, located in Langley BC had 900 feet of footing sized 24" x 12" 
			            and 48" x 12". Just nine rolls of FF62 fabric and 30 corners were used to form the footings. 
			            Compare that with 1,800' of 2x12".</p>`,
                    image: "/images/projects/versa-2.webp"
                },
                {
                    title: "",
                    body: `<p>Setting up and stripping heavy 2x12" is back breaking work. These 
			            Fastfoot footings are just 25% the weight of a conventional footing. 
			            Leading to a much happier and energized crew. </p>`,
                    image: "/images/projects/versa-3.webp"
                },
                {
                    title: "",
                    body: `<p>A high slump concrete can now be used as Fastfoot is a closed form. This makes screeding 
                        and consolidating concrete dead easy. </p>`,
                    image: "/images/projects/versa-4.webp"
                },
                {
                    title: "",
                    body: `<p>Concrete pour is complete. Notice that the stakes and 2x4s are protected from the concrete 
                        by Fastfoot. This makes for fast stripping and no damage to the stakes or 2x4s.</p>`,
                    image: "/images/projects/versa-5.webp"
                }
            ]
        },
        {
            id: "dt-royal",
            menuItem: {
                en: {
                    title: "DT Royal",
                    url: "fastfoot-residential/projects/dt-royal",
                    metaTitle: "DT Royal Construction | Why We Use Fastfoot for Concrete Footings",
                    metaDescription: "DT Royal Construction shares why Fastfoot® is their preferred choice for forming concrete footings and preventing rising damp in their Langley, BC projects.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Fastfoot footings succeed",
            cardDescription: `Damien Acosta discusses the advantages...`,
            cardImage: "/images/damien-acosta.webp",
            title: "DT Royal Construction - Why we use Fastfoot",
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/RXrgXsMYPYE",
                    title: "Fastfoot® Concrete Footing Form - DT Royal Construction"                }
            ],
            articles: [
                {
                    title: "",
                    body: `<p>Damien Acosta, Forming supervisor, DT Royal Construction, discusses in this video the importance 
                    of Fastfoot in preventing rising damp as well the cost effectiveness over using 2x10 dimensional lumber.</p>`,
                    image: ""
                },
                {
                    title: "",
                    body: `<p>This residential project, located in Langley BC had approximately 900 feet of footing 
                        sized 24" x 10" and 48" x 12". All the walls and floor assemblies are concrete. Nine rolls of 
                        FF62 fabric and 30 corners were used to form the footings. Compare that with 1,800' of 
                        dimensional lumber which would be required using convention footing construction.</p>`,
                    image: "/images/projects/dt-royal-1.webp"
                },
                {
                    title: "",
                    body: `<p>Fastfoot prevents ground moisture from wicking up into the concrete footing for the life 
                        of the building. This is a very inexpensive insurance to prevent mold and mildew in the 
                        basement. Learn more about <a href="/${lang}/${urls.fastFoot.residential.risingDamp}">rising damp prevention</a>.</p>`,
                    image: "/images/projects/dt-royal-2.webp"
                },
                {
                    title: "",
                    body: `<p>Fab-Form manufactures pre-sewn corners that simplify installation.</p>`,
                    image: "/images/projects/dt-royal-3.webp"
                },
                {
                    title: "",
                    body: `<p>Rebar penetrations are easy with Fastfoot. Simply make a small slit in the fabric and push 
                        the rebar through. Even 4" plumbing pipes can penetrate in the same manner.</p>`,
                    image: "/images/projects/dt-royal-4.webp"
                },
                {
                    title: "",
                    body: `<p>Finishing the concrete footing is much easier with Fastfoot as the concrete slump can be 
                        6" instead of the traditional 4" slump used with dimensional lumber to prevent leakage between 
                        the lumber and uneven ground.</p>`,
                    image: "/images/projects/dt-royal-5.webp"
                }
            ]
        },
        {
            id: "jdl-homes",
            menuItem: {
                en: {
                    title: "JDL Homes",
                    url: "fastfoot-residential/projects/jdl-homes",
                    metaTitle: "JDL Homes | Fastfoot® for Green Building and Rising Damp Protection",
                    metaDescription: "Learn why JDL Homes uses Fastfoot® to form their concrete footings, prevent rising damp, and improve sustainability in their home projects in Vancouver, BC.",
                }
            },
            category: "fastFootForms",
            cardTitle: "JDL Homes and Fastfoot",
            cardDescription: `Jeff Langford explains why Fastfoot...`,
            cardImage: "/images/jdl-homes.webp",
            title: "JDL Homes - Why we use Fastfoot",
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/-67e50RCFn0",
                    title: "Fastfoot® Residential Footing Form"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<p>Jeff Langford, Partner of JDL Homes, discusses in this video the importance of Fastfoot in 
                    preventing rising damp as well as other steps taken to improve the quality and thermal performance of their homes.</p>`,
                    image: ""
                },
                {
                    title: "",
                    body: `<p>Fastfoot allows JDL to form their footings with 2x4s, this means less lumber to the 
                        jobsite, and much less to throw out. With the closed form, shoveling gravel around the base of 
                        the footings is no longer needed. </p>`,
                    image: "/images/projects/jdl-homes-1.webp"
                },
                {
                    title: "",
                    body: `<p>Fastfoot prevents ground moisture from wicking up into the concrete footing for the life 
                        of the building. This is a very inexpensive insurance to prevent mold and mildew in the 
                        basement. <a href="/${lang}/${urls.fastFoot.residential.risingDamp}">Learn more about preventing rising damp</a>.</p>`,
                    image: "/images/projects/jdl-homes-2.webp"
                },
                {
                    title: "",
                    body: `<p>Zont™ bracing was used to flatten the ICF wall, provide a walkway, and adjust the plumb. 
                        Learn more on the <a href="/${lang}/${urls.zontBracing.overview}">Zont™ Bracing overview page</a>.</p>`,
                    image: "/images/projects/jdl-homes-3.webp"
                },
                {
                    title: "",
                    body: `<p>JDL Homes uses Soprema's Colphene 3000 Peel & Stick membrane to protect the wall 
                        against ground moisture. The membrane is then lapped over Fastfoot® to ensure that moisture 
                        cannot enter the foundation wall nor footing.</p>`,
                    image: "/images/projects/jdl-homes-4.webp"
                },
                {
                    title: "",
                    body: `<p>JDL Homes uses a dimple membrane on the outside of the Peel & Stick to ensure water 
                        cannot build up on the outside of the wall. A grey breathable air barrier is placed above the 
                        Peel & Stick to allow the water vapour to escape during the curing process.</p>`,
                    image: "/images/projects/jdl-homes-5.webp"
                },
                {
                    title: "",
                    body: `<p>JDL Homes has a great blog discussing this project — 
                        <a rel="noreferrer" href="https://www.jdlhomesvancouver.com/jdl-blog/why-jdl-homes-uses-nudura-insulated-concrete-forms-icfs">read the blog post here</a>.</p>`,
                    image: "/images/projects/jdl-homes-6.webp"
                }
            ]
        },
        {
            id: "boda-construction",
            menuItem: {
                en: {
                    title: "Boda Construction",
                    url: "fastfoot-residential/projects/boda-construction",
                    metaTitle: "Boda Construction | Using Fastfoot® for Moisture Protection and Sustainability",
                    metaDescription: "Discover how Boda Construction in West Vancouver, BC uses Fastfoot® to protect foundations from rising damp and improve the sustainability of their custom home builds.",
                }
            },
            category: "fastFootForms",
            cardTitle: "From Dream to Reality",
            cardDescription: `Boda Construction uses Fastfoot® to protect against ground moisture and rising damp...`,
            cardImage: "/images/boda.webp",
            title: "Boda Construction - Attention to detail",
            images: ["/images/projects/boda-construction-1.webp"],
            videos: [],
            articles: [
                {
                    title: "",
                    body: `<div><p><a rel="noreferrer" href="https://www.bodaconstruction.com" onclick="window.open(this.href,'_blank');return false;">BODA Construction</a> is an established 
                    custom home builder in West Vancouver, BC with a strong reputation 	for quality and attention to detail. 
                    But translating that dream into reality requires close attention to details that don't show 
                    immediately to the client.</p>
                    <p>For example, protecting the concrete footing against ground moisture. Concrete is a wicking material: 
                    ground moisture naturally wicks up through the footing into the concrete wall where it evaporates inside 
                    the home. This excess moisture leads to a damp and musky smell prevalent in 80% of all foundations — 
                    <a href="ftp://ftp.cmhc-schl.gc.ca/chic-ccdh/Research_Reports-Rapports_de_recherche/eng_bilingual/Molds%20in%20Finished%20Basements.pdf" onclick="window.open(this.href,'_blank');return false;">
                    view the CMHC report on damp basements</a>.</p>
                    </div>`,
                    image: ""
                },
                {
                    title: "Attention to hidden details",
                    body: `<div><p>Boda Construction goes that extra distance to ensure a dry foundation for its clients by 
                        using Fastfoot® to form and protect the footing concrete from rising damp.</p>
                        <p><em>"It makes no sense that builders provide protection on the foundation wall for dampness"</em>, 
                        said Aaron Macnabb, Site Supervisor, <em>"yet they leave footings unprotected against ground moisture."</em></p></div>`,
                    image: "/images/projects/boda-construction-2.webp"
                },
                {
                    title: "FASTFOOT® - Protection from ground moisture",
                    body: `<p><em>"FastFoot is so superior to conventional footings.  By adding curb stakes and a builders 
                        level into the mix we were able to level our footings to within +/- 1/32". The barrier that 
                        FastFoot material provides against 'rising damp' was evident in that the foundation walls were 
                        always dry at the bottom, with the only water coming down from the top when it rained. My guys 
                        and I love this product. Thanks"</em>, said Aaron for Boda Construction.</p>`,
                    image: "/images/projects/boda-construction-3.webp"
                },
                {
                    title: `Using "Peel & Stick"`,
                    body: `<div><p>Boda Construction trims the excess width of Fastfoot®, then attaches the fabric edge to 
                        the base of the formed concrete wall with an 8" width of 'Peel & Stick'.</p>
                        <p>The dimpled wall membrane is lapped over the Peel & Stick providing complete moisture 
                        protection to the foundation wall and footing.</p></div>`,
                    image: "/images/projects/boda-construction-4.webp"
                },
                {
                    title: "Designing the Dream",
                    body: `<div><p><em>"The Butterfly House explores a west coast contemporary aesthetic. The home is shaped 
                        by strong, simple forms including a butterfly/inverted roof that gives the home its unique 
                        character. Clear stained cedar siding mixed with concrete, aluminum windows and trim give the 
                        home a distinctly modern feel while still capturing the warmth of a ‘west coast’ expression.</em></p>
                        <p><em>A large green roof covers the first roof level of the home, replacing what would typically 
                        be a large asphalt surface  with something that is both visually desirable and environmentally 
                        conscious".</em></p><p><a rel="noreferrer" href="https://www.vallely.ca/VALLELY/Butterfly_House.html" onclick="window.open(this.href,'_blank');return false;">
                        Kevin Vallely, Architect</a>.</p></div>`,
                    image: "/images/projects/boda-construction-5.webp"
                }
            ]
        },
        {
            id: "naikoon-nv",
            menuItem: {
                en: {
                    title: `Midori Uchi Project`,
                    url: "fastfoot-residential/projects/naikoon-nv",
                    metaTitle: "Midori Uchi Project | Sustainable Footings for a Green Home in North Vancouver",
                    metaDescription: "See how Naikoon Contracting used Fastfoot® to form sustainable footings for their green Midori Uchi project in North Vancouver, BC.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Fastfoot® & Midori Uchi green Project",
            cardDescription: `Sustainable footings for a very green Naikoon project...`,
            cardImage: "/images/naikoon.webp",
            title: `Midori Uchi Project`,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/3mioJg-ym8Q",
                    title: "Fastfoot® Residential Strip Footing Form"
                }
            ],
            articles: [
                {
                    title: `"Midori Uchi" Project`,
                    body: `<div><p><a rel="noreferrer" href="https://www.naikooncontracting.com" onclick="window.open(this.href,'_blank');return false;">Naikoon Contracting Ltd.</a>, 
                        North Vancouver BC, recently formed and poured footings for one of Canada’s 'greenest' homes 
                        which hopes to achieve the highest LEED Platinum score in Canada as well as meet the new R-2000 
                        certification for energy efficiency.</p><p>Joe Geluch, President, has been a green builder for 
                        15 years and won numerous awards for his efforts.</p><p>Click on the image to go 
                        to the Midori Uchi project page. Note the rammed earth walls on the front left corner of the home.</p>
                        <p><em>"We always use Fastfoot® on our footings"</em>, confirmed Joe, <em>"the fabric prevents 
                        ground moisture entering the foundation as well as prevents concrete damage to our lumber."</em></p></div>`,
                    image: "/images/projects/naikoon-nv-1.webp"
                },
                {
                    title: "Setting up screed boards",
                    body: `<div><p>In order to minimize lumber, Naikoon's crew used 2x4s for the screed boards.</p><p>The 
                        laser is used to ensure the top of the screed board is at the exact height for the ICF blocks.</p></div>`,
                    image: "/images/projects/naikoon-nv-2.webp"
                },
                {
                    title: `Folding Fastfoot® around corners"`,
                    body: `<div><p>Fastfoot® is 'folded' around corners so that <a href="/${lang}/${urls.fastFoot.residential.risingDamp}">ground 
                        moisture cannot enter the concrete</a>.</p><p>A hammer tacker with 3/8" staples is used to fasten 
                        the fabric to the top of the 2x4 screed board.</p></div>`,
                    image: "/images/projects/naikoon-nv-3.webp"
                },
                {
                    title: "Wide Footings for Rammed Earth Feature Wall",
                    body: `<div><p>The structural engineer required a 6' wide footing under the rammed each wall.</p>
                        <p>Naikoon's crew lays out two widths of Fastfoot® under the footing to protect against ground 
                        moisture.</p><p>The photo below shows the fabric and steel reinforcing completed.</p></div>`,
                    image: "/images/projects/naikoon-nv-4.webp"
                },
                {
                    title: "",
                    body: ``,
                    image: "/images/projects/naikoon-nv-5.webp"
                },
                {
                    title: "Placing concrete in Fastfoot®",
                    body: `<div><p>Fastfoot® is a closed form, preventing the concrete from being contaminated by the ground. 
                        Concrete is very expensive, typically from $150 to $200 per cubic meter. Fastfoot® prevents concrete 
			            leakage and produces better quality concrete by preventing contamination.</p>
                        <p>Engineers require 3" clearance between the steel and the ground. With Fastfoot® this distance 
                        can be reduced to 1 1/2" thereby increasing the bending moment capacity of the footing as the tensile 
			            strength of the steel is directly proportional to the distance from the neutral axis.</p></div>`,
                    image: "/images/projects/naikoon-nv-6.webp"
                },
                {
                    title: "Dowelling",
                    body: `<div><p>The engineer required 15M dowels 16" on centre to provide strength to the cold joint 
                        between the footing and wall.</p><p>With the monopoured foundation in the background, there is no 
			            cold joint, therefore providing a stronger foundation.</p></div>`,
                    image: "/images/projects/naikoon-nv-7.webp"
                },
                {
                    title: "",
                    body: ``,
                    image: "/images/projects/naikoon-nv-8.webp"
                }
            ]
        },
        {
            id: "kent-whitham",
            menuItem: {
                en: {
                    title: "Kent Whitham",
                    url: "fastfoot-residential/projects/kent-whitham",
                    metaTitle: "Kent Whitham | Fastfoot® for Rising Damp Protection in Sandpoint, Idaho",
                    metaDescription: "Kent Whitham uses Fastfoot® to prevent rising damp and ensure dry foundations for their retirement home in Sandpoint, Idaho. Learn more about their moisture control techniques.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Fastfoot® & Rising Damp",
            cardDescription: `Protection against ground moisture requires careful attention...`,
            cardImage: "/images/kent-whitham.webp",
            title: "",
            images: ["/images/projects/kent-whitham-1.webp"],
            videos: [],
            articles: [
                {
                    title: "",
                    body: `<p>Kent Whitham and wife Linda recently formed and poured the footings and foundation walls for their 
                    retirement home in Sandpoint, Idaho with great success. <em>"We had a seep under one corner of our 
                    existing basement", </em> said Kent. <em>"That's why we have gone to great pains to ensure that this 
                    potential damp generator is controlled. Fastfoot® in combination with the waterproofing membrane will 
                    ensure that subterranean seep will not result in a damp basement."</em></p>`,
                    image: ""
                },
                {
                    title: "",
                    body: `<div><p><em>"We wanted a capillary break between the clay and the bottom of the footing"</em>, 
                        said Kent. <em>"We installed a 4" layer of gravel so that any water in the excavation could pass 
	                    through the gravel to the perimeter drain."</em></p><p>Rover (see inset picture) supervised the 
	                    installation of the drainage layer, ensuring the layer was uniform and properly compacted. 
	                    Rover is very task oriented and ignored Kent's repeated requests for a coffee break.</p></div>`,
                    image: "/images/projects/kent-whitham-2.webp"
                },
                {
                    title: "",
                    body: `<p>Kent set up his screed boards around the perimeter of the foundation. As the foundation 
                        walls were 10' high on one side, the engineer required 5' wide footings to support the soil loads 
                        of 8 to 10'.</p>`,
                    image: "/images/projects/kent-whitham-3.webp"
                },
                {
                    title: "",
                    body: `<p>Fastfoot® was installed using a hammer tacker with 3/8" staples. Colored adjustment lines 
                        made for easy installation.</p>`,
                    image: "/images/projects/kent-whitham-4.webp"
                },
                {
                    title: "",
                    body: `<p style="text-align:left; font-style:normal;">The structural engineer required two rows of 
                        #5 60 ksi bar 16" on center both ways in the retaining wall footing, with #5 hooks 16" on center 
                        running up into the wall, with every other vertical doubled.</p>`,
                    image: "/images/projects/kent-whitham-5.webp"
                },
                {
                    title: "",
                    body: `<p style="text-align:left; font-style:normal;">The concrete placing crew ready for action on 
                        a cool, misty morning. Fortunately the pump showed up so shovelling from the concrete truck to 
                        the footing forms was not necessary.</p>`,
                    image: "/images/projects/kent-whitham-6.webp"
                },
                {
                    title: "",
                    body: `<div><p>51 cubic yards of concrete were required in the footings which included six steps. Kent 
                        estimated the total volume at 49.88 cubic yards, allowed 1/2 yard for the pumper and 1/2 yard 
                        as a cushion. "We had a half yard left over after 6 trucks at 8.5 yards each", said Kent.</p>
                        <p><em>"We were real pleased with the results. No blowouts, no injuries. The contractor 
	                    and a couple of the guys helping are converts to Fastfoot®. Not one staple or tear in the entire 
	                    job and I did use a 1 1/2" diameter vibrator in the footing concrete."</em></p></div>`,
                    image: "/images/projects/kent-whitham-7.webp"
                },
                {
                    title: "",
                    body: `<div><p>8" Fox Blocks formed the basement walls. Zont™ bracing was used to align the tall walls.</p>
                        <p><em>"I was really impressed with the performance of the bracing system, and because we were a 
                        very small crew, the bracing system I think saved me some time and costs because of the complexity 
                        of the bracing we needed. If I had to rent the steel bracing, it would have been a struggle to 
                        complete the pours that I needed to do without incurring a lot of rental charges. Plus the fact 
                        that those steel braces are HEAVVVVVY"</em>, confirmed Kent.</p></div>`,
                    image: "/images/projects/kent-whitham-8.webp"
                },
                {
                    title: "",
                    body: `<div><p>Proper treatment of Fastfoot® is essential to ensuring 
                        <a href="/${lang}/${urls.fastFoot.residential.risingDamp}">rising damp</a> does not occur between the ground and the 
                        footing concrete.</p>
                        <ul>
		                    <li>The ICF wall and footing was cleaned of all dirt and dust;</li>
		                    <li>Painted with a water based primer;</li>
		                    <li>Fastfoot® was held in place with sheathing tape;</li>
		                    <li>Peel and stick wall membrane was rolled down the wall, along the top of the footing, and over the Fastfoot®.</li>
	                    </ul>
                        <p>This treatment ensures that any water coming down the wall will pass over the top and sides 
                        of the footing, through the drainage layer and into the drainage system. And the basement stays warm and dry.</p></div>`,
                    image: "/images/projects/kent-whitham-9.webp"
                }
            ]
        },
        {
            id: "danny-epp",
            menuItem: {
                en: {
                    title: "Danny Epp",
                    url: "fastfoot-residential/projects/danny-epp",
                    metaTitle: "Danny Epp | Greener Footings with Fastfoot® for Tsawwassen, BC Home",
                    metaDescription: "See how Danny Epp used Fastfoot® to form footings for his new home in Tsawwassen, BC, benefiting from less material and improved moisture protection.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Fastfoot® installed by Father & Sons",
            cardDescription: `A perfect ICF footing installed by the Epp Family...`,
            cardImage: "/images/danny-epp-son.webp",
            title: "FASTFOOT® - Greener footings",
            images: ["/images/projects/dany-epp-1.webp"],
            videos: [],
            articles: [
                {
                    title: "",
                    body: `<p>Danny Epp and his two sons Ryan and Brandon formed and poured the footings for their new home in
                    Tsawwassen, BC using the green Fastfoot® forming membrane.</p>`,
                    image: ""
                },
                {
                    title: "Building Site",
                    body: `<div><p>The building site was excavated on two separate levels to minimize excavation costs on a 
                        steep slope. The owners are using the Logix® insulated concrete form which measure 16" in height, 
                        and 4' in length.</p><p>The two levels have a 48" height difference which accommodates 3 levels 
                        of the ICF block.</p></div>`,
                    image: "/images/projects/dany-epp-2.webp"
                },
                {
                    title: "Footing Size",
                    body: `<div><p>Fastfoot® fabric membrane is pulled between the screed boards, and stapled in position 
                        using the width adjustment lines.</p><p>The 'folded corner' method was used to install Fastfoot® 
                        around corners. 1x4 cleats were installed to withstand lateral concrete pressure and hang steel 
			            reinforcing.</p><p>The engineer required three horizontal members, with uprights 24" on center. 
			            The support for the steel uprights has been lifted by a 1-1/2" spacer block to provide extra 
			            space for screeding.</p></div>`,
                    image: "/images/projects/dany-epp-3.webp"
                },
                {
                    title: "Pouring Concrete",
                    body: `<div><p>The concrete pour was flawless. Note the steel reinforcing puncturing the fabric - 
			            this steel will tie into an interior footing to be formed and poured at a later date.</p>
                        <p>Each of the four steps were formed with fabric. 2x4 vertical stakes formed the front edge of 
			            each step, and screed boards attached at the top of each step. The framework was then lined with 
			            Fastfoot® to form and contain the concrete. 16" high by 30" wide plywood bulkheads were then 
			            screwed to the 2x4 vertical stakes to form the vertical face of each step.</p></div>`,
                    image: "/images/projects/dany-epp-4.webp"
                },
                {
                    title: "",
                    body: `<p>Watch a video of the Fastfoot® installation on this project by visiting the 
                        <a href="/${lang}/${urls.fastFoot.residential.installation}">Fastfoot® installation page</a>.</p>
                    `,
                    image: "/images/projects/dany-epp-5.webp"
                }
            ]
        },
        {
            id: "sawatzky",
            menuItem: {
                en: {
                    title: `Sustainable Formwork for an "Imagination Home"`,
                    url: "fastfoot-residential/projects/sawatzky",
                    metaTitle: "Sawatzky's Imagination Home | Sustainable Formwork for a Unique Design",
                    metaDescription: "Learn how Sawatzky's Imagination Corporation used Fastfoot® for sustainable formwork in the construction of their unique 'Imagination Home' in BC.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Footings and Columns for the Imagination",
            cardDescription: `Even the imagination requires solid footings & columns...`,
            cardImage: "/images/i-corp-logo.webp",
            title: `Sustainable Formwork for an "Imagination Home"`,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/5St-hzAnnmE",
                    title: "Fastfoot® Concrete Footing Form: Contractor Testimonial",
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<div><p><a rel="noreferrer" href="https://imaginationcorporation.com/" onclick="window.open(this.href,'_blank');return false;">Sawatzky's Imagination Corporation</a> 
                        is a small family company that specializes in the design and creation of dimensional signs and 
                        environments. They tackle projects of any size from small signs to entire theme parks. Their 
                        work has garnered numerous national and international awards.</p><p>Dan Sawatzky is and has been 
                        a creative force in the sign industry, a visual storyteller spanning over forty years. He and 
	                    his crew host Sign Magic Workshops in their studio a number of times each year with attendees 
	                    coming from around the world.</p></div>`,
                    image: "/images/projects/swatzky-corp-1.webp"
                },
                {
                    title: "Building Design",
                    body: `<div><p>The Sawatzky's new home is designed to accomodate large gatherings of family as well as 
                    host a number of workshops each year. The rooms are large and spacious.</p><p>Dan is enthusiastic 
                    about building with concrete. He'll be using the
	                <a rel="noreferrer" href="https://www.logixicf.com/" onclick="window.open(this.href,'_blank');return false;">Logix® Platinum block</a> for higher thermal 
	                performance right up to his truss plate.</p>
                    <p>Click on the image to go to
                    <a rel="noreferrer" href="https://imaginationcorporation.com/house-project/" onclick="window.open(this.href,'_blank');return false;">Dan's house blog</a>.</p></div>`,
                    image: "/images/projects/swatzky-corp-2.webp"
                },
                {
                    title: "Screed Board Installation",
                    body: `<div><p>Dan is not an experienced machine operator, so the elevation differed about 5" from one 
                        side of the excavation to the other.</p><p>The forming contractor is Harold's Contracting of 
                        Abbotsford BC. Harold Esau and his crew quickly set up the screed boards using a laser level 
                        and 1x2 stakes 6 to 8' on center.</p><p>Visit the <a href="/${lang}/${urls.fastFoot.residential.installation}">Fastfoot® installation page</a> to learn more.</p></div>`,
                    image: "/images/projects/swatzky-corp-3.webp"
                },
                {
                    title: "Fastfoot® Installation",
                    body: `<div><p>Fastfoot® is adjusted to uneven grades using specially marked footing width lines and 
                        letting the fabric out in deeper sections.</p><p>Fastfoot® is stapled to the top of the 
	                    screed boards using a hammer tacker with 3/8" staples.</p><p>Harold's team quickly got on to 
	                    folding corners. They cut an "inverted T" on the inside of the corner, folded the fabric 90 
	                    degrees and then continued in the new direction.</p></div>`,
                    image: "/images/projects/swatzky-corp-4.webp"
                },
                {
                    title: "Fast-Tube™ Setup",
                    body: `<div><p>The engineer specfied 16" diameter columns to support the artistic front porch.</p>
                    <p>"I like Fast-Tube™", confirmed Dan. "They're fast to cut, and easy to setup once you understand 
                    how to staple the alignment tab to the 2x4."</p><p>Visit the <a href="/${lang}/${urls.fastTube.installation}">Fast-Tube™ installation page</a> to learn more.</p></div>`,
                    image: "/images/projects/swatzky-corp-5.webp"
                },
                {
                    title: "Placing Footing Concrete",
                    body: `<div><p>Fastfoot® prevents all concrete leakage and reduces concrete consumption.</p><p>Notice how 
                        the fabric prevents the concrete damage to the lumber.</p></div>`,
                    image: "/images/projects/swatzky-corp-6.webp"
                },
                {
                    title: "Placing Concrete in Columns",
                    body: `<p>Dan filled the column pads first, then filled the regular footings. Then he came back and 
                        filled the columns. This prevented the column concrete from leaking out the footing.</p>`,
                    image: "/images/projects/swatzky-corp-7.webp"
                },
                {
                    title: "Rising Damp Protection",
                    body: `<div><p>Abbotsford gets 60 inches of rain a year, so ground moisture is a major issue. Fastfoot® 
                        is a vapor barrier, preventing ground moisture from entering the concrete.</p><p>Harold's crew 
                        pulled Fastfoot® from the top of the screed boards and taped the edges together.</p>
                        <p><a rel="noreferrer" href="https://www.logixicf.com" onclick="window.open(this.href,'_blank');return false;">Logix® blocks</a> will be placed on top the 
                        fabric to ensure it stays in position. Once the wall has been poured, a 12" width of Peel and 
	                    Stick will overlap the Fastfoot® to ensure all staple holes are properly covered. Then the 
	                    dimple membrane will run down the wall and over the top of the footing, providing complete 
	                    protection to the bottom side and top of the footing.</p><p>Learn more about <a href="/${lang}/${urls.fastFoot.residential.risingDamp}">rising damp and how to prevent it</a>.</p></div>`,
                    image: "/images/projects/swatzky-corp-8.webp"
                },
                {
                    title: "No Concrete Damage",
                    body: `<p>Note this photo: not a drop of concrete on the 2x6s. All will be used to build the house.</p>`,
                    image: "/images/projects/swatzky-corp-9.webp"
                }
            ]
        },
        {
            id: "alan-smith",
            menuItem: {
                en: {
                    title: "Alan Smith",
                    url: "fastfoot-residential/projects/alan-smith",
                    metaTitle: "Alan Smith | Fastfoot® for Perfect Footings in Pottsville, Arkansas",
                    metaDescription: "Alan Smith successfully used Fastfoot® for his walkout basement footings in Pottsville, Arkansas. Learn how Fastfoot® simplified the process and prevented rising damp.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Homeowner builder succeeds with Fastfoot®",
            cardDescription: `Alan Smith uses Fastfoot® to form perfect footings...`,
            cardImage: "/images/alan-smith.webp",
            title: "",
            images: ["/images/projects/alan-smith-1.webp"],
            videos: [],
            articles: [
                {
                    title: "Alan Smith - Homeowner/Builder",
                    body: `<div><p>Alan Smith recently formed and poured perfect footings for his walkout basement in 
                        Pottsville, Arkansas. His comments after using Fastfoot® for the first time:</p><p><em>Everything 
                        worked great! I’ve recommended the fabric to several guys at work that are also planning to 
                        build their own homes.</em></p></div>`,
                    image: "/images/projects/alan-smith-2.webp"
                },
                {
                    title: "Running Utilities Through Footing",
                    body: `<p>Alan slit the fabric vertically and pushed the two PVC pipes through. Simple and fast.</p>`,
                    image: "/images/projects/alan-smith-3.webp"
                },
                {
                    title: "Rebar Placement",
                    body: `<div>
                        <p>Alan used plastic rebar chairs to hold the steel off the fabric. As the concrete is not in 
                        contact with the ground, rebar clearance can be reduced to that required with a normal form.</p>

                        <p>Fastfoot® has the added benefit of preventing ground moisture from wicking up into the 
                        concrete—thereby providing a dry and healthy indoor environment for the Smith Family.</p>

                        <p>Learn more about <a href="/${lang}/${urls.fastFoot.residential.risingDamp}">rising damp and moisture protection</a>.</p>
                    </div>`,
                    image: "/images/projects/alan-smith-4.webp"
                }
            ]
        },
        {
            id: "dominion-ocean-view",
            menuItem: {
                en: {
                    title: "Dominion Ocean View",
                    url: "fastfoot-residential/projects/dominion-ocean-view",
                    metaTitle: "Dominion Ocean View | Fastfoot® for Grade Beams and Waterfront Homes",
                    metaDescription: "Discover how Dominion Building Group uses Fastfoot® to form grade beams and footings for waterfront homes in Virginia Beach, ensuring moisture protection and efficient construction.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Grade Beams in Virginia Beach",
            cardDescription: `The Dominion Building Group uses Fastfoot® to form grade beams for waterfront homes...`,
            cardImage: "/images/dominion.webp",
            title: "",
            images: ["/images/projects/dominion-1.webp"],
            videos: [],
            articles: [
                {
                    title: "Dominion Building Group",
                    body: `<div><p>The <a rel="noreferrer" href="https://www.dominionbuildinggroup.com/" onclick="window.open(this.href,'_blank');return false;">Dominion Building Group</a> 
                        has been using Fastfoot® to form footers and grade beams since 2003. President Reid Pocock is a 
                        strong believer in fabric. <em>"Why would we cut up plywood sheets if we can use lightweight 
                        fabric? Furthermore Fastfoot® prevents ground moisture from wicking up through the sand and 
                        entering the grade beam. This is a must for quality construction and a dry and healthy indoor 
                        environment."</em></p><p>In the photo to the right, the grade beam steel and concrete will 
	                    transfer building loads to the wooden piles located under the beam as the sand surface does not 
	                    provide sufficient load bearing capacity.</p></div>`,
                    image: "/images/projects/dominion-2.webp"
                },
                {
                    title: "Reinforcing steel",
                    body: `<p>Some areas of the beam are supported by three piles. The formwork creates a triangular 
                        shape to transmit the structural loads to the three piles.</p>`,
                    image: "/images/projects/dominion-3.webp"
                },
                {
                    title: "Reinforcing steel",
                    body: `<p>The distance between these two pile pockets is about 16'. A large amount of steel 
                        reinforcing is required to provide sufficient strength in the concrete beam.</p>`,
                    image: "/images/projects/dominion-4.webp"
                },
                {
                    title: "Pile pockets",
                    body: `<p>On this project, some of the pockets were very deep at 4'-6". Fastfoot® had no problem 
                        forming this depth.</p>`,
                    image: "/images/projects/dominion-5.webp"
                },
                {
                    title: "Placing concrete",
                    body: `<p>Formwork was filled by chuting off the back of the ready mix trucks.</p>`,
                    image: "/images/projects/dominion-6.webp"
                },
                {
                    title: "Backfilling",
                    body: `<div>
                        <p>Dominion Building Group takes care to ensure the Fastfoot® membrane stays in place to 
                        prevent rising damp in the sand from entering the concrete grade beam.</p>

                        <p>Learn more about <a href="/${lang}/${urls.fastFoot.residential.risingDamp}">rising damp and how Fastfoot® prevents it</a>.</p>
                    </div>
                    `,
                    image: "/images/projects/dominion-7.webp"
                },
                {
                    title: "Gradebeam Complete",
                    body: `<p>The foundation and backfilling is now complete, ready for the construction of the 
                        superstructure.</p>`,
                    image: "/images/projects/dominion-8.webp"
                }
            ]
        },
        {
            id: "tomsBackhoe",
            menuItem: {
                en: {
                    title: "Tom's Backhoe",
                    url: "fastfoot-residential/projects/tom-backhoe",
                    metaTitle: "Tom's Backhoe | Sustainable Fabric Formwork for Slabs and Columns in Haiku, Maui",
                    metaDescription: "Gabe Hoeffken of Tom's Backhoe uses Fastfoot® for slab edges and Fast-Tube™ for columns in Haiku, Maui. Learn how they implemented sustainable fabric formwork in their project.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Sustainable Fabric Formwork",
            cardDescription: `Slab edges and columns, all formed with fabric...`,
            cardImage: "/images/toms-backhoe.webp",
            title: "Sustainable Fabric Formwork in Haiku Maui, HI",
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/Mhi6kN-FPJM",
                    title: "Sustainable Fabric Formwork"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<div><p>Gabe Hoeffken, Vice-President of Tom's Backhoe & Excavation, recently used Fastfoot® to edge 
                    form his slab, Fast-Tube™ to form his concrete columns, and 
                    <a href="/${lang}/${urls.zontBracing.tomBackhoe}">Zont™ bracing</a> for his Logix® ICF walls.</p>
                    <p><em>"We really liked using Fastfoot® for the edging"</em>, said Gabe. <em>"The fabric prevented concrete 
                    damage to the lumber so we were able to use it for the rest of our build. And it was a lot less expensive to 
                    use Fastfoot® and the single 2x6 than plywood reinforced with 2x4s."</em></p><p>We thank Gabe for the great 
                    photos and video on stripping the Fast-Tube™.</p></div>`,
                    image: ""
                }
            ]
        },
        {
            id: "muskoka",
            menuItem: {
                en: {
                    title: "Muskoka",
                    url: "fastfoot-residential/projects/muskoka",
                    metaTitle: "Muskoka Sustainable Builders | Green Footings for a 19' High Rammed Earth Structure",
                    metaDescription: "Muskoka Sustainable Builders use Fastfoot® to form green footings for a 19' high rammed earth structure in Ontario. Learn about their sustainable construction techniques.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Footings for 19' High Rammed Earth Structure",
            cardDescription: `Muskoka Sustainable Builders use Fastfoot®...`,
            cardImage: "/images/muskoka.webp",
            title: "Sustainable Footings for a 19' High Rammed Earth Structure",
            images: ["/images/projects/muskoka-1.webp"],
            videos: [],
            articles: [
                {
                    title: "",
                    body: `<div><p><a rel="noreferrer" href="https://www.muskokaSustainableBuilders.ca" onclick="window.open(this.href,'_blank');return false;">Muskoka Sustainable Builders Inc.</a> 
                    is a general contracting company based near Huntsville, Ontario, specializing in rammed earth construction. 
                    <em>"Our goal is to guide clients through the entire construction process so they end up with the most 
                    efficient and healthy home possible"</em>, said Mark Allen, principal. <em>"While many contractors 
                    supply and install 'green' products to their clients, this often leads to a home with lots of green 
                    credentials, but not a very sustainable or efficient home."</em></p><p>Both Mark and partner James 
                    Blackman have backgrounds in mechanical engineering: <em>"We are uniquely positioned to evaluate the 
                    entire home as a living system to ensure everything comes together to create the best possible living 
                    space. While there a lot of advanced active technologies that can be employed in a modern home, 
                    we believe in passive techniques that keep things simple and affordable."</em></p></div>`,    
                    image: ""
                },
                {
                    title: "Siting of the Building",
                    body: `<div><p>Making a building sustainable means choosing a site and orienting the building so sunlight 
                        can passively heat the structure.</p><p>High levels of insulation with minimal thermal bridging 
                        and air infiltration, combined with a good mechanical ventilation system ensure the home's energy 
                        needs are minimal.</p></div>`,
                    image: "/images/projects/muskoka-2.webp"
                },
                {
                    title: "Installation of Drainage layer",
                    body: `<div><p>The drainage layer under the footing is critical to ensure liquid water is kept away from 
                        the footing concrete.</p><p>This is especially important with rammed earth walls as the aggregate 
                        particle size induces wicking of ground moisture.</p></div>`,
                    image: "/images/projects/muskoka-3.webp"
                },
                {
                    title: "Setup Screed Boards",
                    body: `<div><p>Footing size for the two storey rammed earth walls is 12" deep by 36" wide. Pairs of 
                        expensive 2x12s would typically be used to form footers of this size. However, with Fastfoot®, 
                        2x4s are used as the screed board with the fabric membrane forming the rest.</p><p>Pairs of 
                        stakes are driven into the ground 6' on center, with spacing between the pair equal to the 
                        footing width. Sharpened 2x2s were used for stakes as the ground was quite solid.</p></div>`,
                    image: "/images/projects/muskoka-4.webp"
                },
                {
                    title: "Screed Board Frame for Steps",
                    body: `<div><p>Normally steps are formed with plywood, scribbed to fit the bank.</p><p>With Fastfoot®, 
                        light weight 2x4 frames are set up to support the fabric as shown in the left and top of this photo. </p></div>`,
                    image: "/images/projects/muskoka-5.webp"
                },
                {
                    title: "Installing Fastfoot®",
                    body: `<div><p>Fastfoot® is installed using a hammer tacker with 3/8" staples, about 8" on centre.</p>
                        <p>Note the building inspector and her assistant walking the left footing, carefully inspecting 
                        to ensure the fabric has been installed correctly. These youthful inspectors are very, very 
                        fussy about <a href="/${lang}/${urls.fastFoot.residential.risingDamp}">rising damp</a>.</p></div>`,
                    image: "/images/projects/muskoka-6.webp"
                },
                {
                    title: "Installing Steel Reinforcing",
                    body: `<div><p>Three 15mm horizontal bars are required in the footings, with 15mm cross members 24" on 
                        center. The steel is then hung using 1x4 cleats.</p><p>Footing steel is important given the 
                        signicant loads from the rammed earth walls above.</p></div>`,
                    image: "/images/projects/muskoka-7.webp"
                },
                {
                    title: "Step Bulkheads Installed",
                    body: `<p>3/4" plywood was used for bulkheads on the six footing steps.</p>`,
                    image: "/images/projects/muskoka-8.webp"
                },
                {
                    title: "Overview of Footing Forms",
                    body: `<div><p>The quality of a building contractor can always be measured by the organization and 
                        neatness of the jobsite.</p><p>It would be hard to find another jobsite organized as well as 
                        this one...</p></div>`,
                    image: "/images/projects/muskoka-9.webp"
                },
                {
                    title: "Placing Concrete",
                    body: `<p>James began placing the concrete starting with the lower steps to plug openings between 
                        the steps. Then the horizontal footings were filled. A boom pump was used for concrete placement.</p>`,
                    image: "/images/projects/muskoka-10.webp"
                },
                {
                    title: "Consolidating Concrete",
                    body: `<p>Mark assists concrete consolidation with his rake handle. Or a kick with the boot does equally well.</p>`,
                    image: "/images/projects/muskoka-11.webp"
                },
                {
                    title: "Footing Pour Complete",
                    body: `<div><p>Cleats will be removed shortly to receive the rammed earth formwork. Screedboards and 
                        stakes are left in place to protect the footing membrane from site damage.</p><p>Notice that 
                        there are no rebar hooks coming out of the footing. "We epoxy rebar into the footing after the 
                        formwork is up so it's out of the way during construction of the rammed earth walls," said James.</p></div>`,
                    image: "/images/projects/muskoka-12.webp"
                },
                {
                    title: "Sourcing Aggregate for Rammed Earth Walls",
                    body: `<p>Rammed earth walls are only as good as the quality of the aggregate and cement mixture. 
                        As well the color of the finished wall is determined by aggregate choice.</p>`,
                    image: "/images/projects/muskoka-13.webp"
                },
                {
                    title: "Two Story Rammed Earth Walls",
                    body: `<div><p>Note the robust formwork used to form the two story 19' high rammed earth walls.</p>
                        <p>The beautiful colors in the horizontal layers of earth aggregate are one of the selling 
                        features of rammed earth buildings.</p><p>The floor joist system will be hung from the walls by 
                        drilling and epoxying into the rammed earth.</p></div>`,
                    image: "/images/projects/muskoka-14.webp"
                },
                {
                    title: "Stripping Formwork",
                    body: `<div><p>Rammed earth formwork is completed in sections, and moved progressively around the perimeter.</p>
                        <p>This photo shows the removal of the straight section of formwork on the far side.</p></div>`,
                    image: "/images/projects/muskoka-15.webp"
                },
                {
                    title: "Thermal Break in Rammed Earth Walls",
                    body: `<div><p>Muskoka Sustainable Builders place a 6" layer of insulation between the two 6" layers of 
                        rammed earth to provide a thermal break. Total wall thickness is 18".</p><p>James explains the 
                        structural integrity of the three layers, <em>"The end panels of the formwork holds the 
                        insulation in a grove. As for the through ties we use rebar "z" hooked on the vertical rebar at 
                        the very top and bottom of the wall and a structural plastic geo-grid every 2' the rest of the 
                        way up the wall to reduce thermal bridging."</em></p></div>`,
                    image: "/images/projects/muskoka-16.webp"
                },
                {
                    title: "Rammed Earth Interior Finish",
                    body: `<div>
                    <p>Beauty is in the detail, such as this indent around each electrical outlet.</p>
                    <p>Learn more about <a rel="noreferrer" href="https://www.muskokasustainablebuilders.ca" onclick="window.open(this.href,'_blank');return false;">Muskoka Sustainable Builders</a>.</p>
                    </div>`,
                    image: "/images/projects/muskoka-17.webp"
                }
            ]
        },
        {
            id: "jeff-struther",
            menuItem: {
                en: {
                    title: "Jeff Struthers",
                    url: "fastfoot-residential/projects/jeff-struthers",
                    metaTitle: "Jeff Struthers | Fastfoot® for Uneven Ground on Orcas Island, WA",
                    metaDescription: "Jeff Struthers used Fastfoot® to form footings on a challenging site with an 18' height difference. Learn how Fastfoot® adapted to uneven ground for this unique project on Orcas Island.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Fastfoot® adapts to uneven ground",
            cardDescription: `Jeff Struthers' project had 18' of height difference...`,
            cardImage: "/images/jeff-struthers.webp",
            title: "FASTFOOT® - Perfect for uneven ground",
            images: ["/images/projects/jeff-struthers-1.webp"],
            videos: [],
            articles: [
                {
                    title: "",
                    body: `<p>Jeff Struthers, an engineer and retired technology finance executive, formed and poured the 
                    footings for his home on Orcas Island, WA. The home's unique location on the rocky eastern cliffs has 
                    an 18' grade change from front to back of the building footprint. There were eighteen steps in total with 
                    the largest over 7' in height. No problem with Fastfoot®.</p>`,                    image: ""
                },
                {
                    title: "Challenging Site",
                    body: `<div><p>Jeff paid great attention to ensure the building conformed harmoniously to the site, 
	                    spending many days with his transit, measuring grade changes, to determine the size, shape and 
	                    location of the structure.</p><p><em>"I believe it is very important to marry the project to the 
	                    site"</em>, said Jeff. <em>"This can't be done sitting in an office."</em></p><p>Jeff designed 
	                    the home with a central octagon core containing the kitchen and living areas, and two wings - 
	                    the bedroom in the north, and the utilities in the south. The two-level home contains 1700 square 
	                    feet on the upper level, with 500 square feet below.</p></div>`,
                    image: "/images/projects/jeff-struthers-2.webp"
                },
                {
                    title: "Excavation",
                    body: `<p>Fourteen trees were removed from the building footprint, including an old growth fir which 
                        was milled locally for finishing materials inside the home. A backhoe excavator removed 
                        the overburden from the rock.</p>`,
                    image: "/images/projects/jeff-struthers-3.webp"
                },
                {
                    title: "Steps",
                    body: `<div><p>With Fastfoot®, steps are vertical footings. 2x4s are run vertically from the lower 
                        footing screed boards to the upper. And bracing is installed to withstand concrete pressures 
                        against the vertical plywood bulkhead.</p><p><em>"You can imagine how much plywood we would 
                        have used trying to form up against the rock for these steps. Just consider the weight, and all 
                        the oil on the plywood... with Fastfoot®, you leave it in place - no waste", </em>said Jeff.</p>
                        <h2>Steel Reinforcing</h2><p>#4 rebar was used throughout the footings, with five horizontals 
			            spaced 6" on center. Cross members and verts were 12" on center. 
		                <em>"I placed over one mile of steel in the footings"</em>, said Jeff.</p></div>`,
                    image: "/images/projects/jeff-struthers-4.webp"
                },
                {
                    title: "Pouring Concrete",
                    body: `<div><p><em>"The concrete pour went wonderfully, including the Fastbags®"</em>, said Jeff. 
			            <em>"My only regret is that we didn't use Fast-Tube™ to form the columns. We had great difficulty 
			            positioning cardboard tubes. With Fast-Tube™, it would have been easy to brace the vertical 2x4s."
			            </em></p><p>47 cubic yards of concrete were placed by Loren Ray and his crew.</p></div>`,
                    image: "/images/projects/jeff-struthers-5.webp"
                }
            ]
        },
        {
            id: "benchland",
            menuItem: {
                en: {
                    title: "Benchland Homes",
                    url: "fastfoot-residential/projects/benchland-homes",
                    metaTitle: "Benchland Homes | Green Builder Uses Fastfoot® for Complex Footings in Calgary",
                    metaDescription: "Benchland Homes in Calgary uses Fastfoot® to form complex footings for their green custom homes, minimizing material use and providing protection from moisture.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Green Builder uses Fastfoot®",
            cardDescription: `Benchland Homes of Calgary Alberta uses Fastfoot® to make project green...`,
            cardImage: "/images/benchland.webp",
            title: "",
            images: ["/images/projects/benchland-1.webp"],
            videos: [],
            articles: [
                {
                    title: "Green Builder - Benchland Homes",
                    body: `<div><p><a rel="noreferrer" href="https://www.benchlandhomes.com" onclick="window.open(this.href,'_blank');return false;">Benchland Homes</a> is a green 
                        custom home builder located in Calgary Alberta, and a member of BuildGreen Alberta and the 
                        Canadian Home Builder's Association.</p><p>As can be seen on the photo to the right, the 
                        excavation was poorly done. Conforming to the uneven grade was a breeze with Fastfoot®. 
                        President Matt Dempster comments:</p><p><em>"The pour went really well, especially for being my 
                        first Fastfoot® project and being a fairly complex footing. The excavation was poorly done as 
                        well to further complicate things."</em></p><p><em>"One thing I found out is that because of 
                        the non permeable membrane under the footing we didn't have to use sulfate resistant concrete. 
                        Sulfates have been causing problems around here apparently. I'm not sure of the cost difference, 
                        but I think it saved us money on the concrete. Thanks again", </em>Matt Dempster<em>.</em></p></div>`,
                    image: "/images/projects/benchland-2.webp"
                },
                {
                    title: "Complex Footing",
                    body: `<p>With multiple footing widths due to point loading, many jogs in the foundation wall, and 
                        an uneven excavation, Fastfoot® performed perfectly.</p>`,
                    image: "/images/projects/benchland-3.webp"
                },
                {
                    title: "Placing Concrete",
                    body: `<p>With multiple footing widths due to point loading, many jogs in the foundation wall, and 
                        an uneven excavation, Fastfoot® performed perfectly.</p>`,
                    image: "/images/projects/benchland-4.webp"
                }
            ]
        },
        {
            id: "ron-budgell",
            menuItem: {
                en: {
                    title: "Ron Budgell",
                    url: "fastfoot-residential/projects/ron-budgell",
                    metaTitle: "Ron Budgell | Fastfoot® for Cost-Effective Footing Forms in Prospect Bay, NS",
                    metaDescription: "Ron Budgell used Fastfoot® to form cost-effective footings for his custom home in Prospect Bay, NS, reducing material waste and ensuring precise footing formation.",
                }
            },
            category: "fastFootForms",
            cardTitle: "Fastfoot® uses minimal lumber",
            cardDescription: `<em>"Nobody builds flimsey like I do"</em>, said Ron Budgell, a builder in Prospect Bay, NS.`,
            cardImage: "/images/ron-budgell.webp",
            title: `FASTFOOT® - "Nobody builds flimsey like I do"`,
            images: ["/images/projects/ron-budgell-1.webp"],
            videos: [],
            articles: [
                {
                    title: "",
                    body: `<div><p>Ron Budgell, an experienced builder in Prospect Bay, Nova Scotia, has been building and renovating 
                    since 1980. His first ICF project was in 1995, a radical construction method at the time.</p><p>This was 
                    Ron's first footing formed&nbsp; with Fastfoot® and he was pleased because it enhanced his reputation of 
                    <span>"Nobody builds flimsy like I do!"</span>The project was 3,000 square feet on two floors.</p>
                    <p>The following pictures and were taken from the 
                    <a rel="noreferrer" href="https://www.finehomebuilding.com" onclick="window.open(this.href,'_blank');return false;">Fine Home Building</a> blog (no longer online) 
                    and was written by Ron Budgell.</p></div>`,
                    image: ""
                },
                {
                    title: "Ron Budgell's Fine Homebuilding Blog",
                    body: `<div><p>Hi everyone.... I started a new ICF house last week. The architect told me he had recently 
                        seen a new product which looked interesting - fabric forms for footings.</p><p>My initial 
                        reaction was that that was ridiculous, but when I thought about how I am perfectly happy to pour 
                        11 or 12 feet of concrete into forms made of foam, it no longer seemed quite so silly.</p>
                        <p>They have some very interesting ideas. I don't own lumber suitable for footing forms at this 
                        point. I would have had to buy about 500' of rough 2 x 10 for this job, costing over $1000. 
                        Most of that could be salvaged, of course, but some would be consumed and not reusable. Anyway, 
                        I don't want to have to carry all that stuff around or store it.</p><p>The fabric form material 
                        to do the same job costs $170 plus material for stakes and stringers. The 2 x 4 stringers are 
                        almost all reusable. I would have used the stakes anyway. Here's what a framework for a fabric 
                        form looks like...</p></div>`,
                    image: "/images/projects/ron-budgell-2.webp"
                },
                {
                    title: "",
                    body: `<div><p>We built the outer rim first. leveling with a transit and an autolevel. Then we built the 
                        inner rim, leveling from the outer with an ordinary spirit level.</p><p>We had a variation in 
                        depth in the excavation of almost 10", requiring a very deep footing at the deepest point.</p></div>`,
                    image: "/images/projects/ron-budgell-3.webp"
                },
                {
                    title: "",
                    body: `<p>We had a variation in depth in the excavation of almost 10", requiring a very deep 
                        footing at the deepest point</p>`,
                    image: "/images/projects/ron-budgell-4.webp"
                },
                {
                    title: "",
                    body: `<div><p>So here's the footing form material, two rolls of 120' each. We unrolled this and simply 
                        stapled it to the top of the light framework. It's a little slack in the framework so it can 
                        bulge some when full of concrete.</p><p>Going around corners, the material is folded as neatly 
                        as possible, not cut. Think Christmas present corners.</p></div>`,
                    image: "/images/projects/ron-budgell-5.webp"
                },
                {
                    title: "",
                    body: `<div><p>The straight run of formwork is amazingly easy and fast, but at this point, I'm looking 
                        at the depth we have to pour and beginning to get worried...</p><p>But there is plenty to do to 
                        take my mind of what I disaster I might be getting myself into. I have to build footing steps. 
                        I hate building footing steps. </p><p>It can be fun in an odd way to scribe form material to the 
                        dirt though an inch or so here or there is of no account.</p></div>`,
                    image: "/images/projects/ron-budgell-6.webp"
                },
                {
                    title: "",
                    body: `<div><p>So here it is, almost ready to pour. The steel is in it, the cross ties are installed, 
			            we've checked levels, we've located corners for later placement of vertical steel bar.</p>
			            <p>I suppose the only thing not ready when I took this shot, last Thursday, was my head.</p></div>`,
                    image: "/images/projects/ron-budgell-7.webp"
                },
                {
                    title: "",
                    body: `<div><p>We poured late Friday morning in the rain. I was guiding the dirty end of the pump, 
			            wound up like a tight spring, watching for something to burst. Nothing even creaked! I managed to relax, 
			            as much as I can when pouring, and begin to treat this like just another job. As far as I know right 
			            now, it was a flawless pour.</p><p>On Monday, we'll take the forms apart and check levels again. 
			            Something might have moved when the concrete went into the forms, but I didn't see much movement. 
			            I might even go over there tomorrow and see how it turned out.</p><p>So here's what it looks like full of mud.</p></div>`,
                    image: "/images/projects/ron-budgell-8.webp"
                },
                {
                    title: "",
                    body: `<p>I like this Fastfoot. Do more with less material.</p>`,
                    image: "/images/projects/ron-budgell-9.webp"
                },
                {
                    title: "",
                    body: `<p>I'm not looking for pretty. I'm looking for vertical variation of no more than 1/8" 
			            from perfect. Once or twice I've gotten lucky and actually achieved that.</p>`,
                    image: "/images/projects/ron-budgell-10.webp"
                }
            ]
        },
        {
            id: "tru-frame",
            menuItem: {
                en: {
                    title: "Tru Frame",
                    url: "fastfoot-commercial/projects/tru-frame",
                    metaTitle: "Tru Frame | Complex Grade Beam Forming with Fastfoot®",
                    metaDescription: "Tru Frame Construction in Battle Ground, WA used Fastfoot® for a complex grade beam project, saving time and material while ensuring easy concrete finishing and precise steel placement.",
                }
            },
            category: "fastFootCom",
            cardTitle: "Complex Grade Beam",
            cardDescription: `Using Fastfoot® for complex footings saves time and material...`,
            cardImage: "/images/fastfoot-commercial-projects-tru-frame.webp",
            title: `TruFrame Construction`,
            body: `<p>Calvin Vader, principal of TruFrame, recently used Fastfoot for the first time in Battle Ground, WA.</p>`,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/fxMl-mQ6-MY",
                    title: "Fastfoot® Commercial Concrete Footing Form - Tru Frame Construction Grade Beam",
                    splashScreen: "/images/tru-frame-construction-grade-beam-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<div>`,
                    image: "/images/projects/tru-frame-1.webp"
                },
                {
                    title: "",
                    body: `<p>As the top of the framework is the top of the grade beam, screeding the concrete to the 
                        correct level is a breeze. As well, the positioning of steel templates for the anchor bolts is 
                        very easy to achieve. The contractor has suspended the 1/4" steel template using two 2x4s 
                        supported by the top rail.</p>`,
                    image: "/images/projects/tru-frame-2.webp"
                },
                {
                    title: "",
                    body: `<p>The contractor supported the rebar hooks by tying with rebar wire to a 2x4 supported by 
                        another 2x4 running between the two side rails. This made it easy to finish the concrete.</p>`,
                    image: "/images/projects/tru-frame-3.webp"
                },
                {
                    title: "",
                    body: `<p>This point load pad measuring 8' x 8' x 2' is formed with a simple framework - just two 
                        2x4 rails: one at the top and one 2/3rds of the way down. The hydraulic loads from the bottom 
                        of the pad are taken with Fastfoot - this means the lateral loads on the forms are considerably 
                        less than when using plywood.</p>`,
                    image: "/images/projects/tru-frame-4.webp"
                },
                {
                    title: "",
                    body: `<p>This point load pad measuring 8' x 8' x 2-8:' is formed with a simple framework - just 
                        three 2x4 rails: one at the top, one half way down and one abut 8" off the ground. The hydraulic 
                        loads from the bottom of the pad are taken with Fastfoot - this means the lateral loads on the 
                        forms are considerably less than when using plywood. The first lift of 16" of concrete is just 
                        been vibrated.</p>`,
                    image: "/images/projects/tru-frame-5.webp"
                },
                {
                    title: "",
                    body: `<p>Running utilities through the formwork can not be simpler - use a utility knife to cut a 
                        hole in Fastfoot and run the pipe through. Try that with plywood.</p>`,
                    image: "/images/projects/tru-frame-6.webp"
                },
                {
                    title: "",
                    body: `<p>Screeding the concrete is complete. Notice how simple the lateral bracing is - a few 2x4s 
                        to the ground suffices. Also the 2x4 cleats take lateral loads as well. None of this is possible 
                        with plywood forms.</p>`,
                    image: "/images/projects/tru-frame-7.webp"
                }
            ]
        },
        {
            id: "corWorks",
            menuItem: {
                en: {
                    title: "Cor-Works",
                    url: "fastfoot-commercial/projects/cor-works",
                    metaTitle: "Cor-Works Ltd. | Efficient Footing Forms for Point Loads",
                    metaDescription: "Cor-Works Ltd. used Fastfoot® for efficient grade beam formation with point loads, reducing material waste and installation time on commercial concrete projects in Calgary, Alberta.",
                }
            },
            category: "fastFootCom",
            cardTitle: "Footings with Point Loads",
            cardDescription: `Using Fastfoot® for grade beams saves time and material...`,
            cardImage: "/images/fastfoot-commercial-projects-cor-works.webp",
            title: `Cor-Works Ltd.`,
            body: `<p><a rel="noreferrer" href="https://www.cor-works.com/" onclick="window.open(this.href,'_blank');return false;">Cor-Works Ltd.</a> is a commercial concrete company 
			located south of Calgary Alberta servicing south western Alberta. Owner Chad Steward is a big advocate of 
			building green. "Cutting up 4 x 8' sheets of plywood is not good for the environment or the back".</p>`,
            images: ["/images/projects/cor-works-1.webp"],
            videos: [],
            articles: [
                {
                    title: "",
                    body: `<p>The contractor has set up 2x6 screed boards around the perimeter of the footing and used 
                        2x4 stakes to hold the screeds at the correct height. Deeper pads and footings use a second 2x4 
                        to reduce the fabric bulge and concrete induced tension. The fabric is attached to the top rail 
                        using 3/8" staples and a hammer tacker. The bottom edge is held by the friction between the 
                        fabric and the ground below caused by the concrete pressure.</p>`,
                    image: "/images/projects/cor-works-2.webp"
                },
                {
                    title: "",
                    body: `<p>Loads from the foundations walls are quite high and the structural engineer has requested 
                        a considerable amount of steel to withstand the loads.</p>`,
                    image: "/images/projects/cor-works-3.webp"
                },
                {
                    title: "",
                    body: `<p>Some of the steel cages were quite complex and were manufactured off site. Here the steel 
                        cages are being lifted into the forms.</p>`,
                    image: "/images/projects/cor-works-4.webp"
                },
                {
                    title: "",
                    body: `<p>Forms are complete, Fastfoot installed, rebar in place. Ready for concrete.</p>`,
                    image: "/images/projects/cor-works-5.webp"
                },
                {
                    title: "",
                    body: `<p>Concrete pour has just begun. The concrete was placed in two 16" lifts to reduce form pressure.</p>`,
                    image: "/images/projects/cor-works-6.webp"
                },
                {
                    title: "",
                    body: `<p>The fabric held up perfectly during the pour including vibration. Fastfoot makes stripping 
                        a breeze as there is no concrete damage to lumber.</p>`,
                    image: "/images/projects/cor-works-7.webp"
                }
            ]
        },
        {
            id: "forceConcreteRutgers",
            
            menuItem: {
                en: {
                    title: "Force Concrete Rutgers",
                    url: "fastfoot-commercial/projects/force-concrete-rutgers",
                    metaTitle: "Force Concrete | Commercial Footings for Rutgers Center",
                    metaDescription: "Force Concrete & Masonry Corporation used Fastfoot® for forming footings and pads for the RWJ Barnabas Health Center, supporting massive structural loads efficiently.",
                }
            },
            category: "fastFootCom",
            cardTitle: "Footings for Rutgers Center",
            cardDescription: `Fastfoot® for commercial footings saves time and material...`,
            cardImage: "/images/fastfoot-commercial-projects-rutgers.webp",
            title: `Force Concrete and Masonry Corporation`,
            body: `<p><a rel="noreferrer" href="https://www.forceconcretemasonrycorp.com/" onclick="window.open(this.href,'_blank');return false;">Force Concrete</a> of 
                Piscataway, NJ has been providing concrete and masonry services since 2002. The photo above shows the finished 
                3D model of the RWJ Barnabas Health Center, where Force Concrete completed all the concrete work.</p>

                <p>The center will be home to men’s and women’s basketball, gymnastics, and wrestling. The facility 
                will feature state-of-the-art locker rooms, practice venues, strength-training and sports medicine suites, 
                coaches’ offices, and meeting rooms. The project will also include a four-story parking structure. 
                Visit the <a rel="noreferrer" href="https://www.rutgersbigtenbuild.com/multisport-training-complex/index.html">RWJ Barnabas Health Center website</a> for more details.</p>

                <p>See another project where Force Concrete used Fastfoot®: 
                <a href="/en/${urls.fastFoot.commercial.greenLantern}">the Green Lantern project</a>.</p>`,
            images: ["/images/projects/force-concrete-1.webp"],
            videos: [],
            articles: [
                {
                    title: "",
                    body: `<p>This photo provides an overview of the foundation, showing the multiple point load pads 
                        and strip footings, all formed with the lumber framework lined with Fastfoot.</p>`,
                    image: "/images/projects/force-concrete-2.webp"
                },
                {
                    title: "",
                    body: `<p>Steps are easily accommodated with Fastfoot as shown in the photo above. The ground was so 
                        hard that the contractor drove electrical conduit into the ground and screwed the conduit to the 
                        screed board.</p>`,
                    image: "/images/projects/force-concrete-3.webp"
                },
                {
                    title: "",
                    body: `<div><p>This pad is about 30" deep and is easily framed with a single 2x6 on top with a second 2x4 
                        rail 2/3rds of the distance between the top rail and the ground. Most of the lower concrete 
                        loads are taken by the friction between the fabric and the ground below. Very efficient 
			            formwork.</p><p>The contractor has used plumbing tape to reinforce the corners of the rails. 
			            Fastfoot easily supports the additional loads induced by the vibration of the concrete.</p>
                        <p>Notice that the contractor was not able to drive the 2x4s into the ground - so he drove the 
                        electrical conduit into the ground and screwed the conduit to the 2x4 "stake".</p></div>`,
                    image: "/images/projects/force-concrete-4.webp"
                },
                {
                    title: "",
                    body: `<p>Concrete pour is complete. Notice how clean the site is - no concrete leaking out of the 
                        bottom of the forms.</p>`,
                    image: "/images/projects/force-concrete-5.webp"
                },
                {
                    title: "",
                    body: `<div><p>Complex footing and pad layouts are easily accommodated with the lightweight framework 
                        lined with Fastfoot. No need for leveling strips inside plywood forms and no need for expensive 
                        form plywood.</p><p>All lumber is protected from concrete damage by Fastfoot.</p></div>`,
                    image: "/images/projects/force-concrete-6.webp"
                }
            ]
        },
        {
            id: "ramGraceRoad",
            menuItem: {
                en: {
                    title: "Ram Construction",
                    url: "fastfoot-commercial/projects/ram-construction",
                    metaTitle: "Ram Construction | Fastfoot® for Commercial Grade Beams",
                    metaDescription: `Ram Construction used Fastfoot® to form a 18" x 36" grade beam for Fedex's Western Canada Distribution Center, reducing material and labor costs while ensuring precision.`,
                }
            },
            category: "fastFootCom",
            cardTitle: "Grade Beam with Fastfoot®",
            cardDescription: `Forming an 18" x 36" grade beam with Fastfoot® - compare this with 2x12s...`,
            cardImage: "/images/fastfoot-commercial-projects-ram-grace-road.webp",
            title: `Ram Construction uses Fastfoot® for Commercial Grade Beam`,
            body: ``,
            images: ["/images/projects/ram-construction-1.webp"],
            videos: [
                {
                    video: "https://www.youtube.com/embed/AzI_CmEavvA",
                    title: "Fastfoot® Commercial Grade Beam Footing",
                    splashScreen: "/images/fastfoot-commercial-grade-beam-footing-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<div>
                        <p>Ram Construction of Surrey, BC recently completed the foundations, slabs and tilt walls for 
                        Fedex's Western Canada Distribution Center.</p>
                        <p><a rel="noreferrer" href="https://www.ramconst.com" onclick="window.open(this.href,'_blank');return false;">Ram Construction Inc.</a>, started in 1986 by 
                        current President Steve Knoblauch, has a long and successful history of building retail, commercial and 
                        institutional buidings in Greater Vancouver, the Fraser Valley, Squamish, the Interior of BC and 
                        Vancouver Island.</p><p>In the picture below the grade beam to support the dock levelers is being 
                        poured.</p>
                    </div>`,
                    image: ""
                },
                {
                    title: "Set up Cribbing",
                    body: `<div><p>Workers used 1x4 stakes, 48" on center, with a 2x4 screed board for the top of the 
                        footing. Grade beam depth was 16 to 20" in height.</p><p>A laser was used to measure the grade 
                        beam height on each stake. Three 2" duplex nails attached each stake to the screed board.</p>
                        <p><em>"We would have required a 2x12 plus a 2x4 to form this"</em>, said Chris Moncton, Site 
                        Supervisor. <em>"With Fastfoot® we eliminated the 2x12 and the cost of moving and storing the 
                        concrete damaged lumber."</em></p></div>`,
                    image: "/images/projects/ram-construction-2.webp"
                },
                {
                    title: "Unroll Fastfoot®",
                    body: `<p>Fastfoot® was quickly unrolled between the screed boards. This single roll of Fastfoot®, 
                        weighing just 14 pounds, replaced 900 pounds of 2x12.</p>`,
                    image: "/images/projects/ram-construction-3.webp"
                },
                {
                    title: "Stapling Fastfoot®",
                    body: `<div><p>Fastfoot® was attached to the screed board using a hammer tacker with 3/8" staples. 
                        Spacing was about 4 to 6" on center.</p><p><em>"Worker safety is important</em>", confirmed 
                        Chris Moncton. <em>"Light weight fabric makes a lot of sense - why risk back injury from heavy 
			            lumber?"</em></p></div>`,
                    image: "/images/projects/ram-construction-4.webp"
                },
                {
                    title: "Attaching 1x4 Cleats",
                    body: `<p>Cleats were attached in line with each pair of stakes to ensure the fabric tension 
			            would not torque the screed board off the stake.</p>`,
                    image: "/images/projects/ram-construction-5.webp"
                },
                {
                    title: "Reinforcing Steel",
                    body: `<p>As the grade beam is bridging between load bearing caissons, there were two levels of 
                        footing steel with stirrups 12" on center. Steel projecting above the grade beam will be 
                        imbedded in a 5' retaining wall above used to support the dock levelers.</p>`,
                    image: "/images/projects/ram-construction-6.webp"
                },
                {
                    title: "Steel Caissons",
                    body: `<div><p>8" and 10" diameter steel caissons were located 15 to 18' on center to support building 
                        loads.</p><p>Fastfoot® was easily slit with a utility knife over each caisson.</p></div>`,
                    image: "/images/projects/ram-construction-7.webp"
                },
                {
                    title: "",
                    body: ``,
                    image: "/images/projects/ram-construction-8.webp"
                }
            ]
        },
        {
            id: "kitimat",
            menuItem: {
                en: {
                    title: "Kitimat Project",
                    url: "fastfoot-commercial/projects/kitimat-project",
                    metaTitle: "Kitimat Project | Western Industrial Contractors Use Fastfoot® for Large Warehouse Foundation",
                    metaDescription: "Western Industrial Contractors used Fastfoot® to form footing pads for a large warehouse expansion project in Kitimat, BC, enhancing efficiency and reducing material costs.",
                }
            },
            category: "fastFootCom",
            cardTitle: "Kitimat Project",
            cardDescription: `Footing pads for a large warehouse project in Kitimat BC by Western Industrial Contractors...`,
            cardImage: "/images/fastfoot-commercial-projecfts-stapling.webp",
            title: `Ram Construction uses Fastfoot® for Commercial Grade Beam`,
            body: `<p>This 140,000 square foot warehouse expansion in Kitimat, BC used Fastfoot® for the footing pads. 
	            The steel structure required 145 footings, with aluminum cladding used for the building envelope.</p>
                <p><a rel="noreferrer" href="https://www.wicltd.com" onclick="window.open(this.href,'_blank');return false;">Western Industrial Contractors (WIC)</a>, one of 
                BC's largest contractors, was responsible for the foundation and steel structure. WIC offers a complete 
                range of construction services, including project evaluation, cost and schedule analysis, evaluation 
	            of construction methods, and manpower and equipment planning. WIC is known for 'design-build' 
	            construction and encourages Site Managers to innovate with cost effective solutions.</p><p>The picture 
	            below shows one of the eight larger footing pads 55'-9' long, 36' wide and 3'-6" deep. These large pads 
	            reflect the high snow loads which occur in this northern city located on the Pacific Ocean. Wind and 
	            seismic loading were also incorporated into the design as shown by the column steel reinforcing 
	            protruding from the pads.</p>`,
            images: ["/images/projects/kitimat-1.webp"],
            videos: [
                {
                    video: "https://www.youtube.com/embed/AzI_CmEavvA",
                    title: "Fastfoot® Commercial Footings - Kitimat",
                    splashScreen: "/images/fastfoot-commercial-footings-kitimat-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "Smaller Pads",
                    body: `<div><p>Workers set up 2x8 screed boards for the 137 smaller pads, each measuring 20' long, 10'-5" 
                    wide and 20" tall. A single top rail was located at the exact height of the footing pad, making 
                    concrete screeding very easy.</p><p>Plywood forms require screeding inside the form, making accurate 
                    finishing more difficult and requiring more labor.</p></div>`,
                    image: "/images/projects/kitimat-2.webp"
                },
                {
                    title: "Compacted Ground",
                    body: `<p><em>"It was impossible to drive 2x4 stakes into the ground"</em>, said Al MacFarlane, WIC 
                        Project Manager. <em>"We first drove steel stakes and then nail attached them to the 2x4 upright."</em></p>`,
                    image: "/images/projects/kitimat-3.webp"
                },
                {
                    title: "Attaching Fastfoot®",
                    body: `<div><p>Fastfoot® is attached to the top of the screed board using a hammer tacker with 3/8" staples. 
			            Installation is fast and clean. A single roll of Fastfoot® weighs 14 pounds and replaces 900 
			            pounds of 3/4" plywood.</p><p><em>"Worker safety is very important to WIC"</em>, confirmed Al 
			            MacFarlane. <em>"Light weight fabric makes a lot of sense - why risk back injury from heavy 
			            plywood?"</em></p></div>`,
                    image: "/images/projects/kitimat-4.webp"
                },
                {
                    title: "Reduction in Lateral Form Pressure",
                    body: `<div><p>Lateral pressures are reduced by up to 50% with Fastfoot® compared to plywood as lateral 
                        pressures in the bottom of the formare taken by the fabric itself. This reduces bracing costs 
                        and installation time.</p><p><em>"We poured in one foot lifts to not exceed the holding 
			            capacity of Fastfoot® - even pads 42" high,"</em> said Al.</p><p>Fabric is folded in corners 
			            similar to wrapping gifts. Fabric slack at the base was minimized to reduce concrete bulging.</p></div>`,
                    image: "/images/projects/kitimat-5.webp"
                },
                {
                    title: "Site Logistics",
                    body: `<div><p>One of the advantages of Fastfoot® is that larger sections of the project can be formed 
                        and poured at the same time without the limitation of plywood inventory.</p><p>The WIC crew 
                        enjoy an unusually dry Kitmat day.</p></div>`,
                    image: "/images/projects/kitimat-6.webp"
                },
                {
                    title: "Reinforcing Steel",
                    body: `<p>Fastfoot® does not affect rebar placement.</p>`,
                    image: "/images/projects/kitimat-7.webp"
                },
                {
                    title: "Stripping",
                    body: `<p>As Fastfoot® is a stay-in-place form, stripping and storage costs are reduced dramatically. 
                        As well the fabric prevents concrete contamination of the screed boards, uprights and steel stakes.</p>`,
                    image: "/images/projects/kitimat-8.webp"
                },
                {
                    title: "After Backfilling",
                    body: `<p>Ready to form and pour columns.</p>`,
                    image: "/images/projects/kitimat-9.webp"
                }
            ]
        },
        {
            id: "solarFarm",
            menuItem: {
                en: {
                    title: "Solar Farm",
                    url: "fastfoot-commercial/projects/solar-farm",
                    metaTitle: "Solar Farm | Fastfoot® for Solar Array Foundation Pads",
                    metaDescription: "Fastfoot® was used to edge form foundation pads for the world's largest solar farm, enhancing efficiency and ensuring structural integrity under extreme conditions.",
                }
            },
            category: "fastFootCom",
            cardTitle: "Largest solar farm uses Fastfoot®",
            cardDescription: `Footing pads for the world's largest rollercoaster...`,
            cardImage: "/images/fastfoot-commercial-projects-obama.webp",
            title: "",
            body: `<p>This photo shows an overview of a portion of the project. The solar arrays were supported by 8" x 
                8" galvanized "I" beams driven from 4' to 8' into the ground. An accumulator station (the white buildings 
                shown in the photo above) were located in the center of each four solar array fields.</p><p>Fastfoot® was 
                used to edge form the foundation pads for each of these accumulator buildings.</p><p><em>"This is the 
                largest solar plant of its kind anywhere in the country"</em>, confirmed President Obama. <em>"We've got 
                to develop new energy technologies and new energy sources - it's the only way forward."</em></p>
                <p><em>"This is the largest solar plant of its kind anywhere in the country"</em>, confirmed President 
                Obama. <em>"We've got to develop new energy technologies and new energy sources - it's the only way 
                forward."</em></p>`,
            images: ["/images/projects/solar-farm-1.webp"],
            videos: [],
            articles: [
                {
                    title: "",
                    body: `<div><p>The contractor in charge of forming and concrete work was 
			            <a rel="noreferrer" href="https://www.tbpenick.com" onclick="window.open(this.href,'_blank');return false;">T.B. Penick & Sons, Inc.</a> Penick has 
			            been in business since 1905, providing general construction, design-build, construction 
			            management, structural concrete and Innovative Concrete Systems.</p><p>This photo shows the 
			            setup of 2x10 screed boards using metal stakes spaced 5' on center. Fastfoot® was stapled to the 
			            top of the 2x10 with the balance placed on the ground. The weight of the concrete on the fabric 
			            provided sufficient resistance to form the concrete in a fast, sustainable and cost effective 
			            manner.</p><p>The "I"-beams to support the solar panels can be seen in the background.</p></div>`,
                    image: "/images/projects/solar-farm-2.webp"
                },
                {
                    title: "",
                    body: `<div><p>This shows the Fastfoot® edging in place with the lower rebar mat installed. Note the 
                        bricks to support the rebar also hold the Fastfoot® in position. Andrew Weber, Senior Project 
                        Engineer with T.B. Penick & Sons, Inc. was impressed with Fastfoot.</p><p><em>"We are 
                        pleased with Fastfoot®"</em>, confirmed Andrew.<em> "This project was on a tight schedule: 
                        installation of Fastfoot was quick with minimal bracing, and we set the height of the screed 
                        board to the exact height of the slab, so concrete finishing was much easier than if we were 
                        finishing inside a plywood form."</em></p></div>`,
                    image: "/images/projects/solar-farm-3.webp"
                },
                {
                    title: "",
                    body: `<div><p>As can be seen from this photo, there were a multiplicity of electrical conduits from the 
			            adjacent four solar panel fields as well as going on the the main station.</p><p>The top mat has 
			            now been installed and the forms are ready for concrete.</p></div>`,
                    image: "/images/projects/solar-farm-4.webp"
                },
                {
                    title: "",
                    body: `<p><em>"We poured the slabs early in the day to avoid the heat and dry air after lunch"</em>, 
                        said Andrew. <em>"Fastfoot, being a vapour barrier, prevented moisture loss	around the perimeter."</em></p>`,
                    image: "/images/projects/solar-farm-5.webp"
                },
                {
                    title: "",
                    body: `<p><em>"Stripping the slab took minutes"</em>, confimed Andrew. <em>"And Fastfoot® protected 
                        the 2x10 screed boards from concrete damage, ready for the next pad."</em></p>`,
                    image: "/images/projects/solar-farm-6.webp"
                }
            ]
        },
        {
            id: "greenLantern",
            menuItem: {
                en: {
                    title: "Green Lantern",
                    url: urls.fastFoot.commercial.greenLantern,
                    metaTitle: "Green Lantern | Fastfoot® Used for Footing Pads for World's Tallest Roller Coaster",
                    metaDescription: "Fastfoot® formed footing pads for Six Flags' Green Lantern roller coaster, providing cost-effective and efficient formwork for massive structural loads in New Jersey.",
                }
            },
            category: "fastFootCom",
            cardTitle: "Green Lantern Project",
            cardDescription: `Footing pads for the world's largest rollercoaster...`,
            cardImage: "/images/fastfoot-commercial-projects-green-lantern.webp",
            title: "Six Flags Green Lantern Roller Coaster uses Fastfoot®",
            body: `<p>The photo above shows the excavation and installation of the footing pads for the Six Flags
	            <a rel="noreferrer" href="https://www.sixflags.com/greatAdventure/footerNav/greenlanternconstruction.aspx" onclick="window.open(this.href,'_blank');return false;">
	            "Green Lantern"</a> project in New Jersey. Standing 154 feet high and reaching speeds of 63 mph, the 
	            roller coaster will rank among the tallest and fastest of its kind anywhere in the world. Unlike 
	            traditional seated coasters, occupants stand throughout the entire course of the ride to deliver a ride 
	            experience unlike any other.</p><p>Structural loads of the rollercoaster are demanding, with upward, 
	            lateral and downward forces from the fast moving cars. Concrete contractor,
	            <a rel="noreferrer" href="https://www.forceconcretemasonrycorp.com" onclick="window.open(this.href,'_blank');return false;">Force Concrete & Masonry 
	            Corporation</a> of Piscataway, New Jersey, chose Fastfoot® to reduce forming costs and eliminate a large 
	            inventory of plywood forms. Site Manager Bill Pavlic said:</p><p><em>"Today we poured our first footings 
	            at Six Flags. Against my judgment I used the Fab-Form for footings 3' 6" tall. Other locations at the 
	            same thickness I used conventional methods, symons forms with a double waler braced back to the bank. 
	            Today we poured a total of 100 cu. yds. into symons form boxes and the other 150 into footings 
	            constructed using your system."</em></p><p>"<em>Never guess what happened... braces against the bank for 
	            the symons form panels let go causing a blow out. Nothing severe but none the less there weren't any 
	            issues with the Fab-Form. Largest footing was 3'-6" X 25' X 25'. The Fab-Form system has been criticized 
	            all week long by others on the jobsite, that problem has been solved after today's results. We began 
	            pouring the largest footing with over a dozen onlookers, including some very important executives from 
	            Six Flags main headquarters and engineers from Birdsall Group. Everyone was impressed. I  will be 
	            ordering more material by the end of the week."</em></p>`,
            images: ["/images/projects/green-lantern-1.webp"],
            videos: [
                {
                    video: "https://www.youtube.com/embed/Tc8z_1Ltvo0",
                    title: "Green Lantern Rollercoaster: FastFoot® Forms",
                    splashScreen: "/images/green-lantern-rollercoaster-fastfoot-forms-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "Overview of Green Lantern Site",
                    body: `<p>This video shows the layout for the new Green Lantern roller coaster.</p>`,
                    image: "/images/projects/green-lantern-2.webp"
                },
                {
                    title: "Screed Boards & Bracing",
                    body: `<div><p>2x8s were used for the screed rail. By locating the top of the screed  
			            located at the exact footing height, screeding of concrete is very easy.</p><p>With plywood, 
			            screeding is done inside the form, making accurate finishing difficult and time consuming.</p></div>`,
                    image: "/images/projects/green-lantern-3.webp"
                },
                {
                    title: "Reduction in Bracing",
                    body: `<p>Lateral pressures are reduced by up to 50% when using fabric as the lateral pressures in 
                        the bottom of the form are turned into downward pressures. This reduces bracing costs and labor 
                        dramatically.</p>`,
                    image: "/images/projects/green-lantern-4.webp"
                },
                {
                    title: "Comparing plywood to Fastfoot®",
                    body: `<div><p>The hydraulic loads from the bottom third of a fabric formed wall is taken by the fabric 
                        itself (the resistance between the fabric and the ground). With plywood these loads must be 
                        taken by the bracing. As a result, lateral pressures are reduced by up to 50% over plywood.</p>
                        <p>In this photo the plywood forms on the right failed. Fastfoot® performed perfectly.</p></div>`,
                    image: "/images/projects/green-lantern-5.webp"
                },
                {
                    title: "Steel Complexity",
                    body: `<p>Transfering the column loads into the footing demands a great deal of steel. Failure is 
                        not an option with roller coasters.</p>`,
                    image: "/images/projects/green-lantern-6.webp"
                },
                {
                    title: `42" Deep Pads`,
                    body: `<p>One of the advantages of Fastfoot® is that larger sections of the project can be formed 
                        and poured at the same time without the limitation of plywood inventory.</p>`,
                    image: "/images/projects/green-lantern-7.webp"
                },
                {
                    title: "Tri-Pad",
                    body: `<p>The final concrete lift is being poured. Note the three columns coming off the pad which 
                        will be supporting a triangular support for the roller coaster track. This pad is 42" deep.</p>`,
                    image: "/images/projects/green-lantern-8.webp"
                },
                {
                    title: "Column Hardware",
                    body: `<div><p>The top of this column has three support templates.</p><p>Note the white expanded 
                        polystyrene blocks under the template to create shear keyways in the concrete.</p></div>`,
                    image: "/images/projects/green-lantern-9.webp"
                }
            ]
        },
        {
            id: "giustiGroup",
            menuItem: {
                en: {
                    title: "Giusti Group",
                    url: "fastfoot-commercial/projects/giusti-group",
                    metaTitle: "Giusti Group | Fastfoot® for Large Condominium Footing Pads in Kelowna, BC",
                    metaDescription: "Giusti Group used Fastfoot® to form 270 footing pads for a large condominium project in Kelowna, BC, streamlining the foundation process with efficient formwork and reducing material costs.",
                }
            },
            category: "fastFootCom",
            cardTitle: "Giusti Group Project",
            cardDescription: `270 footing pads for a large condominium project in Kelowna BC...`,
            cardImage: "/images/fastfoot-commercial-projects-scott.webp",
            title: "Fastfoot® Commercial Pads",
            body: `<p>The <a rel="noreferrer" href="https://www.giustigroup.com" onclick="window.open(this.href,'_blank');return false;">GIUSTI Group</a> of Calgary Alberta 
                formed the foundations, columns and floors for this six story concrete and steel condominium 
	            project in Kelowna, BC. All footing pads for the 285 unit project were formed with Fastfoot®.</p>
	            <p>Over the past 25 years the Giusti Group has built more than 600 custom homes and 35,000 multi-family 
	            units.</p><p>The photo below shows an overview of the site. On the right side can be seen three pads and 
	            columns already poured. The contractor is now setting up the next set of footing pads using Fastfoot®.</p>`,
            images: ["/images/projects/giusti-group-1.webp"],
            videos: [
                {
                    video: "https://www.youtube.com/embed/1niFCnP4bUk",
                    title: "Fastfoot® Commercial Pad Installation",
                    splashScreen: "/images/fastfoot-commercial-pad-installation-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "Geotechnical Complexity",
                    body: `<div><p>The building site was complex for two reasons: first the danger of liquefaction under seismic 
			            shaking; and second, settlement under static loads.</p><p><em>"To eliminate the possibility of 
			            liquefaction, we used vibral compaction and sand columns"</em>, said Randy Hillaby, geotechnical 
			            engineer with Levelton. <em>"We preloaded the site to prevent static settlement."</em></p>
			            <p>As the site was close to Kelowna Lake, with its high water table, dewatering was required to 
			            keep the excavation relatively dry. The large PVC pipe in this photo was used to dewater the sand.</p></div>`,
                    image: "/images/projects/giusti-group-2.webp"
                },
                {
                    title: "Structural Engineering",
                    body: `<div><p>As the remediated soils could only support loads of 2,000 pounds per square foot, large 
                        footing pads were required to transfer the loads of the building into the ground.</p>
                        <p><em>"Our largest pad measured over 15' square, with a depth of 30 inches"</em>, said Brian 
                        Tomecek, Structural Engineer with TRL & Associates Ltd. <em>"Typical steel configuration 
                        was 25 to 30 mm at 300 mm on center."</em></p></div>`,
                    image: "/images/projects/giusti-group-3.webp"
                },
                {
                    title: "Footing Layout",
                    body: `<div><p>The irregular building site made form layout very difficult. </p><p><em>"We decided right 
                        from the get-go to use a robotic total station"</em>, said Scott Saunders, Project Manager.</p>
                        <p><em>"Laying out 270 pads on different angles using strings would have been a nightmare. With 
                        the station, one man does the layout - a huge labor saving."</em></p></div>`,
                    image: "/images/projects/giusti-group-4.webp"
                },
                {
                    title: "Installing Screed Boards & Fastfoot®",
                    body: `<div><p>In the photo, 2x10s were precut to the required pad dimensions, and hinged at each 
                        corner for fast installation and stripping. Three 2x4 stakes were driven along each 2x10, and a 
                        laser used to locate the screed at the exact height.</p><p>The screed board's height is at the 
                        pad height, making concrete screeding much easier than with plywood forms. Bracing was installed 
                        on each stake to withstand lateral loads. The contractor reinforces each corner with a 2x4 on 45 degrees.</p>
                        <p>62" Fastfoot® was stapled to the top of the 2x10s 2" on center. Bricks were used to hold the 
                        steel off the ground and hold the fabric in position. Hydraulid loads are reduced by approximately 40% 
			            when using Fastfoot® due to form pressures in the bottom third of the form being taken by the fabric itself.</p></div>`,
                    image: "/images/projects/giusti-group-5.webp"
                },
                {
                    title: "Reinforcing Steel",
                    body: `<p>25 and 30mm rebar was used throughout the footings, with horizontals spaced 300mm on center. 
                        An overhead crane was used to install the heavy mats.</p>`,
                    image: "/images/projects/giusti-group-6.webp"
                },
                {
                    title: "Concrete",
                    body: `<div><p>Concrete was supplied by Burnco, with branches throughout Alberta, Kelowna, Penticton 
			            and Burnaby. 32 MPA concrete was supplied for the footings and slabs.</p><p><em>"This project 
			            used over 13,000 yards"</em>, said Brandon Moffat, sales representative. <em>"Fastfoot® is an 
			            excellent form as it ensures proper hydration of our concrete on hot summer days."</em> </p>
                        <p>The concrete was placed in deeper pads in two lifts. <em>"Any pad deeper than 18" is best 
                        poured in two lifts"</em>, confirmed Scott.</p></div>`,
                    image: "/images/projects/giusti-group-7.webp"
                },
                {
                    title: "Site Logistics",
                    body: `<div><p>At the end of the project, space becomes more and more limited. Storage and movement of 
                        formwork becomes increasingly difficult.</p><p><em>"One of the real advantages of Fastfoot® is 
                        the reduction of forming materials and the ease of moving 2x10s instead of heavy plywood forms"</em>, 
			            confirmed Scott.</p></div>`,
                    image: "/images/projects/giusti-group-8.webp"
                }
            ]
        },
        {
            id: "uganda",
            menuItem: {
                en: {
                    title: "Kitgum Uganda Church",
                    url: "fast-tube/projects/uganda",
                    metaTitle: "Kitgum Uganda Church | Fast-Tube™ Column Forming for Church Project",
                    metaDescription: "Fast-Tube™ was used to form columns for the Kitgum Uganda Church, enhancing construction efficiency while utilizing local labor for the project in Uganda.",
                }
            },
            category: "fastTube",
            cardTitle: "Kitgum Uganda Church",
            cardDescription: `The Calvary Chapel forms columns with Fast-Tube in Uganda...`,
            cardImage: "/images/fast-tube-projects-uganda.webp",
            title: "",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/2Eb9-1Yvmk4",
                    title: "Fast-Tube™ Concrete Column Form - Uganda Church Project",
                    splashScreen: "/images/uganda-church-project-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<div><p>The <a rel="noreferrer" href="https://www.ccsouthbay.org" onclick="window.open(this.href,'_blank');return false;">Calvary Chapel South Bay Church</a> 
                        in Gardena, California recently completed a church in
	                    <a href="https://www.google.com/maps/place/Kitgum,+Uganda/@3.2902849,32.873689,4459m/data=!3m1!1e3!4m5!3m4!1s0x1773e5518de5f533:0xf186ad6436f26449!8m2!3d3.2884847!4d32.8789499" onclick="window.open(this.href,'_blank');return false;">
	                    Kitgum, Uganda</a> using the Fast-Tube to form the ten columns. </p>
                        <p>The Calvary Chapel has built a number of churches in Uganda for protection of the parishioners 
                        from the hot sun and rain. If you wish to donate to the work of the Calvary Chapel South Bay's 
                        work in Uganda, please click on the icon above.</p></div>`,
                    image: "/images/projects/uganda-1.webp"
                },
                {
                    title: "",
                    body: `<p>Fast-Tube column forms are quickly cut to length from a 100' roll using a utility knife.</p>`,
                    image: "/images/projects/uganda-2.webp"
                },
                {
                    title: "",
                    body: `<p>The alignment tab of the Fast-Tube is stapled to a 2x4 using a hammer tacker with 3/8" 
                        staples. Then a second 2x4 is nailed to the first, sandwiching the alignment tab between the two 2x4s.</p>`,
                    image: "/images/projects/uganda-3.webp"
                },
                {
                    title: "",
                    body: `<p>The Fast-Tube and 2x4s are set up over the concrete footing and rebar, plumbed with a 
                        level and kickers nailed in place to hold the column in position</p>`,
                    image: "/images/projects/uganda-4.webp"
                },
                {
                    title: "",
                    body: `<p>Concrete pumps do not exist in this part of Uganda, so a human chain passes buckets of 
                        concrete from the mixing area to the column. Then the buckets are lifted up the ladder and poured 
                        into the column. A 5 gallon bucket with the end removed is placed at the top of the tube making the filling easy.</p>`,
                    image: "/images/projects/uganda-5.webp"
                },
                {
                    title: "",
                    body: `<p>To start the pour, one of the volunteers holds the bottom edge of the tube in position. 
                        Once there is 6" of concrete in the form, concrete tension in the fabric will prevent leakage.</p>`,
                    image: "/images/projects/uganda-6.webp"
                },
                {
                    title: "",
                    body: `<p>Wooden trusses are set up on beams running between the tops of the columns.</p>`,
                    image: "/images/projects/uganda-7.webp"
                },
                {
                    title: "",
                    body: `<p>The metal roof has been installed over the trusses and the church main structure in now complete.</p>`,
                    image: "/images/projects/uganda-8.webp"
                }
            ]
        },
        {
            id: "slabSettlement",
            menuItem: {
                en: {
                    title: "Slab Settlement",
                    url: "fast-tube/projects/slab-settlement",
                    metaTitle: "Morningstar Quality | Fast-Tube™ for Garage Slab Settlement Prevention",
                    metaDescription: "Morningstar Homes uses Fast-Tube™ to prevent garage slab settlement with reinforced concrete columns, providing a cost-effective solution for stable foundations.",
                }
            },
            category: "fastTube",
            cardTitle: "Morningstar Quality",
            cardDescription: `Morningstar uses Fast-Tube™ to prevent garage slab settlement...`,
            cardImage: "/images/fast-tube-projects-garage.webp",
            title: "",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/1TU0hOoRKAQ",
                    title: "Tube™ Concrete Column Form - Cardboard Tube Replacement",
                    splashScreen: "/images/sonotube-replacement-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "Morningstar Quality",
                    body: `<div><p>True craftsmanship is often reflected in details hidden from the home buyer... like 
                        structural support for garage slabs.</p><p>In the photo to the right, a double car garage is 
                        being formed by Sunset Builders using 1-1/8" plywood forms. After the concrete is poured and the 
                        forms stripped, this area is backfilled to a height of approximately 7.5' using excavated materials. 
                        However with the weight of the cars on the slab, compaction occurs, leading to settlement and 
                        cracking of the slab.</p><p>To prevent slab settlement and cracking, 
	                    <a rel="noreferrer" href="https://www.morningstarhomes.bc.ca/" onclick="window.open(this.href,'_blank');return false;">Morningstar Homes</a> forms and 
	                    pours two concrete footings 30" x 30" x 10" and two 10" diameter concrete columns, each with 
	                    two 15mm vertical rebars, the tops of which are embedded into the garage slab. Around the 
	                    perimeter of the slab, steel dowels are drilled into the concrete walls to support the outside 
	                    edge of the slab.</p></div>`,
                    image: "/images/projects/slab-settlement-1.webp"
                },
                {
                    title: "Fast-Tube™",
                    body: `	<div><p>Fabric is an excellent method of forming columns to support the center of the garage slab. 
	                    Fast-Tube™ is:</p>
	                    <ul>
	                    	<li>Cut to exact length from a 120' roll, eliminates the waste which 
	                    	occurs with 12' carboard tubes</li>
	                    	<li>Undamaged by water, can be set up in advance of the concrete pour</li>
	                    	<li>Fast to set up and fast to strip, saves on labor costs</li>
	                    	<li>Impervious to water, is recycled as an underslab membrane</li>
	                    </ul></div>`,
                    image: "/images/projects/slab-settlement-2.webp"
                }
            ]
        },
        {
            id: "treeHouse",
            menuItem: {
                en: {
                    title: "Tree House",
                    url: "fast-tube/projects/tree-house",
                    metaTitle: "Tree House | Fast-Tube™ Used for Elegant Forest Architecture",
                    metaDescription: "Arro Design used Fast-Tube™ for a stunning tree house design in Vermont, utilizing concrete columns to achieve height without bulky structures.",
                }
            },
            category: "fastTube",
            cardTitle: `Fast-Tube "Tree House"`,
            cardDescription: `Arro Design and the architectural jewel in the forest...`,
            cardImage: "/images/fast-tube-tree-house.webp",
            title: "",
            body: ``,
            images: ["/images/projects/tree-house-1.webp"],
            videos: [],
            articles: [
                {
                    title: "Arro Design - Architect & Builder",
                    body: `<div><p>Arro Design, Waitsfield, Vermont, is a design-build construction company specializing in 
	                    concrete structures. Sandy Lawton, Principal, has extensive experience using concrete, 
	                    <em>&quot;I guide clients towards concrete. It's such a creative medium to work with.&quot;</em> </p>
	                    <p>This tree-house in the woods, is a perfect example of using concrete to enhance a design. &quot;
	                    <em>Our client wanted to retreat with nature, trees and light, and so we needed height without a bulky 
	                    structure. Fast-Tube™ columns are strong, simple and in color harmonics with indigenous rocks&quot;, 
	                    said Sandy.</em></p><p>The tree-house also includes a suspended concrete walkway running to the main house.</p></div>`,
                    image: ""
                },
                {
                    title: "Support Structure",
                    body: `<div><p>The structural frame is made up of four 12&quot; diameter concrete columns 29' tall, 
                        running from the foundation to the roofline.</p><p><em>&quot;We wanted continuous full length 
                        columns without the spiral lines of cardboard tubes&quot;, </em>confirmed Sandy. 
                        <em>&quot;As Fast-Tube™ comes on a 120' rolls, the four 29' columns can be cut from of a single roll.&quot;</em></p>
	                    <h2>Setting up Fast-Tube™</h2>
	                    <p>Scaffolding was set up around each of the four columns, with laminated veneer lumber 
	                    (LVL) placed horizontally at 10', 20' and 30' of height 
	                    to accurately position the forms. Muffler hanger clamps were used to attach the LVLs to the 
	                    scaffolding. A 30' length of LVL was run vertically from the foundation to the top of the column, 
	                    and screwed against the horizontal LVLs. A 16' and 14' 2x4 was screwed to the vertical LVL to hold 
	                    the fabric tab in place.</p></div>`,
                    image: "/images/projects/tree-house-2.webp"
                },
                {
                    title: "Steel Reinforcing",
                    body: `<div><p>The structural engineer specified five #5 vertical rebar spaced radially inside 9" 
	                    compression rings 10" on center. The reinforcing was installed in position and held in place 
	                    temporarily using the vertical 2x4 and tie wire.</p>
	                    <h2>Centering the Reinforcing</h2>
	                    <p><em>&quot;On our first column, we used 2&quot; circular spacers attached to the vertical steel 
	                    members&quot;</em>, said Sandy, <em>&quot;but we found the spacers constrained the flow of 
	                    concrete down the tube.&quot; </em></p><p><em>&quot;On our next column, we used 1-1/2&quot; 
	                    spacers, and placed them on the compression rings so that they presented a smaller area to the 
	                    concrete flow. This worked perfectly.&quot;</em></p>
	                    <h2>Installing Fast-Tube™</h2>
	                    <p>A roll of Fast-Tube™ was taken to the top of the scaffolding and carefully slid over the steel 
	                    reinforcing, taking care not to rip the fabric. Fast-Tube™ was cut to length, and the alignment 
	                    tab stapled to the single 2x4. A second 2x4 was then screwed to the first, sandwiching the alignment tab.</p></div>`,
                    image: "/images/projects/tree-house-3.webp"
                },
                {
                    title: "Concete Mix Design",
                    body: `<div><p>&quot;Our main concern was the potential for aggregate segregation with the 30' drop&quot;, 
	                    said Sandy. &quot;To prevent this, we went with a high range concrete (super plasticized) to 
	                    make it sticky.&quot;</p><p>&quot;On our first column, we used high range concrete with 3/4" 
	                    aggregate and a 4" slump. However we found we were getting voids under the 2&quot; horizontal spacers.&quot; </p>
	                    <p>&quot;On the next column, we used 1-1/2" spacers aligned vertically, a 5" slump, and 
	                    3/8" aggregate - with perfect results.&quot;</p><p>&quot;To vibrate the concrete, we tapped each 
	                    side of the column with our hands as we were filling it. Fast-Tube™ shakes like Jell-O  and 
	                    consolidation is easily achieved.&quot;</p></div>`,
                    image: "/images/projects/tree-house-4.webp"
                },
                {
                    title: "Skeptics Converted",
                    body: `<div><p>&quot;Everybody was very skeptical from the beginning&quot;, said Sandy, &quot;even my 
	                    site superintendent couldn't understand how 5 pounds of fabric could support a 30' column of 
	                    concrete weighing 3,500 pounds. But we proved the skeptics wrong.&quot;</p><p>&quot;To ensure 
	                    the limits of the fabric weren't exceeded, we poured 11' of height, waited 30 minutes; then 10', 
	                    waited 15 minutes; and then the balance.&quot;</p><p><em>&quot;Fast-Tube™ being made of polyethylene 
	                    is perfect for curing. Polyethylene doesn't stick to concrete so it's very easy to strip.&quot;</em></p>
	                    <h2>Conclusions</h2>
	                    <p>&quot;Fast-Tube™ has amazing potential for concrete forming&quot;, enthused Sandy. &quot;It 
	                    eliminates the limitations of fixed length cardboard forms, and allows more creative architectural 
	                    solutions.&quot;</p></div>`,
                    image: "/images/projects/tree-house-5.webp"
                },
                {
                    title: "Beauty of Fabric Formed Concrete",
                    body: `	<p>An award for "Excellence in Architecture" was given out at the Annual meeting and Design 
	                    Awards Presentations of the American Institute of Architects, Vermont Chapter in the Landscape 
	                    Category for this project. For more information on this artistic architectural use of fabric formwork, 
	                    contact <a href="mailto:sandy@arrodesign.org">Sandy Lawton</a>, ArroDesign, (802)496-3234.</p>`,
                    image: "/images/projects/tree-house-6.webp"
                }
            ]
        },
        {
            id: "sunset",
            menuItem: {
                en: {
                    title: "Sunset",
                    url: urls.fastTube.sunset,
                    metaTitle: "Sunset Builders | First Use of Fast-Tube™ for Concrete Column Forms",
                    metaDescription: "In June 2003, Sunset Builders was the first to use production welded Fast-Tube™ for concrete columns, revolutionizing their concrete formwork process.",
                }
            },
            category: "fastTube",
            cardTitle: `Sunset Builders "First User"`,
            cardDescription: `Back in June 2003, Sunset tries the first production welded Fast-Tube™...`,
            cardImage: "/images/fast-tube-projects-logo.webp",
            title: "",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/a12nEbALkMs",
                    title: "Fast-Tube™ Vertical Column Form: Sunset Builders",
                    splashScreen: "/images/sunset-builders-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "Sunset Builders",
                    body: `<div><p>Sunset Builders is a cribbing and framing company operating in the Lower Mainland of BC, 
	                    Canada. Sunset forms and pours foundations and frames structures for 
	                    <a rel="noreferrer" href="https://www.morningstarhomes.bc.ca/" onclick="window.open(this.href,'_blank');return false;">Morningstar Homes</a>.</p>
	                    <p>Henry Van Delft, Principal of Sunset, was the first cribber to use production welded 
	                    Fast-Tube™. When approached by Rick Fearn, Fast-Tube™ inventor, on a sunny day in June 2003, 
	                    about trying the tube, Henry said, <em>&quot;Hmm... interesting. I like the idea,</em>
	                    <span class="font-bold"><em> but</em></span><em> will it hold concrete?&quot;</em></p>
	                    <p>Rick responded, <em>&quot;Well... in theory it <span class="font-bold">should</span> work, I've done the 
	                    calculations. But there's always a difference between theory and reality. Can we give it a try?&quot;</em></p>
	                    <p><em>&quot;Come back on Wednesday with a couple of tubes 9' long. Ron Kautzma, site manager 
	                    will set them up with you&quot;</em>, said Henry.</p></div>`,
                    image: "/images/projects/sunset-1.webp"
                },
                {
                    title: "Wednesday Pour",
                    body: `<div><p>I remember as if it was yesterday. I showed up on site at 9:30 with the Fast-Tubes®. 
	                    Ron and I stapled the alignment tabs between a couple of 2x4s. Then he then placed the tubes 
	                    over the rebar in the pre-poured footings and braced them ready for concrete. I was getting 
	                    nervous. Concrete would soon be here.</p>
	                    <p>I wondered if the tube would fail. I ran the calculations through my head. A 10&quot; diameter 
	                    tube 9' high, that's a pressure of 9 x 150 pounds per square foot or 1,350 pounds per 
	                    square foot at the bottom. This means 10/12x1,350 of pressure on half the tube, or about 560 
	                    pounds on each side. If I divide that by 12&quot;, that's 50 pounds tension on each inch of 
	                    tube. But tensile strength of the fabric is 140 pounds per inch, so I've got a safety factor 
	                    of 280%. I should be okay...?</p><p>But what about the bottom being completely open? Will there 
	                    be more pressure on the bottom edge so that it fails there and rips up from the bottom? And what 
	                    about the weld? Will it hold?</p></div>`,
                    image: "/images/projects/sunset-2.webp"
                },
                {
                    title: "Ready for Concrete?...",
                    body: `<div><p>At 10:45 AM I heard the low roar of the concrete pump coming down the street. And I could 
	                    feel the nervous tension building in the pit of my stomach. Ron didn't seem nervous at all. Nor 
	                    did his assistant Jordan. At 11 o'clock the first concrete truck showed up.</p>
	                    <p>How are we going to stop the concrete from leaking out the base? In theory, if it's a 4&quot; slump, 
	                    the concrete pressure should make the tube tighten like a drum because of hoop tension, so it 
	                    should lock itself to the footing. But who knows about theory at a time like this?!</p>
	                    <p>I asked Ron what he thought about leaking at the base? <em>&quot;No problem&quot;</em>, 
	                    he said with confidence. <em>&quot;I'll put one foot at 4:00 oclock and one at 8:00 o'clock. And I've 
	                    got the 2x4s at 12:00 oclock.&quot;</em></p><p>Easy to say 'no worry', but that didn't calm me. Jordan, 
	                    Ron's young helper, was on the pump hose. He started by filling the tubes before the foundation. 
	                    I guessed that would give time to replace them with cardboard when they failed. Did I say 'fail'. 
	                    I'm getting ahead of myself.</p></div>`,
                    image: "/images/projects/sunset-3.webp"
                },
                {
                    title: "Concete Pour",
                    body: `<div><p>I saw the pump operator staring at the two tubes, hanging loose in the bracing, moving 
	                    lightly in the breeze. I could hear him thinking, <em>&quot;There's no possible way those 
	                    flimsey tubes can hold two tons of concrete.&quot;</em></p><p>Jordan directed the hose over the 
	                    top of the first tube, and lowered the end about half way down the column. His strategy was to 
	                    reduce the landing speed of the concrete by lowering the drop height...</p>
	                    <p>The Ron placed his feet in position...</p><p>And I held my breath...</p></div>`,
                    image: "/images/projects/sunset-4.webp"
                },
                {
                    title: "Success",
                    body: `<div><p>I could hear concrete dropping to the footing below. I saw some concrete leaking out. 
	                    Was this failure at the bottom edge?</p><p>But then the leak stopped. Ron's foot technique 
	                    was working! And the tube was filling! Just like it was supposed to. Two feet, then three, then 
	                    four feet. Wow. Half way. Maybe theory is reality?! Then with confidence increasing, the balance 
	                    of the tube was filled. Right to the top! No failure!</p>
	                    <p>Ron tapped the sides of the tube with his hands to consolidate the concrete. The tube shook 
	                    like a bowl of jello.</p><p>The second tube filled just the same, without failure.</p>
	                    <p>We had a winner.</p></div>`,
                    image: "/images/projects/sunset-5.webp"
                },
                {
                    title: "Fast-Tube™ is Born",
                    body: `<div><p>Henry arrived and said he would check with the developer to see about using Fast-Tube™ on 
	                    all their projects. <em>&quot;This product make's sense as we don't have to muck around 
	                    setting up cardboard tubes at the last minute to prevent water damage. And we can cut off what 
	                    we need and eliminate all waste.&quot;</em></p><p>Since 2003, Sunset has used thousands of 
	                    column forms on their many projects.</p><p>And it all started from that day back in June 2003.</p>
	                    <p>Thank you Henry, Ron and crew for supporting Canadian innovation.</p></div>`,
                    image: "/images/projects/sunset-6.webp"
                }
            ]
        },
        {
            id: "strachan",
            menuItem: {
                en: {
                    title: "Strachan",
                    url: "fast-tube/projects/strachan",
                    metaTitle: "Strachan Investments Ltd. | Cost-Effective Fast-Tube™ Concrete Column Forms",
                    metaDescription: "Strachan Investments Ltd. saved time and costs with Fast-Tube™ for concrete columns, offering efficient and environmentally friendly forming solutions.",
                }
            },
            category: "fastTube",
            cardTitle: "Strachan saves money with Fast-Tube™",
            cardDescription: `Production cribber chooses Fast-Tube™...`,
            cardImage: "/images/fast-tube-projects-strachan.webp",
            title: "",
            body: ``,
            images: ["/images/projects/strachan-1.webp"],
            videos: [],
            articles: [
                {
                    title: "Strachan Investments Ltd.",
                    body: `<div><p>Brian Strachan, President, has been in the concrete forming business for over 15 years. 
	                    His company has five employees and places between 150 and 200 cubic meters of concrete per week. 
	                    Over the years he has worked for many of the large developers in Vancouver.</p>
	                    <p><em>&quot;Each product has it's advantages and disadvantages&quot;</em>, said Brian. 
	                    <em>&quot;We used to install the cardboard tubes at the last minute to prevent water damage. 
	                    Now I give a roll of Fast-Tube™ to each of my crews, and they install upon the completion of the 
	                    formwork, regardless of the weather - rather than when the concrete shows up. It makes 
	                    my life a lot simpler. The disadvantage of fabric is that a tear can lead to form failure if you 
	                    fill it right up - so we're careful when installing over rebar.&quot;</em></p></div>`,
                    image: "/images/projects/strachan-2.webp"
                },
                {
                    title: "Cost of Fast-Tube™",
                    body: `<div><p>From a cost standpoint, Brian views the Fast-Tube™ as a winner. <em>&quot;In the past, 
	                    12' cardboard tubes would be delivered on the ready mix truck along with the concrete to 
	                    minimize water damage. Now we include the Fast-Tube™ in our contract, we make a markup on the fabric,
	                    and the owner gets each column for about half the cost. Everyone wins.&quot;</em></p></div>`,
                    image: "/images/projects/strachan-3.webp"
                },
                {
                    title: "Setting the Base",
                    body: `	<p>Strachan use another method of setting the base when filling the tube. <em>&quot;We hold 
	                    the bottom edge away from the 2x4s with one hand. As soon as the tube has 6&quot; of concrete in it, 
	                    fabric tension prevents leakage. This is easier than placing your feet around the base.&quot;</em></p>`,
                    image: "/images/projects/strachan-4.webp"
                }
            ]
        },
        {
            id: "lockingBase",
            menuItem: {
                en: {
                    title: "Locking Base",
                    url: "fast-tube/projects/locking-base",
                    metaTitle: "Locking Fast-Tube™ Base | Steve's Locking Technique for Concrete Column Forms",
                    metaDescription: "Steve from DR Construction demonstrates his innovative technique for locking the base of Fast-Tube™, ensuring secure concrete column formation.",
                }
            },
            category: "fastTube",
            cardTitle: "Locking Fast-Tube™ Base",
            cardDescription: `Steve, DR Construction demonstrates his technique...`,
            cardImage: "/images/fast-tube-projects-locking-base.webp",
            title: "",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/G6j0s-qSMQY",
                    title: "Fast-Tube™ Concrete Column Form : Locking the base",
                    splashScreen: "/images/locking-the-base-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "Locking the Base",
                    body: `<div><p>Steve, lead hand, with DR Contracting, Surrey, BC, demonstrates his technique for 
	                    locking the base. He grabs the base of the tube with each hand at 4:00 and 8:00 o'clock, 
	                    then twists each hand 90 degrees to stop the concrete from coming in contact with is fingers.</p>
	                    <p><em>&quot;You learn from experience to protect your hands from the concrete</em>&quot;, confirmed Steve.</p></div>`,
                    image: "/images/projects/locking-base-1.webp"
                },
                {
                    title: "Fast-Tube™, a Great Product",
                    body: `<div><p>Dan Reneau, President of DR Contracting, is an experienced user of Fast-Tube™ and 
	                    demonstrates his technique for locking the base.</p><p><em>&quot;Fast-Tube™ is a great 
	                    product, we love it.&quot;</em></p></div>`,
                    image: "/images/projects/locking-base-2.webp"
                }
            ]
        },
        {
            id: "rain",
            menuItem: {
                en: {
                    title: "Rain",
                    url: urls.fastTube.rain,
                    metaTitle: "Fast-Tube™ in the Rain | Reliable Concrete Forming with Fabric",
                    metaDescription: "Fast-Tube™ provides reliable concrete forming in wet conditions, outperforming traditional cardboard tubes by remaining unaffected by moisture.",
                }
            },
            category: "fastTube",
            cardTitle: "Fast-Tube™ in the rain",
            cardDescription: `Production cribber likes Fast-Tube™, especially in the rain...`,
            cardImage: "/images/fast-tube-water-damage.webp",
            title: "",
            body: ``,
            images: [],
            videos: [],
            articles: [
                {
                    title: "FAST-TUBE™ in the RAIN",
                    body: `<div><p>On the left of the photo above, Steve, foreman, DR Contracting, Surrey, BC, stands beside 
                        a column poured in the rain with Fast-Tube™. On the right, a contractor tries to protect his 
                        cardboard tubes from the rain with polyethylene.</p><p><em>&quot;Forming with cardboard in the 
                        rain </em>leads to failure&quot;, said Dan, President of DR Contracting. <em>&quot;With Fast-Tube™ 
                        we set up any time and never worry about the weather.&quot;</em></p></div>`,
                    image: "/images/projects/rain-1.webp"
                },
                {
                    title: "Water Damaged Cardboard Tubes",
                    body: `<p>Cardboard is hydroscopic, weakened by moisture and rain, and can lead to column form 
                        failure when exposed to moisture. Fast-Tube, made of polyethylene, is uneffected by moisture, 
	                    and can be left out in moisture and rain indefinitely.</p>`,
                    image: "/images/projects/rain-2.webp"
                }
            ]
        },
        {
            id: "corintoChurch",
            menuItem: {
                en: {
                    title: "Corinto Church",
                    url: "fast-tube/projects/corinto-church",
                    metaTitle: "Corinto Church | Fast-Tube™ for Church Column Structure in Nicaragua",
                    metaDescription: "Fast-Tube™ was used to form concrete columns for the Church in Corinto, Nicaragua, providing a cost-effective and durable solution for this community project.",
                }
            },
            category: "fastTube",
            cardTitle: "Fast-Tube™ Church",
            cardDescription: `Fast-Tube™ used to form column structure of Nicaragua Church...`,
            cardImage: "/images/fast-tube-projects-corinto.webp",
            title: "",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/nXK9e55kta0",
                    title: "Nicaragua Church: Fast-Tube® Columns",
                    splashScreen: "/images/nicaragua-church-fast-tube-columns-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "Fast-Tube™ used for Church Structure in Nicaragua",
                    body: `<div><p>The picture above shows the inauguration ceremony for the completion of the Church in Corinto, 
                        Nicaragua, built with volunteer labor and donated materials. The column structure of the Church 
                        was formed with Fast-Tube™.</p><p>Nicaragua is one of the hemisphere's poorest countries, with a 
                        low per capita income, unemployment of over 40%, high external debt and an unequal income distribution.</p>
	                    <p>The <a rel="noreferrer" href="https://www.firstassembly.fm/" onclick="window.open(this.href,'_blank');return false;">Church of the First Assembly of God</a> 
	                    in Fargo ND and the <a rel="noreferrer" href="https://latinamericachildcare.org/" onclick="window.open(this.href,'_blank');return false;">Latin American 
	                    Child Care Agency</a> have been working in Nicaragua since 1997, and have built 9 schools to 
	                    alleviate poverty and improve educational standards. In five years the Church in Corinto had 
	                    expanded 40 fold, and required a larger building. <em>"We needed a Church that was affordable,"</em> 
	                    said Bonnie Hernandez, Minister, <em>"and we wanted to build it with local manpower."</em></p></div>`,
                    image: ""
                },
                {
                    title: "Church Design",
                    body: `<div><p>The church was designed as a rectangle, approximately 110' in length and 60' in width. 
	                    The outside walls were concrete masonry units. One third of the width was to include a suspended 
	                    steel and concrete balcony to permit additional seating for the large and growing congregation. 
	                    The remaining width was open to the 23' ceiling, sloping down  to masonry walls around the perimeter.</p>
	                    <p>The roof was corrugated steel over steel trusses, supplied by a local manufacturer. The balcony and 
	                    roof truss system were to be supported by concrete columns.</p><p>Doug Muckey, volunteer from 
	                    Ellendale, North Dakota, and concrete professional, agreed to supervise the forming and pouring
	                    of the concrete columns. <em>"We use Fast-Tube™ extensively in our ready mix business, and knew 
	                    it was perfect for this project"</em>, said Doug. <em>"We needed two 20' columns at each end of 
	                    the building to support the roof structure, six 10' columns to support the inside edge of the 
	                    balcony, and six 13' columns supporting the roof above."</em></p></div>`,
                    image: "/images/projects/corinto-church-1.webp"
                },
                {
                    title: "&quot;But where are the columns forms?!&quot;",
                    body: `<div><p>Doug Muckey had told the Church he would bring the column formwork with him. But when he 
                        arrived on the project site, the construction supervisor, Manuel, who was meeting with twelve of 
                        the volunteers, gasped, <em>&quot;But where are the column forms? You promised to bring these! 
                        How are we going to build the structure without these?&quot;</em></p><p>Doug smiled and went 
                        back to the taxi where he retrieved his black suitcase. He opened it in front of the crowd and 
                        said, <em>&quot;Here are your column forms called 'Fast-Tube™' - you will soon see how 
                        well they work!&quot;</em></p><p>Doug then proceeded to show the eager volunteers the 
                        <a href="/${lang}/${urls.fastTube.installation}">installation method</a>.</p></div>`,
                    image: "/images/projects/corinto-church-2.webp"
                },
                {
                    title: "Steel reinforcing",
                    body: `<div><p><em>"Back in America, we typically pour 8' to 10' high columns. But this project required 
                        20' columns, so we were pushing the barrier!"</em>, said Doug. <em>"And everything was by hand - 
                        no ready mix trucks and no pumps."</em></p><p>The workers began by setting up scaffolding at each 
                        column location. A 20' high 2x4 was positioned and braced on the outside circumference of the column. 
	                    Steel reinforcing of 4 strands of #5 rebar with stirrups 6" on center was assembled on the ground, 
	                    and tilted into position next to the 2x4.</p></div>`,
                    image: "/images/projects/corinto-church-3.webp"
                },
                {
                    title: "Installing the Fabric",
                    body: `<p><em>&quot;We developed our own technique for installing the 20'' Fast-Tubes™. Starting 
                        from the top, we carefully slid the 20' length of Fast-Tube™ over the steel cage. We stapled 
                        the alignment tab to the 2x4 to hold the tube in its exact location, and attached a second 2x4 
                        to the first to ensure the fabric tube would be centered across from the 2x4s.&quot;</em></p>`,
                    image: "/images/projects/corinto-church-4.webp"
                },
                {
                    title: "Pouring Concrete",
                    body: `<div><p>As the Church wanted to employ as much local labor as possible, all concrete was mixed and
                        placed by hand.</p><p>&quot;I was very nervous about this&quot;, said Doug. &quot;Imagine 
                        carrying five gallon buckets of concrete to the top of the scaffolding and dumping them 20' 
                        to the bottom. Needless to say I didn't sleep much the night before.&quot;</p><p>"To make placing 
                        easier, we cut off the top of a plastic bucket and screwed it to the top of the 2x4s. Then we attached 
	                    the Fast-Tube™ to the plastic bucket with Duct Tape®.&quot;</p><p><i>&quot;I was at the bottom 
	                    when the first bucket of concrete was dropped. The fabric held <span class="font-bold">perfectly</span>! As 
	                    the concrete filled the tube, we centered the steel cage in the column by grabbing the steel 
	                    through the fabric and positioning it&quot;</i>, exclaimed Doug. <em>&quot;The church was finally 
	                    taking shape!&quot;</em></p></div>`,
                    image: "/images/projects/corinto-church-5.webp"
                },
                {
                    title: "Electrical Outlets",
                    body: `<div><p><i>&quot;As we needed electrical power on each column, we ran two lines of conduit down 
                        the center of the reinforcing cage. We placed 90 degree bends and located two outlet boxes 
                        11-3/4 inches across from each other. We plugged the boxes with paper so the concrete wouldn't 
                        flow inside. Once we stripped the fabric, we hammered out the surface concrete&quot;</i>, said Doug.</p>
	                    <p>After the completion of the concrete columns, Doug returned home to North Dakota. The walls, 
	                    balcony and roof would be completed by others.</p></div>`,
                    image: "/images/projects/corinto-church-6.webp"
                },
                {
                    title: "Inauguration Ceremony",
                    body: `<div><p>On February of next year the inauguration ceremony took place with over 1,200 exuberant 
                        parishioners. Doug Muckey flew back from North Dakota to join the event. </p><p><i>&quot;It is 
                        so amazing what these people have accomplished!&quot;</i> exclaimed Doug. <i>&quot;Not only have 
                        they completed this magnificent church with their own money and labor, but they have also built 
                        three schools nearby. The Church is breaking down barriers between rich and poor, creating a 
                        more just society.&quot;</i></p></div>`,
                    image: "/images/projects/corinto-church-7.webp"
                }
            ]
        },
        {
            id: "supErb",
            menuItem: {
                en: {
                    title: "SupErb",
                    url: "fast-tube/projects/superb",
                    metaTitle: "SupErb Construction | Fast-Tube™ Staked for Efficient Boardwalk Project",
                    metaDescription: "SupErb Construction used Fast-Tube™ Staked to form concrete columns for a 439-meter boardwalk in Parksville, BC, improving efficiency and reducing waste.",
                }
            },
            category: "fastTube",
            cardTitle: `Fast-Tube "Staked"`,
            cardDescription: `SupErb Construction impresses with beach walkway project...`,
            cardImage: "/images/fast-tube-projects-chris-erb.webp",
            title: "",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/_sxPLaWKAsA",
                    title: "Fast-Tube™ Staked",
                    splashScreen: "/images/fast-tube-staked-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "City of Parksville Greens Shorefront",
                    body: `<div><p>Parksville, located on the eastern shores of Vancouver Island, awarded a contract for 439 
                        meters of boardwalk along the ocean front of its community park to SupErb Construction Ltd. of 
                        Nanaimo, BC.</p><p>SupErb Construction, founded in 1981 by Chris Erb of Nanaimo BC, constructs 
                        residential, commercial and civil projects.</p><p>Chris has been involved in environmental 
                        construction long before it became fashionable, being an EnviroHome Canada Builder, R-2000 
                        Builder and a BuiltGreen BC Builder. SupErb Construction is the island's biggest user of Fastfoot®, 
                        the environmental concrete form. <em>"I continually point out the advantages of Fastfoot® to 
	                    other contractors, but they won't change"</em>, said Chris. <em>"I don't understand their 
	                    reluctance to try something new, less expensive and better for the environment."</em></p></div>`,
                    image: "/images/projects/superb-1.webp"
                },
                {
                    title: "Boardwalk Construction Details",
                    body: `<div><p>The wooden boardwalk requires pairs of concrete support piers spaced 4.9 meters apart in 
                        width and 3 meters on centre in length. Each steel reinforced support pier was 30" in diameter 
                        and 21" in height. A galvanized steel saddle embedded in the concrete supports an 8" x 8" wooden beam 
	                    between each pair of piers, and 4" x 10" beams 24" on centre run between each cross beam to 
	                    support 3" x 8" cedar decking.</p>
	                    <h2>Bidding to Win</h2>
	                    <p>Chris knew the competition for the contract would be tight. All contractors would price out 
	                    30" diameter cardboard tubes from the same suppliers. And the concrete, steel reinforcing, and 
	                    lumber would also be competitively priced. To win, Chris had to come up with an innovative 
	                    solution that would save time, money and meet the City's environmental values.</p></div>`,
                    image: "/images/projects/superb-2.webp"
                },
                {
                    title: "Innovative Design",
                    body: `<div><p>Chris contacted Fab-Form to see if a fabric form was available for the 30" diameter by 
	                    21" high columns.</p><p>Fab-Form suggested a new product 'Fast-Tube™ Staked' where four 
	                    stakes would be pre-installed on the outside of the fabric tube with a special folding template 
	                    to accurately position each stake.</p><p><em>"We looked at the samples and knew this was an 
	                    excellent solution"</em>, said Chris. <em>"Doug Bennett, our site supervisor, set up the samples 
	                    on sand, with install time under a minute. We had a real winner. With cardboard, we would have 
	                    to fabricate the stakes and screw them to the tube, all this taking time."</em></p><p><em>"With 
	                    Fast-Tube Staked™ we get a column and stakes that minimizes site labour. Furthermore, this time 
	                    of year we get plenty of rain, so the logistics of protecting cardboard is a huge issue with 325 
	                    columns to pour. Finally we knew this would meet the environmental values of the City as the 
	                    waste using fabric is 1/10 that of cardboard."</em> </p>
	                    <h2>Installation</h2>
	                    <p>SupErb used a Bobcat® with a backhoe attachment to dig out a 4' wide and 21" deep trench. 
	                    A stringline was used to locate rebar pins 3 meters on centre. <em>"Installation was so fast, 
	                    the Bobcat® couldn't keep up"</em>, said Doug. Rebar cages were set in the centre of each Fast-Tube™.</p></div>`,
                    image: "/images/projects/superb-3.webp"
                },
                {
                    title: "Pouring Concete",
                    body: `<div><p>"Concrete placement was perfect", said Chris. "We vibrated each column without problem as 
                        the safety factor on the fabric was over 400%. Initially we checked the concrete height with a 
                        laser, but elevations were perfect with no movement in stakes nor fabric." After 30 minutes, 
                        Doug installed the galvanized saddles on top of each column. "Stripping took seconds", confirmed 
                        Doug, with the 1x2 stakes being saved for future projects.</p>
	                    <h2>Win Win</h2>
	                    <p>All parties won: the City got a lower cost environmental boardwalk for it's citizens. SupErb 
	                    increased its profit margins with a faster install, lower material, labour and disposal costs.</p></div>`,
                    image: "/images/projects/superb-4.webp"
                }
            ]
        },
        {
            id: "prefab",
            menuItem: {
                en: {
                    title: "Prefab",
                    url: "monopour/mpss/projects/prefab",
                    metaTitle: "Fab-Form Prefab | Fast-Tube™ Used in Large Scale Construction Projects",
                    metaDescription: "Fab-Form's prefab system was used in a 19,000 ft² project, offering a time-saving and cost-effective solution for large-scale foundation work.",
                }
            },
            category: "monopour",
            cardTitle: "Fab-Form Prefab",
            cardDescription: `<a href="https://www.vancouvericf.com/usarSep2017.php">Prefab used in 19,000 ft2 project...</a>`,
            cardImage: "/images/fab-form-projects-prefab.webp",
            title: "",
            body: ``,
            images: [],
            videos: [],
            articles: []
        },
        {
            id: "nuduraVan",
            menuItem: {
                en: {
                    title: "Nudura Vancouver",
                    url: "monopour/mpss/projects/nudura-vancouver",
                    metaTitle: "Nudura® Comes to Vancouver | ICF Monopour Foundation in White Rock",
                    metaDescription: "Nudura® ICF Monopour foundation system used in White Rock for a new construction project, ensuring precise alignment and durability.",
                }
            },
            category: "monopour",
            cardTitle: "Nudura® comes to Vancouver",
            cardDescription: `Nudura®, the builder's block used in White Rock project...`,
            cardImage: "/images/fab-form-projects-nudura.webp",
            title: "Nudura® comes to Vancouver",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/W8ESDox0X3k",
                    title: "Nudura Insulated Concrete Form (ICF) Monopour",
                    splashScreen: "/images/nudura-icf-monopour-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<p>An ICF Monopour foundation was recently poured in White Rock by Vern Perry of 
	                    <a rel="noreferrer" href="https://www.oceanoconstruction.com" onclick="window.open(this.href,'_blank');return false;">Oceano Construction</a> 
	                    for owner/builder Brian Evans. In the video above Brian discusses the merits of Nudura® and the ICF Monopour System.</p>`,
                    image: ""
                },
                {
                    title: "",
                    body: `<p>This isometric drawing of the ICF foundation and crawlspace provides the general layout of 
                        the panels which was used by Oceano Construction when installing the panels.</p>`,
                    image: "/images/projects/white-rock-1.webp"
                },
                {
                    title: "",
                    body: `<p>This plan drawing of the ICF foundation and crawlspace provides the diagonal dimensions 
	                    of the panels used for the final alignment of the wall panels.</p>`,
                    image: "/images/projects/white-rock-2.webp"
                },
                {
                    title: "",
                    body: `<div><p>The excavation was dug on three levels: the full basement is closest, a secondary level 
                        and finally the crawl space level. Height difference was 7'-3" between the three levels. Notice 
                        that the builder has installed a drainage layer on the surface of each elevation to prevent 
                        water buildup behind the footings and to eliminate water wicking up into the footings.</p>
	                    <p>The batter boards to align the MP panels can be seen on each corner. The first delivery was 
	                    the panels for the full height foundation.</p></div>`,
                    image: "/images/projects/white-rock-3.webp"
                },
                {
                    title: "",
                    body: `<p>The second delivery was for the stem wall panels. The full height walls were installed 
	                    first (top right of photo) to allow the correct positioning of the stems walls to the full height walls.</p>`,
                    image: "/images/projects/white-rock-4.webp"
                },
                {
                    title: "",
                    body: `<p>The crawl space foundation (showing on the left with Fastfoot® installed) was already 
                        installed and braced into position. The panel C11 (two blocks high, 36") was manufactured to 
                        join the two foundations together. To accommodate the double step, the component was flipped 
                        upside down, a third block snapped into place and the fabric attached. Nudura® has locking teeth 
	                    which holds the blocks together, ideal for this application.</p>`,
                    image: "/images/projects/white-rock-5.webp"
                },
                {
                    title: "",
                    body: `<p>This photo shows the same double step when filled with concrete. The contractor has 
                        bulk-headed off the form adjacent to the bank to eliminate lateral pressures.</p>`,
                    image: "/images/projects/white-rock-6.webp"
                },
                {
                    title: "",
                    body: `<p>The Fastfoot® fabric footing form serves two functions: first it allows the MP panels to 
                        adapt to uneven ground, and second, it prevents ground moisture from wicking in to the top, 
                        sides and bottom of the footing. This is essential in the wet Vancouver climate.</p>`,
                    image: "/images/projects/white-rock-7.webp"
                },
                {
                    title: "",
                    body: `<p>The pour occurred on a rainy fall morning. It was completely uneventful - which in the 
                        concrete business is a very good thing.</p>`,
                    image: "/images/projects/white-rock-8.webp"
                },
                {
                    title: "",
                    body: `<p><em>"I am very pleased with the performance of the Nudura® Monopour"</em>, 
                        confirmed Brian Evans.</p>`,
                    image: "/images/projects/white-rock-9.webp"
                }
            ]
        },
        {
            id: "cirrusHomes",
            menuItem: {
                en: {
                    title: "Cirrus Homes",
                    url: "monopour/mpss/projects/cirrus-homes",
                    metaTitle: "Cirrus Homes Monopour | ICF Monopour with Helix® Micro Rebar",
                    metaDescription: "Cirrus Homes uses the Fab-Form ICF Monopour System with Helix® Micro Rebar for a faster, more efficient concrete foundation with added durability.",
                }
            },
            category: "monopour",
            cardTitle: "Cirrus Homes Monopour",
            cardDescription: `Footing protection against ground moisture...`,
            cardImage: "/images/fab-form-projects-cirrus.webp",
            title: "ICF Monopour + Helix®",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/FxkREgzfbHQ",
                    title: "Fab-Form ICF Monopour using Helix Micro Rebar",
                    splashScreen: "/images/fab-form-icf-monopour-using-helix-micro-rebar-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<div><p>The use of Helix® micro rebar in the concrete means the ready mix company now supplies 
                        and installs the steel reinforcing. This has allowed Fab-Form to change the size and shape of 
                        the ICF panels to maximize the speed and efficiency of the contractor.</p><p>Greg Hanberry, 
                        Director of<a rel="noreferrer" href="https://www.cirrushomes.ca" onclick="window.open(this.href,'_blank');return false;"> Cirrus Homes</a>, a green home 
                        builder for 28 years, discusses his experience with the Fab-Form Monopour System in the video above.</p></div>`,
                    image: ""
                },
                {
                    title: "",
                    body: `<div><p>The Fab-Form monopour foundation is built in componets with the fabric bag (which forms 
                        the footing)attached to the bottom of each panel. The different coloured elements shown above 
                        represent a separate component. Once the contractor has approved the working drawings, the 
                        manufacturing begins.</p><p>The working drawings allow the builder to carefully review of the 
                        top of wall elevations and final dimensions so that site errors and resulting delays and expenses 
                        are avoided. Even point loads in the footing are easily accomodated as shown in the drawing above.</p></div>`,
                    image: "/images/projects/cirrus-homes-1.webp"
                },
                {
                    title: "",
                    body: `<p>Monopour panels are delivered by truck to the jobsite. Notice the drainage layer across the 
                        site to prevent ground moisture entering into the concrete. Notice also the string lines and 
                        batter boards which will be used to align each panel.</p>`,
                    image: "/images/projects/cirrus-homes-2.webp"
                },
                {
                    title: "",
                    body: `<p>The first level of Monopour panels including the footing bag have now been installed. 
                        Zont™ waler brackets have been screwed into the webs on about 6' on center. 2x4 walers and 
                        strongbacks will be installed next.</p>`,
                    image: "/images/projects/cirrus-homes-3.webp"
                },
                {
                    title: "",
                    body: `<p>The 2x4 walers and strongbacks have been installed. Kickers are placed on each strongback 
                        to plumb the wall. A 2x10 has been added for the walkway in order to easily install the top panels.</p>`,
                    image: "/images/projects/cirrus-homes-4.webp"
                },
                {
                    title: "",
                    body: `<p>This photo details the walkway and railing. The Zuckles™ are easily adjusted while 
                        standing on the walkway.</p>`,
                    image: "/images/projects/cirrus-homes-5.webp"
                },
                {
                    title: "",
                    body: `<p>The concrete was first placed in the perimeter footings and up into the wall one to two 
                        feet. This concrete was allowed to go 'off' as the internal footings and stem walls were filled. 
	                    Then the ICF wall was filled in 3 to 4' lifts.</p>`,
                    image: "/images/projects/cirrus-homes-6.webp"
                },
                {
                    title: "",
                    body: `<div>
                        <p>Reinforcing for the walls and footings was done using Helix® micro rebar, speeding construction and reducing costs. Cirrus placed two rebars at the top of the wall, but the rest of the forms had no rebar. Note the fibers visible on the ICF plastic webs.</p>

                      <p>The Helix® was added to the ready-mix trucks at the Allied Concrete plant to ensure the correct dosage and proper dispersion throughout the concrete. Learn more about <a rel="noreferrer" href="https://www.steelfiberswest.com" onclick="window.open(this.href,'_blank');return false;">Helix® micro rebar</a>.</p>
                    </div>`,
                    image: "/images/projects/cirrus-homes-7.webp"
                },
                {
                    title: "",
                    body: `<p>Placing the final lift of concrete in the ICF wall.</p>`,
                    image: "/images/projects/cirrus-homes-8.webp"
                },
                {
                    title: "",
                    body: `<p>Cirrus Homes takes a great deal of care in protecting the foundation from ground moisture. 
	                    First, a peel and stick membrace is placed on the cleaned ICF wall, overlapping the Fastfoot® 
	                    fabric. Then a dimple membrane is attached over the peel and stick to provide a drainage layer.</p>`,
                    image: "/images/projects/cirrus-homes-9.webp"
                }
            ]
        },
        {
            id: "valkyries",
            menuItem: {
                en: {
                    title: "Valkyries",
                    url: "monopour/mpss/projects/valkyries",
                    metaTitle: "Helix® Micro Rebar Debuts in British Columbia | ICF Monopour for Townhouses",
                    metaDescription: "RDC Fine Homes uses Helix® Micro Rebar in the Valkyries townhouse project, enhancing concrete strength while reducing environmental impact in Squamish, BC.",
                }
            },
            category: "monopour",
            cardTitle: "Monopour forms townhouse",
            cardDescription: `Valkyries uses Helix and monopour system...`,
            cardImage: "/images/fab-form-projects-valkyries.webp",
            title: "Helix® Micro Rebar Debuts in British Columbia",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/eej3pSuU4BU",
                    title: "Fab-Form ICF Monopour: Helix™ steel fiber debut",
                    splashScreen: "/images/fab-form-icf-monopour-using-helix-micro-rebar-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<div><p><a rel="noreferrer" href="https://www.rdcfinehomes.com/" onclick="window.open(this.href,'_blank');return false;">RDC Fine Homes Ltd.</a> recently 
                        poured BC's first foundation reinforced with Helix® micro rebar in the footing and stem wall. 
                        RDC, located in Whistler BC, specializes in custom homes and energy efficient &quot;Built Green®&quot;
                        technology.</p><p>The project, <a rel="noreferrer" href="https://www.thevalkyries.ca" onclick="window.open(this.href,'_blank');return false;">'The 
	                    Valkyries'</a>, located in Squamish, BC, consists of four, three story, three bedroom town homes. 
	                    The developer, Mario Gomes, is building to the 'Built Green® GOLD' standard with a minimum 
	                    EnerGuide rating of 80.</p><p>To assist with these green objectives, project Structural Engineer, 
		                Ken Louie, <a rel="noreferrer" href="https://www.rktg.ca/" onclick="window.open(this.href,'_blank');return false;">RKTG Associates Limited</a>, Vancouver 
		                BC, determined that Helix® provided equivalent structural performance to conventional steel 
		                reinforcing while lowering the embodied energy by 30%.</p></div>`,
                    image: ""
                },
                {
                    title: "Pre-manufactured Foundation Components",
                    body: `<div><p>The 524' long stem wall and footing foundation was premanufactured into 51 separate 
                        components and delivered to the Squamish BC jobsite. Each component consisted of:</p>
	                    <ol>
	                    	<li>curb wall made from Logix® taper top block, R-24 insulation 
	                    	value</li>
	                    	<li>Fastfoot® footing membrane to form the 24" x 9" footing and prevent 
	                    	rising damp</li>
	                    	<li>door openings where required</li>
	                    	<li>seismic tie down locaters for SSTB16 and PAB8</li>
	                    	<li>adjustable side supports to level and plumb each component
	                    	</li>
	                    </ol>
	                    <p>Component ends were glued and clamped together on site, then reinforced with fiberglass tape.</p></div>`,
                    image: "/images/projects/valkyries-1.webp"
                },
                {
                    title: "Zont™ Bracing",
                    body: `<div><p>The Zont® bracing system was used to ensure there was no movement of the wall during the 
                        pour. In this picture the new Zont® 'Twist' was used to lock the top waler in position.</p>
	                    <p>Zuckle™ wall aligners were used to accurately adjust the wall to the string line.</p></div>`,
                    image: "/images/projects/valkyries-2.webp"
                },
                {
                    title: "Adding Helix® to Concrete",
                    body: `<div><p>Concrete was supplied by <a rel="noreferrer" href="https://www.cardinalconcrete.ca" onclick="window.open(this.href,'_blank');return false;">
	                    Cardinal Concrete Ltd.</a>, Squamish, BC. The mix was 25 MPa , 3/4" aggregate and no plasticizer.</p>
	                    <p><em>"We're impressed with Helix®" </em>said Bob Versluis, Plant Manager <em>"the 1" fiber length 
	                    made for easy pumping."</em></p><p>A forklift was used to lift the Helix® and employee to drop the 
	                    boxes of fiber into the hopper. For details on adding the Helix® into the concrete, click
	                    <a rel="noreferrer" href="https://www.steelfiberswest.com/mixing.php" onclick="window.open(this.href,'_blank');return false;">here</a>.</p>
		                <p>Helix® dosage was 20.7 kg/m3, which replaced 15M bars in the footing and stem wall.</p></div>`,
                    image: "/images/projects/valkyries-3.webp"
                },
                {
                    title: "Placing Concrete",
                    body: `<div><p>Blair Mackie, Project Supervisor manned the pump hose.</p><p><em>"Helix® presented no 
                        difficulties with the concrete pumping",</em> confirmed Blair. <em>"We required 37 cubic meters 
                        of concrete and there was only one occasion where the line got blocked."</em></p>
		                <p><em>"We had concerns that Helix® might make finishing the top of wall more difficult"</em>, 
		                added Blair. <em>"Helix® had no impact what so ever."</em></p></div>`,
                    image: "/images/projects/valkyries-4.webp"
                },
                {
                    title: "Completed Pour",
                    body: `<div><p>The pour of 37 m3 was uneventful, with finishing done by RDC.</p><p><em>"We've used the 
                        Monopour System for three years now,"</em> said Bob Deeks, President of 
                        <a rel="noreferrer" href="https://www.rdcfinehomes.com/" onclick="window.open(this.href,'_blank');return false;">RDC Fine Home Ltd.</a></p><p><em>"The 
                        Helix®-Monopour combination is difficult to beat. Not only do we get an insulated and damp 
	                    proofed foundation, we reduced our construction time by two weeks and our costs as well."</em></p></div>`,
                    image: "/images/projects/valkyries-5.webp"
                }
            ]
        },
        {
            id: "ecoHeritage",
            menuItem: {
                en: {
                    title: "Eco-Heritage",
                    url: "monopour/mpss/projects/eco-heritage",
                    metaTitle: "EcoHeritage Densification | Sustainable Foundations and Preservation",
                    metaDescription: "The EcoHeritage project in Vancouver preserves heritage homes while increasing density and sustainability using Fab-Form Monopour foundations.",
                }
            },
            category: "monopour",
            cardTitle: "EcoHeritage Densification",
            cardDescription: `Karli Gillespie & Dick Hellofs' project: preserving heritage & the environment...`,
            cardImage: "/images/fab-form-projects-karli-dick.webp",
            title: "Union Street ECOheritage Project",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/56wmZqtnTmY",
                    title: "Fab-Form ICF Monopour: Eco-Heritage Project",
                    splashScreen: "/images/fab-form-icf-monopour-eco-heritage-project-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<div><p>There were two 1892 heritage homes located side by side on the 50' by 132' lot.&nbsp; 
	                    To make the project financially viable, developers Dick Hellios and Karli Gillespie increased 
	                    the densification to seven units: two in each heritage unit; one adjacent and behind each heritage 
	                    unit; and one laneway unit on the south end.</p>
	                    <p>This densification was not accomplished by demolishing and rebuilding from 
	                    scratch, but rather by upgrading the heritage homes to reflect contemporary social and economic 
	                    realities.  New construction is highly energy efficient with an aesthetic that is derived from, 
	                    but not imitative of the existing structures. This balances the energy inefficiencies of the 
	                    heritage homes, while still preserving their cultural and ecological value for the community and 
	                    surrounding neighbourhood.</p></div>`,
                    image: "/images/projects/eco-heritage-project-graphics.webp"
                },
                {
                    title: "Project Concept",
                    body: `<div><p>A central complex housing green technologies such as solar hot water and heat pumps provide 
                        heat, water and services to each unit. The mechanical systems will allow easy connection to future 
                        district energy systems. An electric car-share program is proposed to reduce the transportation 
	                    footprint of residents. Garden recycling and composting will reduce waste production of the seven 
	                    units to less than that of the two heritage homes (text: 
	                    <a rel="noreferrer" href="https://www.vancouverheritagefoundation.org/documents/VHF_UnionSt.pdf" onclick="window.open(this.href,'_blank');return false;">
	                    Vancouver Heritage Foundation</a>).</p><p>Project design was by <a rel="noreferrer" href="https://www.shape-arch.ca" onclick="window.open(this.href,'_blank');return false;">
	                    Shape Architecture</a> of Vancouver, BC. The project was designed for sustainability: the five 
	                    new units are being built to EnerGuide 90+ and the two heritage units to very high levels of efficiency.</p></div>`,
                    image: "/images/projects/eco-heritage-site-plan.webp"
                },
                {
                    title: "Complex Logistics",
                    body: `<div><p>Josh Klein, project supervisor, 
                        <a rel="noreferrer" href="https://www.nbhb.ca" onclick="window.open(this.href,'_blank');return false;">Natural Balance Home Builders</a>, explains:</p>
		                <p><em>&quot;The lot width is only 50' wide, yet each Heritage building measures over 21', 
		                not including roof overhangs. To excavate for the new foundations and sunken utility room, we 
		                carefully slid each building to the south end to provide sufficient space for the backhoe to operate.&quot;</em></p>
			            <p><em>&quot;Once the site was excavated to the two depths, we slid the buildings back to their 
			            original location, lifted them to a height where we could build the new insulated foundations 
			            underneath.</em><a rel="noreferrer" href="https://www.nickelbros.com/" onclick="window.open(this.href,'_blank');return false;"><em> Nickle Bros.</em></a><em> 
			            did a great job with the moving and cribbing.&quot;</em></p></div>`,
                    image: ""
                },
                {
                    title: "Excavation and Shotcreting",
                    body: `<div id="imageSlider"></div>`,
                    image: ""
                },
                {
                    title: "ICF Foundations",
                    body: `<div id="imageSlider"></div>`,
                    image: ""
                },
                {
                    title: "Concrete Pour",
                    body: `<div id="imageSlider"></div>`,
                    image: ""
                }
            ]
        },
        {
            id: "naikoonCLM",
            menuItem: {
                en: {
                    title: "Naikoon CLM",
                    url: "monopour/mpss/projects/naikoon-clm",
                    metaTitle: "Naikoon CLM | Sustainable Construction with Fab-Form Monopour Foundations",
                    metaDescription: "Naikoon Contractors use Fab-Form Monopour foundations for a sustainable construction project in North Vancouver, ensuring precision and energy efficiency.",
                }
            },
            category: "monopour",
            cardTitle: "Naikoon uses Monopour",
            cardDescription: `Central Lonsdale goes modern with the Fastfoot monopour...`,
            cardImage: "/images/fab-form-projects-naikoon-clm.webp",
            title: "Naikoon and Sustainable Construction",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/Ryq3-2k9NB4",
                    title: "Fab-Form Monopour®: Naikoon Contractors",
                    splashScreen: "/images/fab-form-monopour-naikoon-contractors-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<div><p>Naikoon Contracting Ltd., located in North Vancouver, BC, has an excellent reputation for 
                        green construction. The company was the Built Green BC Builder of the year in 2011 and has twice 
                        constructed the most innovative Built Green Home.</p><p>This project, designed by Mark Kerschbaumer, 
                        gives a sense of modernity to Central Lonsdale. <em>"We have been building green long before it 
                        became fashionable"</em>, confirmed Joe Geluch, President.<em>"Part of our sustainable package 
                        on this project was the Fab-Form Monopour. It is an economic method of forming foundations 
			            that prevents ground moisture from entering the foundation while providing R24 thermal protection."</em></p></div>`,
                    image: "/images/projects/naikoon-1.webp"
                },
                {
                    title: "",
                    body: `<p>This drawing shows the components which make up the full foundation, including the window 
                        bucks and other openings.</p>`,
                    image: "/images/projects/naikoon-2.webp"
                },
                {
                    title: "",
                    body: `<p>ICF components, including the Fastfoot® footing forms are delivered to the jobsite, 
                        awaiting assembly by the Naikoon crew.</p>`,
                    image: "/images/projects/naikoon-3.webp"
                },
                {
                    title: "",
                    body: `<p>Two levels of components have now been installed. The Zont bracing is attached to align 
                        the wall and fix into exact location with stakes at the base of each vertical strongback.</p>`,
                    image: "/images/projects/naikoon-4.webp"
                },
                {
                    title: "",
                    body: `	<p>An electric drill is used to adjust the Zuckle™ to align the wall to the stringline.</p>`,
                    image: "/images/projects/naikoon-6.webp"
                },
                {
                    title: "",
                    body: `<p>The footings are protected from ground moisture on the bottom, sides and top with the 
                        Fastfoot® membrane.</p>`,
                    image: "/images/projects/naikoon-7.webp"
                },
                {
                    title: "",
                    body: `<p>Concrete pour is almost complete, top portion of the wall is about to be filled. Note the 
                        use of Fastfoot® on all internal footings.</p>`,
                    image: "/images/projects/naikoon-8.webp"
                },
                {
                    title: "",
                    body: `<p>Concrete pour is complete, with the top of the wall being screeded by the Naikoon crew.</p>`,
                    image: "/images/projects/naikoon-9.webp"
                }
            ]
        },
        {
            id: "maisonsChicShack",
            menuItem: {
                en: {
                    title: "Maisons Chic Shack",
                    url: "monopour/mpss/projects/maisons-chic-shack",
                    metaTitle: "First Sewn Fabric Steps | Maisons Chic Shack & Fast-Tube™",
                    metaDescription: "Simon Auger of Maisons Chic Shack pioneers the use of pre-sewn fabric footing steps in remote log home projects, reducing waste and improving efficiency.",
                }
            },
            category: "monopour",
            cardTitle: "World's First: Sewn Steps",
            cardDescription: `Simon Auger, the first user of pre-sewn fabric footing steps...`,
            cardImage: "/images/fab-form-projects-sewn-steps.webp",
            title: "First Sewn Fabric Steps",
            body: ``,
            images: ["/images/projects/maisons-chic-shack-1.webp"],
            videos: [],
            articles: [
                {
                    title: "",
                    body: `<div><p>Simon Auger, President, Maisons Chic Shack of Orford, Quebec, designs and builds spectacular 
	                    log homes for his clients (visit <a rel="noreferrer" href="https://maisonschicshack.com/" onclick="window.open(this.href,'_blank');return false;">
	                        www.maisonschicshack.com</a>).</p><p>Simon is a repeat user of  Fastfoot® Monopour as his 
	                        projects are in remote locations where concrete is very expensive.</p></div>`,
                    image: ""
                },
                {
                    title: "Excavation Drawing",
                    body: `<div><p>The excavation contained two sets of three steps, each 18&quot; high by 2' or 2'-8&quot; 
	                    long (see Simon's drawing on right). The 18&quot; height matched the 
	                    <a rel="noreferrer" href="https://www.nudura.com/en/insulatedconcreteforms.aspx" onclick="window.open(this.href,'_blank');return false;">Nudura</a> 
	                    block used on this project.</p><p><em>&quot;We were very interested to try the sewn steps&quot;,
	                    </em> said Simon.<em> &quot;Fab-Form premanufactured Fastfoot® to match our excavation perfectly. 
	                    We screw-attached the fabric to the bottom edge of each component.&quot;</em></p>
	                    <p><em>&quot;It is not sustainable to cut up all this lumber to form steps - it ends up in the 
	                    landfill. Fastfoot® stays in place for the life of the building preventing rising damp.&quot;</em></p></div>`,
                    image: "/images/projects/maisons-chic-shack-2.webp"
                },
                {
                    title: "Interior View",
                    body: `<div><p>This picture shows the interior of the sewn footing step. Note the use of 
	                    <a href="/${lang}/${urls.zontBracing.overview}">Zont™ horizontal bracing</a>, which transfer 
	                    all catwalk loads directly to the ground and provides excellent alignment on these 15' 
	                    high walls.</p><p>The sewn step reduces concrete consumption by 40%&nbsp; while providing 
	                    equivalent structural stength. There is no concrete leakage when pouring into a closed form.</p>
	                    <p>The fabric-formed steps provide excellent protection against ground moisture wicking up into 
	                    the concrete.<a href="/${lang}/${urls.fastFoot.residential.risingDamp}">Read the complete discussion of rising damp</a>.</p></div>`,
                    image: "/images/projects/maisons-chic-shack-3.webp"
                },
                {
                    title: "Sustainable Formwork",
                    body: `<div><p>The photo to the right shows a typical lumber formed step. Every single piece of lumber 
                        and plywood used in this step ends up in the landfill.</p><p>With the fabric formed step, 
                        Fastfoot® stays in place for the life of the building, <a href="/${lang}/${urls.fastFoot.residential.risingDamp}">
                        preventing rising damp</a>. Not a single piece of lumber is wasted with this technology.</p>
	                    <p>Lumber formed footing steps are unsustainable: As the lumber is an open form, concrete fines 
	                    leach into groundwater, polluting both the water table and ultimately the landfill.</p></div>`,
                    image: "/images/projects/maisons-chic-shack-4.webp"
                },
                {
                    title: "Premanufactured Bucks",
                    body: `<div><p>The premanufactured door and window bucks are ready to be installed in the foundation. 
	                    Note the 2&quot; of extruded polystyrene on the outside the buck which provides a thermal break 
	                    between the wooden buck and concrete.</p><p><em>&quot;Conditions in our winter are very severe&quot;</em>, 
	                    said Simon Auger. <em>"Adding the thermal break ensures the concrete remains warm, even in the coldest 
	                    weather."</em></p><p><em>&quot;Conditions dans notre hiver sont très sévères&quot;, a déclaré Simon
	                    Auger. &quot;Placer la coupure thermique assure le béton reste au chaud, même par temps très froid.&quot;</em></p></div>`,
                    image: "/images/projects/maisons-chic-shack-5.webp"
                },
                {
                    title: "Ready for Concrete",
                    body: `<div><p>The 15' high Nudura® wall and Fastfoot® Monopour are ready for concrete. Walls are 
	                    braced with <a href="/${lang}/${urls.zontBracing.overview}">Zont™ bracing</a>, the horizontal 
	                    bracing system ideal for ICF monopours. Safety regulations are very strick in Quebec, as can be 
	                    seen from the catwalk railings in the interior. OSHA only requires railings if the height of 
	                    the catwalk above the ground is greater than 6' in height.</p></div>`,
                    image: "/images/projects/maisons-chic-shack-6.webp"
                },
                {
                    title: "View Showing Steps",
                    body: `<div><p>The picture to the right shows the steps dropping off 4' - 6&quot; beside on each side 
                        of the closest corner.</p><p>Sewn Fastfoot® steps eliminate all rigid formwork, including plywood 
                        bulkheads and side forms. Concrete usage is reduced by 40%&nbsp; over lumber formed steps while 
                        providing equivalent structural strength.</p><p>Lumber formed steps provide no protection against 
	                    ground moisture wicking up into the concrete.<a href="/${lang}/${urls.fastFoot.residential.risingDamp}">Learn more about rising damp and how to prevent it</a>.</p></div>`,
                    image: "/images/projects/maisons-chic-shack-7.webp"
                },
                {
                    title: "Poured Foundation",
                    body: `<div><p>This final picture shows the foundation after pouring concrete. Bracing has been removed 
                        and the 'peel and stick' moisture protection is being installed prior to backfilling. 
                        Another successful foundation by <a rel="noreferrer" href="https://www.maisonschicshack.com" onclick="window.open(this.href,'_blank');return false;">
                        Maisons Chic Shack</a>.</p><p><em>"Nous sommes très heureux de la performance de Fastfoot® 
                        Monopour"</em>, a déclaré Simon Auger. <em>"Il réduit nos coûts de façon significative en béton 
                        tout en offrant une excellente précision supérieure du mur."</em></p><p><em>&quot;We are very 
                        pleased with the performance of Fastfoot® Monopour®&quot;</em>, said Simon Auger. 
                        <em>&quot; It reduces our forming costs	significantly while providing excellent top of wall 
                        accuracy.&quot;</em></p></div>`,
                    image: "/images/projects/maisons-chic-shack-8.webp"
                }
            ]
        },
        {
            id: "usar",
            menuItem: {
                en: {
                    title: "Usar",
                    url: "monopour/mpss/projects/usar",
                    metaTitle: "Dark Leaky Basement Replaced with Warm, Dry Living Area | Usar Design Build",
                    metaDescription: "Usar Contracting and Design replaces a damp basement with an insulated and dry foundation, using the Fab-Form Monopour system for enhanced performance.",
                }
            },
            category: "monopour",
            cardTitle: "Damp & leaky basement",
            cardDescription: `Usar Contracting and Design replaces a damp basement with a warm and dry...`,
            cardImage: "/images/fab-form-projects-usar.webp",
            title: "Dark leaky basement replaced with Warm, Dry Living Area",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/ogcuv0CUn7w",
                    title: "Fastfoot® ICF Monopour: Usar Design Build",
                    splashScreen: "/images/fastfoot-icf-monopour-usar-design-build-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<div><p>Harmeet Singh Grewal of Usar Contracting and Design Inc., recently replaced a damp and 
			            leaking basement with an insulated dry foundation under a 1950's house on East 2nd Avenue, 
			            Vancouver, BC.</p><p>Harmeet has used the Monopour System on two projects.<em> &quot;I like the 
			            Monopour System&quot;</em>, confirmed Harmeet. <em>&quot;As we eliminate the double pour, we 
			            save a couple of weeks in forming time. This means we have minimal liability of the banks 
			            collapsing. As well, we achieve a top of wall accuracy of an eight of an inch.&quot;</em></p>
			            <p>The basement replacement is part of a major renovation designed and managed by Mila Djuras, of
			            <a rel="noreferrer" href="https://www.interminddesign.com" onclick="window.open(this.href,'_blank');return false;">Intermind Design</a>. <em>&quot;This 
			            is a complete rebuild for the owners&quot;</em>, said Mila. <em>&quot;What was once a damp and 
			            leaky basement, not even suitable for storage, is being replaced with a warm and dry full height 
			            master bedroom and office area. The master bedroom is located on the south end and has access 
			            to a patio and rear garden. A lot of thought was given to window size and location to ensure 
			            natural light streams into this lower level.&quot;</em></p><p>The owners, Craig Neville and Beverly 
			            Pister, are very particular about their new home. <em>&quot;Vancouver home owners have suffered 
			            billions of dollars of water damage due to faulty construction&quot;</em>, said Craig. 
			            <em>&quot;Bev and I are very pleased with the new foundation, and the precautions Mila and 
			            Harmeet have taken to ensure ground moisture does not end up inside our master bedroom and 
			            office.&quot;</em></p><p><a href="/${lang}/${urls.fastFoot.residential.risingDamp}">Learn more about Fastfoot® and rising damp prevention</a>.</p></div>`,
                    image: ""
                },
                {
                    title: "",
                    body: `<div id="imageSlider"></div>`,
                    image: ""
                }
            ]
        },
        {
            id: "econUbc",
            menuItem: {
                en: {
                    title: "Econ UBC",
                    url: "monopour/mpss/projects/econ-ubc",
                    metaTitle: "Fab-Form Monopour & Panelized Housing | Econ Group Construction",
                    metaDescription: "Econ Group Construction uses Fab-Form Monopour for an efficient foundation system, perfect for pre-manufactured panelized homes in Vancouver.",
                }
            },
            category: "monopour",
            cardTitle: "Fab-Form MP & Panelized Homes",
            cardDescription: `Fab-Form Monopour makes so much sense with premanufactured housing.`,
            cardImage: "/images/fab-form-projects-econ-ubc.webp",
            title: "Fab-Form Monopour & Panelized Housing",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/hQEZyEkS0AM",
                    title: "ICF Monopour Project: Pre-Fabricated Sip Panels",
                    splashScreen: "/images/icf-monopour-project-pre-fabricated-sip-panels-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<div><p><a rel="noreferrer" href="https://www.econgroup.ca" onclick="window.open(this.href,'_blank');return false;">The Econ Group</a>,a Design/Build 
                        Contractor in Vancouver BC, recently installed a Monopour foundation for a panelized single 
                        family dwelling on the West Side of Vancouver.</p><p><em>&quot;We insisted on the Monopour for 
                        this project&quot;</em>, confirmed Mike Dutson, a Partner with Econ. <em>&quot;We needed a 
                        foundation wall accuracy of 1/8&quot; because all the floors, walls and roof were pre-manufactured. 
                        We achieved these tolerances easily using the drill adjustable side supports and Zont™ bracing.&quot;</em></p>
			            <p>The project architect was Kenneth Chooi of <span class="font-bold">DSK Architecture</span>, Vancouver BC 
			            (604.448.2102). DSK Architecture specializes in sustainable and energy efficient design for the 
			            residential market.</p><p>Floor, wall and roof panels were supplied by 
			            <a rel="noreferrer" href="https://www.cutmytimber.com" onclick="window.open(this.href,'_blank');return false;">CutMyTimber, Inc.</a>, with offices in 
			            Canada and the USA.</p></div>`,
                    image: ""
                },
                {
                    title: "",
                    body: `<div id="imageSlider"></div>`,
                    image: ""
                }
            ]
        },
        {
            id: "howeSoundIsland",
            menuItem: {
                en: {
                    title: "Howe Sound Island",
                    url: "monopour/mpss/projects/howe-sound-island",
                    metaTitle: "Two Foundations, Two Days, Two Men | Fab-Form Monopour on Howe Sound Island",
                    metaDescription: "Jamieson Merrit sets a new record on Howe Sound Island, completing two foundations in just two days with the Fab-Form Monopour system.",
                }
            },
            category: "monopour",
            cardTitle: "2 Foundations, 2 Days, 2 Men",
            cardDescription: `Jamieson Merrit sets a new record on remote island...`,
            cardImage: "/images/fab-form-projects-jamieson.webp",
            title: "Two ICF Foundations, Two Days, Two Men",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/iERAIOCTLP8",
                    title: "Fab-Form ICF Monopour: 2 Foundations, 2 Men, 2 Days",
                    splashScreen: "/images/fab-form-icf-monopour-2-foundations-2-men-2-days-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<div><p>Jamieson Merrit, President, Arbutus Point Developments Ltd., is a green custom home 
                        builder located in West Vancouver, BC.</p><p>He recently completed two foundations on a small 
                        island in Howe Sound, BC. The foundations included all footings, 12 exterior rectangular columns, 
                        interior footings and skim coats. Jamieson began Wednesday morning and poured Friday morning.</p>
	                    <p>The project was complicated by its remote location as all materials had to be barged in.</p></div>`,
                    image: ""
                },
                {
                    title: "Howe Sound Island",
                    body: `<div><p>This small island, just over a mile long, is located about 15 miles west of the city of 
                        Vancouver, at the entrance to Howe Sound.</p><p>The thirty co-op owners have cottages typically 
                        with wooden posts and pads to support the floor structure. However the damp climate and rising 
                        ground moisture causes the posts and floor systems to rot over time.</p>
	                    <p>As well, muscrats find holes in the wooden skirting and bring their clams and crabs into the 
	                    crawl space to enjoy a dry meal.</p>
	                    <p>The smell of the rotting leftovers is too much for some of the island residents.</p></div>`,
                    image: "/images/projects/howe-sound-island-beach.webp"
                },
                {
                    title: "New Cottage & Bunk House",
                    body: `<div><p><em>"Our cabin had sadly met the end of it's life"</em>, said Jamieson.<em>"We wanted a 
	                    new cottage with a permanent foundation that would be 'muscrat unfriendly."</em></p><p>His plans 
	                    called for a main cottage with 830 square feet on the main floor and 570 square feet upstairs, 
	                    with a bunk house located about 40' north with 390 square feet on one floor.</p><p>The two 
	                    buildings were designed by <a rel="noreferrer" href="https://www.osburnclarke.com/" onclick="window.open(this.href,'_blank');return false;">Osburn/Clarke Productions</a> 
	                    of Vancouver, BC, a firm specializing in remote location homes. Project engineer was Andy Gray 
	                    of<a rel="noreferrer" href="https://www.informengineering.com" onclick="window.open(this.href,'_blank');return false;"> Inform Engineering Ltd.</a></p></div>`,
                    image: "/images/projects/cottage-bunkhouse.webp"
                },
                {
                    title: "Fab-Form Monopour",
                    body: `
                        <div><p><em>"I was attracted to the monopour because it allowed me to pour the fooings, wall, 
	                    interior footings and skim coat all in one go."</em></p><p>As the footing is formed with Fastfoot®, 
	                    there was no lumber in the concrete - and no future rotting.</p><p>Fastfoot® is a damp proof 
	                    membrane so ground moisture can't wick up into the crawl space. This is important as the homes 
	                    are unoccupied for half the year.</p><p><em>"The speed and light weight of the system was also 
	                    very appealing. As the foundation is completely pre-manufactured, the only site work 
	                    was the erection of components and form alignment. We began the foundations Wednesday morning 
	                    and poured Friday."</em></p></div>`,
                    image: "/images/projects/bunk-house-pour.webp"
                },
                {
                    title: "Foundation Design",
                    body: `
                        <div>
                        <p>The design was restricted by the volume of concrete carried on the barge: three concrete 
                        trucks, each with 9 cubic meters.</p><p>Jamieson wanted as much storage space in the main cottage 
                        crawl space as possible: so the height was set at 46" (40" stem wall, 8" footing less the 2" skim coat).</p>
	                    <p>In the bunk house, the crawl space height was reduced to 28" to save  concrete.</p>
	                    <p>In addition there were 12 rectangualr columns supporting porch overhangs requiring more concrete.</p>
	                    <p>Concrete was supplied by Lafarge and placed by Jim's crew at
	                    <a rel="noreferrer" href="https://www.sutherlandconcrete.com" onclick="window.open(this.href,'_blank');return false;">Sutherland Concrete and AJ's Concrete Pumping</a>.</p>
                        </div>`,
                    image: "/images/projects/concrete-on-barge.webp"
                },
                {
                    title: "",
                    body: `<div id="imageSlider"></div>`,
                    image: ""
                }
            ]
        },
        {
            id: "preAttachedFastfoot",
            menuItem: {
                en: {
                    title: "Pre-Attached Fastfoot®",
                    url: "monopour/mpss/projects/pre-attached-fastfoot",
                    metaTitle: "Pre-Attached Fastfoot® and Sewn Corners | Improved Efficiency with Fab-Form Monopour",
                    metaDescription: "Fab-Form Monopour system now features pre-attached Fastfoot® and sewn corners, reducing installation time and enhancing foundation efficiency.",
                }
            },
            category: "monopour",
            cardTitle: "Fastfoot® & Sewn Corners",
            cardDescription: `Fab-Form Monopour just got that much better. These improvements increase efficiency...`,
            cardImage: "/images/fab-form-projects-sewn-corner.webp",
            title: "Pre-attached Fastfoot® and Sewn Corners",
            body: `<p>A recent project of Chateau Homes used the Fastfoot® Monopour System with pre-attached Fastfoot® 
                and sewn corners.</p><p><em>&quot;We have done three monopour projects &quot;</em>, said Peter Francis, 
                President of Chateau Homes Ltd., <em>&quot;but installing and folding fabric on the jobsite always took 
                a fair bit of time. This project had the fabric pre-attached with sewn corners. It took less 
		        than a day to get the basics of the ICF foundation complete.&quot;</em></p>
		        <p>Learn how to install the monopour system with sewn corners <a href="/${lang}/${urls.monopour.mpss.installation}">on the installation page</a>.</p>`,
            images: ["/images/projects/pre-attached-fastfoot.webp"],
            videos: [
                {
                    video: "https://www.youtube.com/embed/oPKYmSg8wM4",
                    title: "Pre-attached Fastfoot® and Sewn Corners",
                    splashScreen: "/images/pre-tfoot-and-sewn-corners-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "Pre-Attached Fastfoot®",
                    body: `
                        <div id="imageSlider"></div>
	                    <div class="article_textWrapper">
                        <p>Foundation components are now manufactured with pre-attached footing fabric, saving 
                        contractors time on the jobsite.</p>
	                    <h2>Sewn Corners</h2>
	                    <p>Sewn corners, T-junctions and steps are now available in three sizes: 50&quot;, 62&quot; and 
	                    74&quot;, with custom sizes also available.</p><p><em>&quot;We listened to our customers&quot;
	                    </em>, said Richard Fearn, Fab-Form Industries. <em>&quot;They told us folding and attaching the 
	                    fabric was a challenge. We eliminated these steps and streamlined the monopour system yet again.&quot;</em></p>
	                    </div>
                        `,
                    image: ""
                }
            ]
        },
        {
            id: "testimonialNewsRelease",
            menuItem: {
                en: {
                    title: "Testimonial News Release",
                    url: "monopour/mpss/projects/testimonial-news-release",
                    metaTitle: "Contractor Testimonials on Fab-Form Monopour | Builders Share Their Success Stories",
                    metaDescription: "Seven contractors discuss their successful projects using the Fab-Form Monopour system, highlighting its efficiency and cost-saving benefits.",
                }
            },
            category: "monopour",
            cardTitle: "Contractor Testimonials",
            cardDescription: `Seven contractors discuss the Fab-Form Monopour System...`,
            cardImage: "/images/fab-form-projects-harold-stevenson.webp",
            title: "",
            body: ``,
            images: ["/images/projects/monopour-test-imonials.webp"],
            videos: [],
            articles: [
                {
                    id: 0,
                    title: ``,
                    body: `
	                    <div id="imageSlider"></div>
	                    <div class="article_textWrapper">
	                    <h3>Harold Stephenson<br/>Sandpoint,ID USA<br/>ICF block: BuildBlock®</h3>
                        <p><em>Thanks for the MP system.  Our project would have had a major problem using a 
                        conventional foundation system. With your MP system we got the major part of the foundation 
                        built in one day. A little more rebar and buttoning up the Fastfoot and we're ready to pour.&quot;</em></p>
	                    <p>&quot;<em>We would have spent a few thousand dollars more to blast and level the site but 
	                    with your system it saved us both a bunch of money and time. We had some extra MP legs, so when 
	                    we found a better spot to locate a leg we just moved them around and added them where we thought 
	                    there might be problems. We have rebar drilled into the granite so the foundation isn't going 
	                    anywhere unless the mountain decides to move. The back right side corner steps down 48" and it, 
	                    too, is tied into solid granite.&quot;</em></p><p><em>&quot;Everything with this project was a 
	                    new experience for us; ICFs, Fastfoot, and the MP supports. You can see the rock we built over 
	                    the top of and the one deep hole at the North East end we easily stepped down 4' with only the 
	                    block, Fastfoot, and MP supports. It was a tight site with difficult, rocky ground, but with the 
	                    MP system it was possible to build within budget, on schedule and with limited manpower.”</em></p>
                        </div>`,
                    image: ""
                },
                {
                    id: 1,
                    title: ``,
                    body: `
	                    <div id="imageSlider"></div>
	                    <div class="article_textWrapper">
	                    <h3>Blaine Johns<br/>Arctic West ICF<br/>West Haven, UT<br/>ICF block: BuildBlock®</h3>
			            <p><em>&quot;By using the Monopour system I have found it is more work for my crew, but my walls are dead on level, 
			            the ICF block interlocks better, and in the long run I save money.&quot;</em></p>
			            <p><em>&quot;No longer am I paying for an extra pump truck, 
			            J bars for the footings, and the footings subcontractor. I'm not worried about the footing subcontractor getting my 
			            footings perfectly level or spending time to shim the ICF Block on top of the footing to make the wall level.&quot;</em></p>
			            <p><em>&quot;This afternoon I just got though stacking the second level of a 16 foot wall.  It was dead on level. I didn't have to add 
			            shims anywhere on the wall. All I did was adjust the monopour system to the laser level after the fourth row of ICF 
			            block. It was easy to adjust the block level to the laser. It made my job a lot easier than doing it the old way.&quot;</em></p>
			            <p><em>&quot;After pouring a large home we're tired and the last thing we want to do is spend a lot of time straightening all 
			            the walls. We found that attaching the Zonts to the top of the wall, our time spent adjusting each brace to create 
			            a straight wall was reduced greatly and the wall came in perfectly. Instead of each brace working independently of 
			            each other, now the wall was moving more as a unit.  We will not pour without them and recommend them to all of our 
			            customers that pour their own homes.&quot;</em></p>
                        </div>`,
                    image: ""
                },
                {
                    title: ``,
                    body: `
	                    <div id="imageSlider"></div>
	                    <div class="article_textWrapper">
	                    <h3>Arden Robitaille, Perry Rosseau<br /><a rel="noreferrer" href="https://www.robro.ca" onclick="window.open(this.href,'_blank');return false;">
	                        Robro Construction</a><br/>Carp, ON Canada<br/>ICF block: IntegraSpec®</h3>
	                    <p><em>&quot;Here are some pics I took from the job we did. These pics are before the pour.</em></p>
	                    <p><em>The pour went without a hitch, no blow-outs and no leaks. The fab-form works great. The Mono-pour was a success. 
	                    We figure we saved a day or 2 by doing the pour this way.&quot;</em></p>
	                    <p>Arden Robitaille,&nbsp; President<br />Perry Rosseau, Vice-President</p>
                        </div>`,
                    image: ""
                },
                {
                    title: ``,
                    body: `
	                    <div id="imageSlider"></div>
	                    <div class="article_textWrapper">
	                    <h3>Robb Armstrong<br/>Sarnia, ON Canada<br/>ICF block: Nudura®</h3>
			            <p><em>&quot;Overall it's going well. My building inspector wants to be here when we pour. He has little experience with ICF and none with a 
			            fabric footing, but he is willing to watch me fail! Let's prove him wrong.&quot;</em></p>
			            <p><em>&quot;Leveling is best done at dusk or night with a self leveling laser level. I believe I am level within 1/16 or less over 40' using the 
			            laser with the sensor during the day while possible, was much more of a hassle.&quot;</em></p>
			            <p><em>&quot;Once the radiant tubing and concrete are installed, I will reinstall the Zont Bracing, so I can use the scaffolding during 
			            the floor pan installation. This will greatly improve speed and safety of that install. It wouldn't be possible to do this with 
			            vertical ICF bracing.&quot;</em></p>
			            <p><em>&quot;Well we poured the foundation and proved the inspector wrong. A perfect 
			            foundation - level and plumb.&quot;</em></p>
	                    </div>
	                    `,
                    image: "",
                    video: "https://www.youtube.com/embed/gD-rrgQcWpw"
                },
                {
                    title: ``,
                    body: `
	                    <div id="imageSlider"></div>
	                    <div class="article_textWrapper">
	                    <h3>Chris Pearson<br/>
	                        <a rel="noreferrer" href="https://www.newyorkpolysteel.com/Fast_Foot_Monopour.html" onclick="window.open(this.href,'_blank');return false;">New York Polysteel</a>
	                        <br/>Amityville, NY<br/>ICF block: ARXX®
	                    </h3>
	                    <p><em>&quot;We have been selling Fastfoot® for years, but this 
	                    was our first job with the Monopour System. We are very impressed as it eliminated most of 
	                    the site labor.&quot;</em></p>
	                    <p><em>&quot;Not only did we pre-glue the Arxx® into foundation 
	                    components, but we also preinstalled our rebar and bracing. Zont bracing 
	                    allowed us to easily move and transport the components with our forklift. We fork lifted the components 
	                    		onto a flat bed truck, and dropped them on the Fastfoot® fabric when we got on site.:We 
	                    even preinstalled the side supports onto the components in advance.&quot;</em></p>
	                    <p><em>&quot;All we had to do was level up the 
	                    		walls with the side supports, button up Fastfoot®, and stake the 
	                    strongbacks to the ground.&quot;</em></p>
	                    <p><em>&quot;The concrete pour went perfectly. The customer is very happy.&quot;</em></p>
                        </div>`,
                    image: ""
                },
                {
                    title: ``,
                    body: `
	                    <div id="imageSlider"></div>
	                    <div class="article_textWrapper">
	                    <h3>Bryan Goux<br/>B. Goux Construction<br/>Kasilof, AK<br/>ICF block: LOGIX®</h3>
			            <p><em>&quot;I had some real skeptics and old school concrete guys say it would never work.&quot;</em></p>
			            <p>&quot;<em>No problems - the walls stayed straight and level. I wish you could 
			            have seen the faces when the bags held up fine. I just smiled when nothing leaked.&quot;</em></p>
			            <p><em>&quot;Thanks for a great product!&quot;</em></p>
                        </div>`,
                    image: ""
                }
            ]
        },
        {
            id: "econKits",
            menuItem: {
                en: {
                    title: "Econ Kits",
                    url: "monopour/mpss/projects/econ-kits",
                    metaTitle: "Econ Group Kitsilano Project | FastFoot® Monopour Testimonial",
                    metaDescription: "The Econ Group in Vancouver installs a Fab-Form Monopour foundation under a single-family home in Kitsilano, showcasing efficient construction with FastFoot®.",
                }
            },
            category: "monopour",
            cardTitle: "Econ Group Construction",
            cardDescription: `Vancouver design/build firm installs components in two hours...`,
            cardImage: "/images/fab-form-projects-econ-kitsilano.webp",
            title: "Econ Group - Kitsilano Project",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/K6qB8LqgRWY",
                    title: "FastFoot® Monopour Testimonial - Econ Group",
                    splashScreen: "/images/fastfoot-monopour-testimonial-econ-group-youtube.webp"
                }
            ],
            articles: [
                {
                    title: "",
                    body: `<p><a rel="noreferrer" href="https://www.econgroup.ca">The Econ Group</a>, a Design/Build Contractor in 
                        Vancouver BC, installed a foundation under an existing single family dwelling on the West Side of 
			            Vancouver. The Econ Group promotes environmentally responsible building and low-impact, 
			            sustainable housing. The group focuses on modern minimalist architecture.</p>`,
                    image: "/images/projects/econ-project.webp"
                }
            ]
        },
        {
            id: "robertBiersteker",
            menuItem: {
                en: {
                    title: "Robert Biersteker",
                    url: "monopour/mpss/projects/robert-biersteker",
                    metaTitle: "Fab-Form Monopour & Stem Wall Foundations | Robert Biersteker",
                    metaDescription: "Robert Biersteker uses Fab-Form Monopour with stem walls for precise foundation work under a pre-manufactured Viceroy Home.",

                }
            },
            category: "monopour",
            cardTitle: "Fastfoot® MP & Stem Walls",
            cardDescription: `Fastfoot® Monopour works perfectly with stem wall foundations...`,
            cardImage: "/images/fab-form-projects-rb.webp",
            title: "Fab-Form Monopour & Stem Wall Foundations",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/8WCgU7zA1Zo",
                    title: "Fastfoot® ICF Monopour: Stem Wall Construction",
                    splashScreen: "/images/fastfoot-icf-monopour-stem-wall-construction-youtube.webp"
                }
            ],
            articles: [
                {
                    id: 0,
                    title: "",
                    body: `<div><p>Robert Biersteker, homeowner and builder, recently installed a stem wall foundation using 
                        the Fastfoot® Monopour System.</p><p><em>&quot;Our home is pre-manufactured by 
                        <a rel="noreferrer" href="https://www.viceroy.com" onclick="window.open(this.href,'_blank');return false;">Viceroy Homes</a>&quot;, </em>said Robert. 
                        <em>&quot;So we required a foundation accurate within 1/8&quot; to fit the panels. We chose 
                        Fab-Form and their premanufactured foundation components.&quot;</em></p><p><em>&quot;I'm glad we 
                        did for two reasons: first, we got a perfectly accurate foundation; and second, as I'm using 
                        the crawl space to hold my pipe organs, I needed it to be really dry. The combination of drainage 
                        layer and Fastfoot® prevents all ground moisture from wicking up.&quot;</em></p></div>`,
                    image: ""
                },
                {
                    id: 1,
                    title: "",
                    body: `<div id="imageSlider"></div>`,
                    image: ""
                }
            ]
        },
        {
            id: "modHome",
            menuItem: {
                en: {
                    title: "ModHome Developments",
                    url: "monopour/mpss/projects/modhome-developments",
                    metaTitle: "Modular ICF Foundations | Fab-Form Monopour with ModHome Developments",
                    metaDescription: "ModHome Developments uses Fab-Form Monopour foundations for modular homes in Yellowknife, ensuring durability and accuracy in extreme conditions.",
                }
            },
            category: "monopour",
            cardTitle: `"Modular" ICF Foundations`,
            cardDescription: `Steve Thomson of Modhomes, discusses foundations over rock...`,
            cardImage: "/images/fab-form-projects-mod-home.webp",
            title: "MODHOME Developments Uses Fab-Form Monopour Foundations",
            body: `<div><p>Steven Thomson, P Eng, Project Manager with <a rel="noreferrer" href="https://www.modhomedev.com" onclick="window.open(this.href,'_blank');return false;">
                Modhome Developments</a> of Yellowknife, Northwest Territories recently used Fab-Form Monopour Foundations 
                under several duplex developments which used modular units.</p><p>&quot;<em>Our situation is unique in 
                two ways&quot;</em>, said Steven, <em>&quot;first, ground conditions in Yellowknife are granite; and 
                second, we are setting modular units onto our foundations, not site building. This means we need accurate 
                foundations that can accomodate uneven ground conditions.&quot;</em></p></div>`,
            images: ["/images/projects/modhome-main.webp"],
            videos: [],
            articles: [
                {
                    id: 0,
                    title: "Site Conditions, Excavation, Pinning",
                    body: `<div id="imageSlider"></div>
	                    <div class="article_textWrapper">
	                    <p>Ground conditions in the Northwest Territories of Canada are solid granite. This means 
                        that site preparation is a large and important part of the builder's budget. Conforming to 
                        uneven rock is often much cheaper than blasting - the builder's experience plays a big part 
                        in cost reduction.</p></div>`,
                    image: ""
                },
                {
                    id: 1,
                    title: "Installing and Pouring Fab-Form Monopour",
                    body: `<div id="imageSlider"></div>
	                    <div class="article_textWrapper">
	                    <p>The crawlspace foundation was 8" in thickness around the perimeter with a 12" stem wall 
	                    between the two duplex units. The pour went well with no blowouts and perfect wall alignment. 
	                    Fab-Form dealer for this project was Adam Montonen,<a rel="noreferrer" href="https://www.korpack.ca" onclick="window.open(this.href,'_blank');return false;">
	                    Korpack Cement Products</a>, Trail BC.</p></div>`,
                    image: ""
                },
                {
                    id: 2,
                    title: "Modular Installation",
                    body: `<div id="imageSlider"></div>
	                    <div class="article_textWrapper">
	                    <p>Four modular units were craned onto the crawlspace foundation to make up the two duplex units. 
	                    For additional information on Modhomes, go to<a rel="noreferrer" href="https://www.modhomedevelopments.com/" onclick="window.open(this.href,'_blank');return false;">
	                    www.modhomedevelopments.com</a>.</p></div>`,
                    image: ""
                }
            ]
        },
        {
            id: "harmonyHouse",
            menuItem: {
                en: {
                    title: "Harmony House",
                    url: "monopour/mpss/projects/harmony-house",
                    metaTitle: "Modular ICF Foundations | Fab-Form Monopour with ModHome Developments",
                    metaDescription: "ModHome Developments uses Fab-Form Monopour foundations for modular homes in Yellowknife, ensuring durability and accuracy in extreme conditions.",

                }
            },
            category: "monopour",
            cardTitle: "Harmony House",
            cardDescription: `Net Zero home being constructed in Burnaby BC, sponsored by CMHC and filmed by Sustainability Television...`,
            cardImage: "/images/fab-form-projects-harmony-house.webp",
            title: "What is the Harmony House?",
            body: `<div><p>The Harmony House is one of the winners in the Canada Mortgage and Housing Corporation (CMHC)
	            <a rel="noreferrer" href="https://www.cmhc.ca/en/en_001.cfm" onclick="window.open(this.href,'_blank');return false;">EQuilbrium™ Sustainable Housing Demonstation 
	            Initiative</a>, a national initiative to design, build and demonstrate sustainable homes throught Canada. 
	            (View the <a rel="noreferrer" href="https://www.cmhc-schl.gc.ca/odpub/pdf/66407.pdf?lang=en" onclick="window.open(this.href,'_blank');return false;">CMHC project overview</a>.)
                </p><p>The mission of the <a rel="noreferrer" href="https://www.harmony-house.ca" onclick="window.open(this.href,'_blank');return false;">
	            Harmony House team</a> is to design and build a home that features a healthy indoor environment, energy 
	            efficiency, low environmental impact, significant resource conservation, and that produces as much energy 
	            as it consumes in a year (a net-zero energy home) from on-site renewable energy systems.</p>
	            <h3>Project Team (foundation work)</h3>
	            <ul>
	            	<li>Green Consultant & Project Designer: 
	            	<a rel="noreferrer" href="https://www.harmony-house.ca" onclick="window.open(this.href,'_blank');return false;">Habitat Design & Consulting</a>,
	            	<a href="mailto:mattock@helix.net">Chris Mattock</a>, Principal, 604.264.7944</li>
	            	<li>Green Builder: <a rel="noreferrer" href="https://www.insightful.ca" onclick="window.open(this.href,'_blank');return false;">Insightful Healthy Homes</a>, 
	            	<a href="mailto:arthur@insightful.ca">Arthur Lo</a>, Principal, 604.608.2771</li>
	            	<li>Structural Engineer: <a rel="noreferrer" href="https://www.k-ito.ca" onclick="window.open(this.href,'_blank');return false;">K Ito & Associates</a>, 
	            	<a href="mailto:ito@k-ito.ca">Kimi Ito</a>, Principal, 604.205.5222</li>
	            	<li>Green Media Consultant:<a rel="noreferrer" href="https://www.sustainabilitytelevision.com" onclick="window.open(this.href,'_blank');return false;">
	            	Sustainability Television</a>,
	            	<a href="mailto:info@sustainabilitytelevision.com">Jason Robinson</a>, Principal, 604.685.8846</li>
	            	<li>ICF Supplier: <a rel="noreferrer" href="https://quad-lock.com">Quad-Lock Building Systems</a>, Douglas Benion, 
	            	Manager of Technical Training</li>
	            </ul>
	        </div>`,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/criHNXmaeMM",
                    title: "The Harmony House Monopour",
                    splashScreen: "/images/the-harmony-house-monopour-youtube.webp"
                }
            ],
            articles: [
                {
                    id: 0,
                    title: "Green Consultant, Project Designer, Habitat Design &amp Consulting Ltd.",
                    body: `<div><p>Chris Mattock, Principal Consultant with <a rel="noreferrer" href="https://www.hdplusc.com" onclick="window.open(this.href,'_blank');return false;">
                        Habitat Design & Consulting</a> provided reasons for the project using the Monopour System:</p>
			            <p>&quot;There were two primary reasons we went with the system: the first 
			            is that the homeowner gets better air quality as the damp proof membrane around the footing 
			            prevents ground moisture wicking up into the concrete and working its way inside the structure.&quot;</p>
			            <p><em>&quot;The second is that system, through it's multiple efficiencies, saves the 
			            homeowner significant money. These savings reduce the substantial capital costs of achieving 
			            Net-Zero, for example the photo voltaic cells.&quot;</em></p></div>`,
                    image: "/images/projects/harmonyHouse-1.webp"
                },
                {
                    id: 1,
                    title: "Installing Fastfoot®",
                    body: `<div><p>The pre-manufactured ICF components are laid around the perimeter of the foundation.</p>
			            <p>Harry, project supervisor, rolls Fastfoot® around the perimeter. Fastfoot® prevents ground 
			            moisture wicking up into the foundation and contaminating the indoor environment. The membrane 
			            also prevents ground water contamination by the cement fines.</p>
			            <p>This project uses an ICF with a total wall thickness of 18-1/4" producing an R-value of 45. 
			            "We require this insulation level to achieve our net-zero rating", confirmed Chris Mattock, 
			            green energy consultant of Habitat Design & Consulting.</p></div>`,
                    image: "/images/projects/harmonyHouse-2.webp"
                },
                {
                    id: 2,
                    title: "Folded corners",
                    body: `<p>Winston and Harry fold Fastfoot® around corners thereby preserving the integrity of the 
                        damp proof membrane.</p>`,
                    image: "/images/projects/harmonyHouse-3.webp"
                },
                {
                    id: 3,
                    title: "Steps with Fastfoot®",
                    body: `<div><p>Two 24&quot; steps are easily handled with Fastfoot®. An overlap equal to the footing 
                        width is placed on the top corner of the step so that the fabric edge can reach the block at the corner.</p>
			            <p>The project had 8 steps for a total elevation change of 16'.</p></div>`,
                    image: "/images/projects/harmonyHouse-4.webp"
                },
                {
                    id: 4,
                    title: "Installing Components",
                    body: `<p>Harry quickly levels up the pre-manufactured components using his laser level and portable 
                        drill. The adjusters on the side supports are available in two lengths: for footings from 7&quot; 
                        to 12&quot; and from 11&quot; to 16&quot;.</p>`,
                    image: "/images/projects/harmonyHouse-5.webp"
                },
                {
                    id: 5,
                    title: "Cutting Step Components",
                    body: `<p>Winston scribes the height of the footing on the side of the foam, and cuts the edge with a sawzall.</p>`,
                    image: "/images/projects/harmonyHouse-6.webp"
                },
                {
                    id: 6,
                    title: "Installing Step Components",
                    body: `<p>Step components are installed up the banks, maintaining the footing height between the bank and ICF block.</p>`,
                    image: "/images/projects/harmonyHouse-7.webp"
                },
                {
                    id: 7,
                    title: "Completing the wall",
                    body: `<div><p>Once the premanufactured components were installed, ICF specialist Cyril Parker 
                        completed the balance of the wall. Wall heights varied from 5' to 10'.</p>
			            <p class="testimonial">&quot;This system is <span class="font-bold">great</span> as it eliminates all the 
			            problems of getting the footing level!&quot;, exclaimed Cyril. <em>&quot;With ICFs, you 
			            can't use a leveling strip at the top, so you need to get the footing dead accurate. The 
			            monopour system eliminates all the shimming, foaming and cutting down of the blocks which happens 
			            when your pour the footing first.&quot;</em></p></div>`,
                    image: "/images/projects/harmonyHouse-8.webp"
                },
                {
                    id: 8,
                    title: "Attach Fastfoot®",
                    body: `<p>1-1/2" screws and 1" fender washers are used to attach Fastfoot® to each of the ties.</p>`,
                    image: "/images/projects/harmonyHouse-9.webp"
                },
                {
                    id: 9,
                    title: "Pouring concrete",
                    body: `<p>An hour was allowed for the first lift to go off. Here the placer is filling up the balance of the wall.</p>`,
                    image: "/images/projects/harmonyHouse-10.webp"
                },
                {
                    id: 10,
                    title: "The Perfect Footing, Fastfoot®",
                    body: `<p>No stakes, no lumber, complete protection against ground moisture.</p>`,
                    image: "/images/projects/harmonyHouse-11.webp"
                },
                {
                    id: 11,
                    title: "Steps",
                    body: `<p>The steps did not use a single piece of forming lumber. And Fastfoot® stays in place to 
                        provide complete protection against rising damp from ground moisture.</p>`,
                    image: "/images/projects/harmonyHouse-12.webp"
                },
                {
                    id: 12,
                    title: `"Zont" Bracing`,
                    body: `<p>The <a href="/${lang}/${urls.zontBracing.overview}">"ZONT" horizontal bracing system</a> 
                        was used to align the walls. The slot in the zont bracket permits up to 1&quot; of compression on the 
			            ICF wall during the concrete pour.</p>`,
                    image: "/images/projects/harmonyHouse-13.webp"
                }
            ]
        },
        {
            id: "tallWall",
            menuItem: {
                en: {
                    title: "Tall Wall",
                    url: "zont-bracing/projects/tall-wall",
                    metaTitle: "23.5' Tall Wall Bracing with Zont Bracing System",
                    metaDescription: "Kelly Lipsett from DT Royal Construction discusses the success of using the Zont Bracing system for a complex ICF wall build with 23.5' tall walls.",
                }
            },
            category: "zont-bracing",
            cardTitle: "Tall Walls with Zont Bracing",
            cardDescription: `Kelly discusses his success with Zonts...`,
            cardImage: "/images/zont-bracing-versa.webp",
            title: "23.5' Tall Wall Bracing",
            body: `<div><p>Kelly Lipsett with <a rel="noreferrer" href="https://www.instagram.com/d.troyalconstruction/" onclick="window.open(this.href,'_blank');return false;"> 
                DT Royal Construction</a>, runs through how they braced this complicated ICF build with the Zont system.</p>
                <p>This was the first ICF project for the builder, <a rel="noreferrer" href="https://www.versahomes.com/" onclick="window.open(this.href,'_blank');return false;">
                Versa Homes</a>. With both 8 and 10" concrete walls, and over 215 cubic yards of concrete just in the ICF, 
                this was a challenging build.</p></div>`,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/LBU-KLLVBTY",
                    title: "Tall Wall - Zont ICF Bracing",
                    splashScreen: "/images/tall-wall-zont-icf-bracing-youtube.webp"
                }
            ],
            articles: [
                {
                    id: 0,
                    title: "",
                    body: `<p>An aerial view shows the scope of the project, with over 400 lineal feet of ICF wall.</p>`,
                    image: "/images/projects/tallWall-1.webp"
                },
                {
                    id: 1,
                    title: "",
                    body: `<p>First pour of the ICF walls. Concrete was placed roughly 11' high in this pour.</p>`,
                    image: "/images/projects/tallWall-2.webp"
                },
                {
                    id: 2,
                    title: "",
                    body: `<p>First pour almost complete. Notice the Simpson ICFVL's installed to quickly allow floor system to be built.</p>`,
                    image: "/images/projects/tallWall-3.webp"
                },
                {
                    id: 3,
                    title: "",
                    body: `<p>Day of second concrete pour. Rolling scaffold was used to build the ICF walls and install bracing.</p>`,
                    image: "/images/projects/tallWall-4.webp"
                },
                {
                    id: 4,
                    title: "",
                    body: `<p>Zat walkway bracket provides a safe platform for placing concrete. The pitched handrail provides ample room to work freely.</p>`,
                    image: "/images/projects/tallWall-5.webp"
                },
                {
                    id: 5,
                    title: "",
                    body: `<p>Complex and pitched wall heights made for a challenging build.</p>`,
                    image: "/images/projects/tallWall-6.webp"
                },
                {
                    id: 6,
                    title: "",
                    body: `<p>The versatility and flexibility of the Zont system made achieving various heights achievable.</p>`,
                    image: "/images/projects/tallWall-7.webp"
                },
                {
                    id: 7,
                    title: "",
                    body: `<p>Rainscreen installation overtop the ICF.</p>`,
                    image: "/images/projects/tallWall-8.webp"
                },
                {
                    id: 8,
                    title: "",
                    body: `<p>Beautiful exposed beams, and installation of stucco finish over the ICF walls.</p>`,
                    image: "/images/projects/tallWall-9.webp"
                }
            ]
        },
        {
            id: "mrFoundations",
            menuItem: {
                en: {
                    title: "MR Foundations",
                    url: "zont-bracing/projects/mr-foundations",
                    metaTitle: "MR Foundations Uses ZAT Brackets for Plywood Forms",
                    metaDescription: "Mark Rice discusses how he used ZAT brackets for a plywood-formed foundation project in Squamish, BC, optimizing his process.",
                }
            },
            category: "zont-bracing",
            cardTitle: "Using ZATs with plywood forms",
            cardDescription: `Mark Rice discusses his success with ZATs...`,
            cardImage: "/images/zont-bracing-mark-rice.webp",
            title: "MR Foundations uses ZAT brackets",
            body: `<div><p>Mark Rice, President, discusses his rental of ZAT brackets for his catwalk on plywood formed 
                foundation walls for a the first floor of a mixed use project in Squamish, BC.</p></div>`,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/9nalN0Gmsl4",
                    title: "Zat™ Scaffolding Walkway Bracket - Plywood Forming",
                    splashScreen: "/images/zat-scaffolding-walkway-bracket-plywood-forming-youtube.webp"
                }
            ],
            articles: [
                {
                    id: 0,
                    title: "",
                    body: `<p>The waler brackets have been installed onto one of the strongbacks. The kickers and turnbuckles will be installed shortly.</p>`,
                    image: "/images/projects/mrFoundations-1.webp"
                },
                {
                    id: 1,
                    title: "",
                    body: `<p>The walkway itself is made up of two 2x10 dimensional lumber. The hand rail and posts are made from 2x4s.</p>`,
                    image: "/images/projects/mrFoundations-2.webp"
                },
                {
                    id: 2,
                    title: "",
                    body: `<p>Kickers and turnbuckles have now been installed to align the wall with string lines.</p>`,
                    image: "/images/projects/mrFoundations-3.webp"
                },
                {
                    id: 3,
                    title: "",
                    body: `<p>Concrete pump has just arrived, forms are now ready for concrete.</p>`,
                    image: "/images/projects/mrFoundations-4.webp"
                }
            ]
        },
        {
            id: "zontTimeLapse",
            menuItem: {
                en: {
                    title: "Zont Time Lapse",
                    url: "zont-bracing/projects/zont-time-lapse",
                    metaTitle: "Zont Bracing Time Lapse - A One Day Foundation",
                    metaDescription: "Watch a time lapse video of the installation of Zont Bracing by SED Construction, showing the completion of a foundation in a single day.",
                }
            },
            category: "zont-bracing",
            cardTitle: "Zont Time Lapse Video",
            cardDescription: `See a video showing the installation of Zonts...`,
            cardImage: "/images/zont-bracing-zont-time-lapse.webp",
            title: "The one day Foundation",
            body: `<div><p>Brian Ralph with KLS Homes is a home builder in Maple Ridge, BC. This is his third ICF 
                foundation which was installed by SED Construction Ltd.</p><p>Construction of the walls began at 7:30 AM. 
                By the end of the day the foundation, including bracing, was substantially complete. The site was open 
                to the public to watch the installation and ask questions.</p></div>`,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/msKILFku3QI",
                    title: "Zont™ Insulated Concrete Form Bracing - SED Construction Timelapse",
                    splashScreen: "/images/zont-icf-bracing-sed-construction-timelapse-youtube.webp"
                }
            ],
            articles: [
                {
                    id: 0,
                    title: "",
                    body: `<p>Attendees discussing the use of Fastfoot for forming the footings and the importance of working off a level footing.</p>`,
                    image: "/images/projects/zontTimeLapse-1.webp"
                },
                {
                    id: 1,
                    title: "",
                    body: `<p>Installing the third layer of ICF. As each Nudura block is 12 square feet, installation is very quick.</p>`,
                    image: "/images/projects/zontTimeLapse-2.webp"
                },
                {
                    id: 2,
                    title: "",
                    body: `<p>Installation of the fourth course of ICF. At this point, Zont brackets are attached to the wall 5' on centre.</p>`,
                    image: "/images/projects/zontTimeLapse-3.webp"
                },
                {
                    id: 3,
                    title: "",
                    body: `<p>Two layers of Zont brackets installed around the perimeter. Windows have begun taking shape.</p>`,
                    image: "/images/projects/zontTimeLapse-4.webp"
                },
                {
                    id: 4,
                    title: "",
                    body: `<p>Walers are first installed into the cavity of the Zont bracket. Vertical strongbacks to follow shortly.</p>`,
                    image: "/images/projects/zontTimeLapse-5.webp"
                },
                {
                    id: 5,
                    title: "",
                    body: `<p>Shawn McDaniel takes a few minutes to talk to the public and answer any questions.</p>`,
                    image: "/images/projects/zontTimeLapse-6.webp"
                },
                {
                    id: 6,
                    title: "",
                    body: `<p>At the end of the day the foundation is built to height and braced. The following day 
                        window bucks will be installed, and walls will be straightened prior to the concrete pour.</p>`,
                    image: "/images/projects/zontTimeLapse-7.webp"
                }
            ]
        },
        {
            id: "plywoodVsIcf",
            menuItem: {
                en: {
                    title: "Plywood vs ICF",
                    url: "zont-bracing/projects/plywood-vs-icf",
                    metaTitle: "Cost Comparison - Plywood Forms vs ICF with Zont Bracing",
                    metaDescription: "A cost analysis comparing the use of plywood forms versus ICF with Zont Bracing, showing a 37% savings with ICF.",
                }
            },
            category: "zont-bracing",
            cardTitle: "Cost Compare",
            cardDescription: `See video and cost analysis showing ICF and Zont bracing is 37% less than plywood...`,
            cardImage: "/images/zont-bracing-plywood-vs-icf.webp",
            title: "Cost Compare - Plywood forms vs ICF",
            body: `<div><p>In the past, plywood forms have had a cost advantage over insulated concrete forms as plywood 
                provided no insulation value.</p><p>However in the 21st century, with higher energy costs, increasing 
                global temperatures and CO2 emissions, the media and public became concerned with climate change. In 
                2015 the Province of BC changed the building code, requiring all foundations to have an effective thermal 
                performance of R22. This meant that if a contractor formed his foundation with plywood, he must now 
                build an insulated 2x6 stud wall on the inside of his foundation to achieve the required thermal performance.</p>
		        <p>The table below compares costs per vertical square foot of surface area of foundation wall in Whistler 
		        BC, Canada. Speed of form installation is from 30 to 50% faster with ICFs as there are no ties to install 
		        and no formwork stripping.</p>
		        <table>
				<tr>
					<td>Cost per square foot, Whistler</td>
					<td>Plywood</td>
					<td style="background-color:#339966; color:white">ICF</td>
				</tr>
				<tr>
					<td>Form cost (plywood rental cost delivered)</td>
					<td>$1.55</td>
					<td>$4.10</td>
				</tr>
				<tr>
					<td>Labour to install and strip forms</td>
					<td>$8.15</td>
					<td>$5.71</td>
				</tr>
				<tr>
					<td>Insulated stud wall, labour & materials, R22</td>
					<td>$3.78</td>
					<td>$0.00</td>
				</tr>
				<tr>
					<td>TOTAL</td>
					<td>$13.48</td>
					<td>$9.81</td>
				</tr>
				<tr>
					<td><span class="font-bold">$ SAVINGS</span></td>
					<td></td>
					<td style="font-size:medium"><span class="font-bold">$3.68</span></td>
				</tr>
				<tr>
					<td><span class="font-bold">% SAVINGS</span></td>
					<td></td>
					<td><span class="font-bold">37%</span></td>
				</tr>
				</table>
		        </div>`,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/MyLtWfsTITo",
                    title: "Insulated Concrete Forms (ICF) VS Plywood Forming",
                    splashScreen: "/images/icf-vs-plywood-forming-youtube.webp"
                }
            ],
            articles: [
                {
                    id: 0,
                    title: "",
                    body: `<div><p><em>"I'm impressed with ICFs"</em>, confirmed Shawn. <em>"To build and pour all the walls 
                        in this five-plex, we've spent about twenty man-days. With plywood it would have taken 35 to 40 
                        man-days. Then to strip the forms I would have three men working two days. So I can bid this 
                        cheaper than conventional because it is so much faster."</em></p></div>`,
                    image: "/images/projects/plywoodVsIcf-1.webp"
                },
                {
                    id: 1,
                    title: "",
                    body: `<div><p><em>"To get a wall truly straight with plywood is tough to do, and you can't move a 
                        wall after you pour. With ICFs and <a href="/${lang}/${urls.zontBracing.overview}">Zont Bracing</a> you can 
                        move the wall up to 1/2" without any trouble."</em></p></div>`,
                    image: "/images/projects/plywoodVsIcf-2.webp"
                },
                {
                    id: 2,
                    title: "",
                    body: `<p>Getting around the jobsite is much easier with a modified four wheel drive using this 
			            completely reversible corner block.</p>`,
                    image: "/images/projects/plywoodVsIcf-3.webp"
                },
                {
                    id: 3,
                    title: "",
                    body: `<div><p>Conventional rebar was replaced by <a rel="noreferrer" href="https://www.steelfiberswest.com" onclick="window.open(this.href,'_blank');return false;">Helix®</a>. 
                        The fibers were added to the concrete at the <a rel="noreferrer" href="https://cardinalconcrete.ca/" onclick="window.open(this.href,'_blank');return false;">
                        Cardinal Concrete</a> plant in Whistler, BC. Dosage for the walls was 14.85 kg/m3.</p>
			            <p><em>"To place rebar in 160' of 12' high wall would take two days for two guys",</em> 
			            said Shawn.<em/><em> That is taken right out of the picture all together. It's just a 
			            super system, super time saver. From a business standpoint that's what it's all about."</em></p></div>`,
                    image: "/images/projects/plywoodVsIcf-4.webp"
                }
            ]
        },
        {
            id: "tripleD",
            menuItem: {
                en: {
                    title: "Triple D",
                    url: "zont-bracing/projects/triple-d",
                    metaTitle: "16' Tall Wall Bracing with Zont Bracing System",
                    metaDescription: "John Dyck from Triple 'D' Construction discusses his use of Zont Bracing for a 16' tall ICF wall, ensuring a flat and sturdy foundation.",
                }
            },
            category: "zont-bracing",
            cardTitle: "16' Tall Wall Bracing",
            cardDescription: `<em>"I like the Zonts™ for tall walls..."</em>`,
            cardImage: "/images/zont-bracing-triple-d.webp",
            title: "16' Tall Wall Bracing",
            body: ``,
            images: ["/images/projects/tripleD-1.webp"],
            videos: [],
            articles: [
                {
                    id: 0,
                    title: "16' High ICF Walls",
                    body: `<div><p>John Dyck, President, Triple "D" Construction, Salmon Arm, BC recently completed a 40' x 50' 
                        workshop with 16' high ICF walls.</p><p>John glued his first row of Logix® ICF blocks to his slab. Then at the 
	                    top of every third row of block he placed a set of Zont™ waler brackets and a horizontal waler around the 
	                    perimeter.</p><p>16' strongbacks, attached to the Zont™ waler brackets 5' on centre,&nbsp; were used to 
	                    straighten the wall vertically.</p><p>At the 8' level (6 blocks high), John placed his second set of Zont™ 
	                    brackets. Just below this bracket he attached a kicker to align the mid point of his wall.</p>
	                    <p>He plumbed his corners and then used string lines to align the wall with the drill-adjustable Zuckle™ 
	                    wall aligners.</p></div>`,
                    image: "/images/projects/tripleD-2.webp"
                },
                {
                    id: 1,
                    title: "Support For Kickers",
                    body: `<div><p>To attach the bottoms of the kickers, John ran dimensional lumber across the floor 
                        so that the bottom of opposing kickers were attached to the same lumber. This prevented any 
                        movement and eliminated the need to drill holes into the slab.</p><p>This view through the 
                        entrance way to the workshop shows the beauty of the country around Salmon Arm.</p>
	                    <p>Triple "D" Construction, (250) 517-0075, has been building in the Okanagan Valley for over 30 years.</p></div>`,
                    image: "/images/projects/tripleD-3.webp"
                },
                {
                    id: 2,
                    title: "Walkway",
                    body: `<div><p>At the 12' level, the contractor used 3/4" plywood gussets to support his 2x10 walkway.</p>
	                    <p>If a railing was required, the contractor would have placed a second vertical 2x4 16" outside 
	                    each strongback on the wall and joined the two with 2x6 horizontal members. The upper 2x6 cross 
	                    member would then support the walkway.</p><p>This railing and walkway would then conform to WCB 
	                    and OSHA safety requirements.</p></div>`,
                    image: "/images/projects/tripleD-4.webp"
                },
                {
                    id: 3,
                    title: "Poured Wall",
                    body: `<div><p>This image shows the outside of the wall after the single 16' high pour. The Logix® 
                        blocks performed without fault and the Zont™ bracing aligned the tall wall accurately.</p>
	                    <p>"I&nbsp; like the Zont™ bracing", confirmed John Dyck. "We achieved very flat walls at a 
	                    fraction of the cost of buying or renting conventional tall wall braces."</p>
	                    <p>The supplier of the Logix™ blocks and Zont™ bracing was Okanagan distributor Ken Wingenbach 
	                    of <a rel="noreferrer" href="https://www.r50.ca" onclick="window.open(this.href,'_blank');return false;">R-50 Solutions</a>.</p></div>`,
                    image: "/images/projects/tripleD-5.webp"
                }
            ]
        },
        {
            id: "upwardConstruction",
            menuItem: {
                en: {
                    title: "Upward Construction",
                    url: "zont-bracing/projects/upward-construction",
                    metaTitle: "Upward Construction: 23.5' ICF Foundation with Zont Bracing",
                    metaDescription: "John Guest of Upward Construction uses Zont Bracing for a 23.5' high ICF foundation with 14\" pilasters in West Vancouver, BC.",
                }
            },
            category: "zont-bracing",
            cardTitle: "Upward Success with Zont bracing",
            cardDescription: `John Guest discusses pilasters with Zonts...`,
            cardImage: "/images/zont-bracing-john-guest.webp",
            title: `23.5' Foundation Walls, 14" Pilasters, Zont Bracing Solution`,
            body: `<div><p>John Guest, Project Supervisor with <a rel="noreferrer" href="https://www.upwardconstruction.ca" onclick="window.open(this.href,'_blank');return false;">
                Upward Construction & Renovation Ltd.</a>, located in North Vancouver, BC, recently formed and poured 
                a their first ICF foundation with the Nudura 8" block on Queens Avenue in West Vancouver.</p>
			    <p>Michael Upward, owner and principal, moved to Canada from New Zealand. In 2002 he created Upward 
			    Construction & Renovation and for the last sixteen years he has been building on the North Shore, from 
			    large renovations to new custom homes.</p><p>Upward's project was an interesting combination of 23 1/2' high 
			    ICF foundation walls along with 14" pilasters required by the structural engineer 
			    <a rel="noreferrer" href="https://www.qxmengineering.com">QQXM Engineering Ltd.</a></p></div>`,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/w-fIyFY-aic",
                    title: "Zont™ Bracing Insulated Concrete Forms (ICF) - 23.5' high walls, 14\" Pilasters",
                    splashScreen: "/images/zont-bracing-insulated-concrete-forms-high-walls-youtube.webp"
                }
            ],
            articles: [
                {
                    id: 0,
                    title: "",
                    body: `<div><p>As can be seen in the foundation plan shown above, Structural Engineer Lily Qiu 
                        required 14" pilasters to withstand soil hydraulic loads around the perimeter of the taller walls.</p></div>`,
                    image: "/images/projects/upwardConstruction-1.webp"
                },
                {
                    id: 1,
                    title: "",
                    body: `<div><p>John's crew did an excellent job on the footings, using a laser for setup and pouring 
                        the concrete. Accuracy was less than one quarter of an inch.</p></div>`,
                    image: "/images/projects/upwardConstruction-2.webp"
                },
                {
                    id: 2,
                    title: "",
                    body: `<div><p>Two or three courses of ICF have now been laid out on the footings and glued into 
                        position. Notice (on the left side) how John has rented scaffolding to enable the construction 
                        of a ramp into the site. As materials are delivered from the north side, this was a cost effective 
                        measure to lower the cost of moving manpower and materials.</p></div>`,
                    image: "/images/projects/upwardConstruction-3.webp"
                },
                {
                    id: 3,
                    title: "",
                    body: `<div><p>In this photo, the crew are cutting slots in the ICF block so that the concrete can 
                        flow around the anchor bolts which have been pre-drilled into the ledger board. The 1-3/4" x 11-3/4" 
                        ledger was then screw attached to the ICF webs. Poly was attached to the back of the ledger 
                        board to protect against concrete damage.</p>
			            <p>On the left side of the photo can be seen the 14" pilaster, providing additional rigidity to 
			            foundation against soil hydraulic pressure.</p></div>`,
                    image: "/images/projects/upwardConstruction-4.webp"
                },
                {
                    id: 4,
                    title: "",
                    body: `<div><p>Four Zonts, one Zuckle and one Zat easily brace this 15' high wall.</p></div>`,
                    image: "/images/projects/upwardConstruction-5.webp"
                },
                {
                    id: 5,
                    title: "",
                    body: `<div><p>Vertical steel has now been installed, ready to pour concrete. Note City of Vancouver in the background.</p></div>`,
                    image: "/images/projects/upwardConstruction-6.webp"
                }
            ]
        },
        {
            id: "12hourFoundation",
            menuItem: {
                en: {
                    title: "12 Hour Foundation",
                    url: "zont-bracing/projects/12-hour-foundation",
                    metaTitle: "12 Hour Foundation Installation with Zont Bracing",
                    metaDescription: "James Hinks' 12-hour foundation installation in Chilliwack, BC, uses Zont Bracing to complete the walls, bracing, and preparation for concrete in one day.",
                }
            },
            category: "zont-bracing",
            cardTitle: "12 Hour Foundation",
            cardDescription: `See a time lapse video of a 12 hour foundation, ready for concrete...`,
            cardImage: "/images/zont-bracing-12-hour.webp",
            title: "The 12 Hour Foundation",
            body: `<div><p>James Hinks is a home builder in Chilliwack, BC. This is his first ICF foundation which was 
                installed by SED Construction Ltd.</p><p>Construction of the walls began at 8:00 AM. By the end of the day 
			    the foundation, including bracing, was substantially complete. The next day the concrete pour began at 
			    1:00 PM, with the 45 metres being poured in three and one half hours.</p></div>`,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/wa2_Ze5NHc0",
                    title: "Insulated Concrete Form (ICF) Time Lapse - Zont™ ICF Bracing",
                    splashScreen: "/images/icf-time-lapse-zont-icf-bracing-youtube.webp"
                }
            ],
            articles: [
                {
                    id: 0,
                    title: "",
                    body: `<div><p>The foundation has 271 lineal feet of wall, with a maximum wall height of 14'-3". 
                        Surface area of the walls is 2,352 square feet including 15 corners and numerous openings.</p></div>`,
                    image: "/images/projects/12hourFoundation-1.webp"
                },
                {
                    id: 1,
                    title: "",
                    body: `<div><p>The second layer of blocks is being installed, while on the far side, Zont brackets 
                        are being attached to the wall.</p></div>`,
                    image: "/images/projects/12hourFoundation-2.webp"
                },
                {
                    id: 2,
                    title: "",
                    body: `<div><p>The Zont bracing is height adaptable. This wall is 14' high - higher walls are 
                        accommodated by more levels of Zonts and walers.</p></div>`,
                    image: "/images/projects/12hourFoundation-3.webp"
                },
                {
                    id: 3,
                    title: "",
                    body: `<div><p>With the 14'-3" walls, Shawn installed four sets of horizontal walers, to ensure a 
                        straight and true concrete wall.</p></div>`,
                    image: "/images/projects/12hourFoundation-4.webp"
                },
                {
                    id: 4,
                    title: "",
                    body: `<div><p>This photo was taken at 3:56 PM on the first day. The foundation is substantially complete.</p></div>`,
                    image: "/images/projects/12hourFoundation-5.webp"
                },
                {
                    id: 5,
                    title: "",
                    body: `<div><p>The next day pour is complete, 45 cubic meters. <em>"I'm very impressed with the speed 
                        of the ICF and the bracing system"</em>, said James Hinks.</p></div>`,
                    image: "/images/projects/12hourFoundation-6.webp"
                }
            ]
        },
        {
            id: "econDeepCove",
            menuItem: {
                en: {
                    title: "Econom Deep Cove",
                    url: "zont-bracing/projects/econ-deep-cove",
                    metaTitle: "Zont Bracing for Multi-Height ICF Walls in Deep Cove",
                    metaDescription: "Econ Group uses Zont Bracing to efficiently brace multi-height ICF walls on a steep construction site near Deep Cove, North Vancouver.",
                }
            },
            category: "zont-bracing",
            cardTitle: "Zont™ Bracing  on 17' high walls",
            cardDescription: `How else do you brace a foundation that drops 28' over a distance of 60'?`,
            cardImage: "/images/zont-bracing-econ-deep-cove.webp",
            title: "ZONT™ BRACING - Ideal for multi-height ICF walls",
            body: `<div><p>This project, located on the granite cliffs near Deep Cove, North Vancouver, BC, has a 
                spectacular view overlooking the waters of Indian Arm. The general contractor is the 
                <a rel="noreferrer" href="https://www.econgroup.ca" onclick="window.open(this.href,'_blank');return false;">Econ Group</a> with excavation by
                <a rel="noreferrer" href="https://www.headwatermanagement.com/" onclick="window.open(this.href,'_blank');return false;">Headwater Management</a>.</p></div>`,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/O11gac7Dtj4",
                    title: "Zont™ Bracing Testimonial: Econ Group",
                    splashScreen: "/images/zont-bracing-testimonial-econ-group-youtube.webp"
                }
            ],
            articles: [
                {
                    id: 0,
                    title: "Challenging Site",
                    body: `<div id="imageSlider"></div>
	                    <div class="article_textWrapper">
	                    <p>The building site has an elevation change of 177' from the waterfront at the north end 
	                    to the public roadway at the south. A construction road (four wheel drive accessible) runs from 
	                    the public road at the top to a construction staging area at the 125' elevation. The staging 
	                    area was used to store construction materials, locate the site office and line pump for filling 
	                    the forms.</p><p>The foundation is located near the waterfront and runs up the granite 
	                    face resulting in footing elevation changes of over 28'. Footings were formed with 
	                    <a href="/${lang}/${urls.fastFoot.residential.overview}">Fastfoot®</a> and had 17 different levels to 
	                    accomodate the rocky terrain. Substantial blasting and rock removal was required to obtain level 
	                    areas for the footings.</p>
	                    </div>`,
                    image: ""
                },
                {
                    id: 1,
                    title: "Foundation Walls",
                    body: `<div id="imageSlider"></div>
	                    <div class="article_textWrapper">
	                    <p>Foundation walls were built with Amvic® insulating concrete forms. This block was chosen for 
	                    two reasons: first, the 6&quot; spacing on the ties provided greater strength. Second, the 
	                    foundation had many interior walls requiring T-junctions manufactured by Amvic®.</p>
	                    <p><em>&quot;We chose Zont™ Bracing because of&nbsp; the many different wall heights&quot;</em>, 
	                    said Carey Brown, Site Manager. <em>&quot;Some walls were 4' high, others were 
	                    17'. As the walls got taller, we installed another level of Zonts™ and walers.&quot;</em></p>
	                    <p><em>&quot;As well, Zonts™ make it easy to support end-of-wall bucks between the horizontal 
	                    walers. We couldn't do this with ICF bracing.&quot;</em></p>
                        </div>`,
                    image: ""
                },
                {
                    id: 2,
                    title: "Pouring Concrete",
                    body: `<div id="imageSlider"></div>
	                    <div class="article_textWrapper"><p>Concrete delivery was a challenge:</p>
	                    <ul>
	                    	<li>Ready mix trucks delivered the concrete to the end of a small public roadway;</li>
	                    	<li>A front end loader with a concrete hopper delivered concrete to a line pump located at mid-station;</li>
	                    	<li>200' of 4&quot; line travelled down the site built staircase to the top of foundation walls.</li>
	                    </ul>
	                    <p><em>&quot;Pouring the foundation walls was uneventful except for a breakdown in the line 
	                    pump&quot;, </em>said Carey.</p>
	                    <p><em>&quot;Zonts™ did a great job in flattening our walls.&quot;</em></p></div>`,
                    image: ""
                }
            ]
        },
        {
            id: "bradEssau",
            menuItem: {
                en: {
                    title: "Brad Essau",
                    url: "zont-bracing/projects/brad-essau",
                    metaTitle: "Brad Essau's Testimonial on Zont Bracing System",
                    metaDescription: "Brad Essau discusses the benefits of using the Zont Bracing system for his foundation projects and how it improves efficiency and wall alignment.",
                }
            },
            category: "zont-bracing",
            cardTitle: "Contractor Testimonial",
            cardDescription: `Brad Essau discusses Zont™ bracing system and how it works for his projects.`,
            cardImage: "/images/zont-bracing-brad-esau.webp",
            title: "Contractor Testimonial",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/uuZVfQo3vIA",
                    title: "Zont Bracing System Testimonial",
                    splashScreen: "/images/zont-bracing-system-testimonial-youtube.webp"
                }
            ],
            articles: []
        },
        {
            id: "rw",
            menuItem: {
                en: {
                    title: "R.W. Foundation",
                    url: "zont-bracing/projects/rw",
                    metaTitle: "ZontTwist™ Project with Richard Wickenheiser",
                    metaDescription: "Richard Wickenheiser discusses his use of the ZontTwist™ system for bracing a foundation, demonstrating its efficiency and versatility.",
                }
            },
            category: "zont-bracing",
            cardTitle: "ZontTwist™ Project Page",
            cardDescription: `Richard Wickenheiser discusses a recent foundation he braced with Zont Twist™...`,
            cardImage: "/images/zont-bracing-rw.webp",
            title: "ZontTwist™ Project Page",
            body: `<div><em>I wanted to thank you for the product. I used all old lumber that I had on site from a
                teardown of a previous strcuture. Since I had 5/8" rather than 3/4" plywood I altered the scaffold brace 
                plans. I also used a 2x8 and a 2x6 for the scaf-folding since I didn't have any 2x10s on hand. As you
                can see the pour went well and I made the final adjustment when we were 2 feet from the top. A very 
                professionally designed bracing system. I would highly recommend it.</em> Richard Wickenheiser</div>`,
            images: ["/images/projects/rw-1.webp"],
            videos: [],
            articles: [
                {
                    id: 0,
                    title: "",
                    body: ``,
                    image: "/images/projects/rw-2.webp"
                },
                {
                    id: 1,
                    title: "Catwalk",
                    body: `<div>
	                    <p>The image above shows the strongbacks and catwalk complete, ready for kickers and final 
	                    Zuckle™ adjustment.</p><p>2x6 and 2x8 from the demolished house were used to construct the walkway.</p>
	                    <p>Zont Twists™ were spaced 6' on center to ensure adequate support for the walkway. </p>
	                    <p>Installation was fast as the camlocks eliminated screwing the walers and strongbacks to the 
	                    waler bracket.</p>
	                    </div>`,
                    image: "/images/projects/rw-3.webp"
                },
                {
                    id: 2,
                    title: "Plywood gussets",
                    body: `<div><p>5/8" plywood was used for the gussets.</p></div>`,
                    image: "/images/projects/rw-4.webp"
                },
                {
                    id: 3,
                    title: "String lines",
                    body: `<div><p>Richard screwed 3" x 8" x 3/4" plywood blocks at each corner and ran string line 
                        around the perimeter.</p><p>Then the Zuckles were drill adjusted to ensure the top edge of the wall 
	                    was exactly 3/4" from the string line.</p><p>After the pour the alignment was rechecked.</p></div>`,
                    image: "/images/projects/rw-5.webp"
                },
                {
                    id: 4,
                    title: "Concrete Pour",
                    body: `<div><p>The bracing system performed perfectly with Fox Block ICF.</p><p><em>"A very 
                        professionally designed bracing system", </em>said Richard.<em>"I would highly recommend it."</em></p></div>`,
                    image: "/images/projects/rw-6.webp"
                },
                {
                    id: 5,
                    title: "Alignment",
                    body: `<div><p>The top of wall was adjusted using the Zuckles both before and after the pour.</p></div>`,
                    image: "/images/projects/rw-7.webp"
                }
            ]
        },
        {
            id: "fiftyThousandsZonts",
            menuItem: {
                en: {
                    title: "Fifty Thousands Zonts",
                    url: "zont-bracing/projects/fifty-thousands-zonts",
                    metaTitle: "50,000 Zont™ Braces Now in Use Across North America & Europe",
                    metaDescription: "Zont™ Bracing has reached 50,000 units across North America and Europe, revolutionizing foundation bracing with its lightweight and efficient design.",
                }
            },
            category: "zont-bracing",
            cardTitle: "50,000 Zont™ Braces now in market",
            cardDescription: `In every province and state of North America`,
            cardImage: "/images/zont-bracing-50k-zonts.webp",
            title: "50,000 Zont™ Braces - Across North America & Europe",
            body: `<p>Into every state in the USA and every province in Canada, Zont™ bracing can be found.</p>`,
            images: ["/images/projects/fiftyThousandsZonts-1.webp"],
            videos: [],
            articles: [
                {
                    id: 0,
                    title: "",
                    body: `<div>
	                    <p>The pictures above show an installation of<a rel="noreferrer" href="https://www.novidesa.com.mx/en" onclick="window.open(this.href,'_blank');return false;">
	                    Novidesa Sistemas Avanzados de Construccion</a> for a church in Pharr, Texas. The general 
	                    contractor with Novidesa is Luis Higareda. The walls were 16' tall, aligned perfectly with Zont™ 
	                    Bracing.</p>
	                    </div>`,
                    image: "/images/projects/fiftyThousandsZonts-2.webp"
                },
                {
                    id: 1,
                    title: "",
                    body: `<div><p>Shawn McDaniel of <a rel="noreferrer" href="https://www.squamishprefab.com/" onclick="window.open(this.href,'_blank');return false;">Squamish 
                        Prefab</a>, located in Squamish, BC, is a 21 year plywood forming veteran. He recently switched 
                        to ICFs and is delighted with the light weight of the blocks and the fact that stripping 
	                    is not required. The light weight Zont™ bracing works well with ICFs.</p></div>`,
                    image: "/images/projects/fiftyThousandsZonts-3.webp"
                },
                {
                    id: 2,
                    title: "",
                    body: `<div><p>John West of J & J Construction Inc., Pierre, SD: "Everything was perfect, that 
	                    is a great bracing system".</p></div>`,
                    image: "/images/projects/fiftyThousandsZonts-4.webp"
                },
                {
                    id: 3,
                    title: "",
                    body: `<div><p>Here's a project in North Vancouver, BC, Canada. The contractor, Yuriy Dzhyha, of 
                        Gerald Reedy Project Management is using the Nudura block.</p></div>`,
                    image: "/images/projects/fiftyThousandsZonts-5.webp"
                },
                {
                    id: 4,
                    title: "",
                    body: `<div><p>Brian Smith of Olympia, WA, has an Amvic ICF wall braced off a prepoured slab. Notice 
                        the 2x4s laid on the slab eliminating the need to put nails - the kickers change the 
	                    angle between the strongback and the slab 2x4.</p></div>`,
                    image: "/images/projects/fiftyThousandsZonts-6.webp"
                },
                {
                    id: 5,
                    title: "",
                    body: `<div><p>Here's a project in Whister, BC, Canada. The contractor is 
	                    <a rel="noreferrer" href="https://www.rdcfinehomes.com/" onclick="window.open(this.href,'_blank');return false;">RDC Fine Homes</a> and is using the 
	                    Logix block.</p></div>`,
                    image: "/images/projects/fiftyThousandsZonts-7.webp"
                }
            ]
        },
        {
            id: "zbTomsBackhoe",
            menuItem: {
                en: {
                    title: "Toms Backhoe",
                    url: urls.zontBracing.tomBackhoe,
                    metaTitle: "Zont™ Bracing in Haiku Maui HI - Remote Location Success",
                    metaDescription: "Gabe Hoeffken of Tom's Backhoe discusses how Zont™ Bracing was perfect for a remote ICF wall installation on Maui, providing straight walls without heavy equipment.",
                }
            },
            category: "zont-bracing",
            cardTitle: "Zont™ Bracing on Haiku Maui HI",
            cardDescription: `<em>"Zont™ Bracing was perfect for this remote location,"</em>  Gabe Hoeffken.`,
            cardImage: "/images/zont-bracing-toms-backhoe.webp",
            title: "Zont™ Bracing in Haiku Maui HI",
            body: `<div>
	            <p>Gabe Hoeffken, Vice-President of Tom's Backhoe & Excavation, recently used Zont™ 
	            bracing for his Logix® ICF walls.</p><p><em>&quot;Zonts™ were perfect for this remote location&quot;</em>, 
			    said Gabe. <em>&quot;There is no way we could afford to bring in bracing from the main island. 
			    And we got the straightest walls ever.&quot;</em></p><p>Thanks Gabe for the great photos.</p>
	            </div>`,
            images: [],
            videos: [],
            articles: [
                {
                    id: 0,
                    title: "",
                    body: `<div id="imageSlider"></div>`,
                    image: ""
                }
            ]
        },
        {
            id: "integraNnj",
            menuItem: {
                en: {
                    title: "Integra NJ",
                    url: "zont-bracing/projects/integra-nj",
                    metaTitle: "Zont™ Bracing for Confined City Lot in New Jersey",
                    metaDescription: "Gints Gulbis of Integra NJ used Zont™ Bracing for a tight city lot project in New Jersey, optimizing the foundation construction despite space constraints.",
                }
            },
            category: "zont-bracing",
            cardTitle: "Zont™ Bracing  on tiny city lot",
            cardDescription: `<em>"Zonts™ and Zuckles™ were amazingly easy to use!"</em> Gints Gulbis, Integraspec NJ`,
            cardImage: "/images/zont-bracing-integra-nnj.webp",
            title: "Zont™ Bracing on Confined City Lot",
            body: ``,
            images: ["/images/projects/integraNnj-1.webp"],
            videos: [],
            articles: [
                {
                    id: 0,
                    title: "",
                    body: `<div><p>Gints Gulbis, President, <a rel="noreferrer" href="https://www.integraspecicfnj.com" onclick="window.open(this.href,'_blank');return false;">
                        Integra NNJ</a>, recently supplied Zont Bracing for an ICF project in New Jersey. As 
	                    the lot was only 40' wide with no space for the excavator, the contractor left the excavator 
	                    in the center of his excavation to enable backfilling after pouring the stem wall.</p>
	                    <p>Gints was impressed with Zont™ bracing, <em>"I've been aware of Zuckle™ and Zont™ products 
	                    for some time. We supplied them on this project where site conditions worked against heavier, 
	                    standard metal bracing.&quot;</em></p><p><em>&quot;Online videos and information helped the 
	                    contractor learn the simple concept even before he got the alignment Zont™ bracing on site. His 
	                    concrete pour went <span class="font-bold">very well </span>and he said the Zont™ bracing was amazingly easy 
	                    and fast to use."</em></p></div>`,
                    image: "/images/projects/integraNnj-2.webp"
                },
                {
                    id: 1,
                    title: "Installing Zonts™",
                    body: `<div><p>Zonts™ were installed on the top and bottom of the 48" stem wall, 6' on center.</p></div>`,
                    image: "/images/projects/integraNnj-3.webp"
                },
                {
                    id: 2,
                    title: "Walkway",
                    body: `<div><p>The contractor used plywood gussets and 2x10s to create a walkway at the top of the 
                        2x4 strongbacks.</p></div>`,
                    image: "/images/projects/integraNnj-4.webp"
                },
                {
                    id: 3,
                    title: "ICF Corners",
                    body: `<div><p>1/2&quot; plywood and plumber's tape were used to reinforce corners on the 10&quot; wall.</p></div>`,
                    image: "/images/projects/integraNnj-5.webp"
                },
                {
                    id: 4,
                    title: "No Space for Excavator",
                    body: `<div><p>This image shows just how tight the space is on this city lot - no room to move.</p></div>`,
                    image: "/images/projects/integraNnj-6.webp"
                }
            ]
        },
        {
            id: "pacificIcf",
            menuItem: {
                en: {
                    title: "Pacific ICF",
                    url: "zont-bracing/projects/pacific-icf",
                    metaTitle: "Pacific ICF Converts to Zont™ Bracing for Efficient Foundation Work",
                    metaDescription: "Pacific ICF adopts Zont™ Bracing for improved foundation construction, cutting down on material weight and installation time for their projects.",
                }
            },
            category: "zont-bracing",
            cardTitle: "Pacific ICF Converts to Zonts™",
            cardDescription: `<em>"I'll never go back to conventional braces..."</em>`,
            cardImage: "/images/zont-bracing-michael-antonoff.webp",
            title: "",
            body: ``,
            images: [],
            videos: [
                {
                    video: "https://www.youtube.com/embed/Q0z5q17UgtQ",
                    title: "Zont™ Insulated Concrete Form (ICF) Bracing: Contractor Testimonial",
                    splashScreen: "/images/icf-bracing-contractor-testimonial-youtube.webp"
                }
            ],
            articles: [
                {
                    id: 0,
                    title: "Pacific ICF Converts to Zont™ Bracing",
                    body: `<div><p><a rel="noreferrer" href="https://pacificicf.com/" onclick="window.open(this.href,'_blank');return false;">Pacific ICF Inc.</a> is a Vancouver 
                        based contractor specializing in ICF construction. President Michael Antonoff: <em>&quot;We've 
                        been building with ICFs and fabric formwork for 12 years. We've been a green contractor long 
                        before it became fashionable.&quot;</em></p><p><em>&quot;We've owned several sets of 10' 
                        ICF bracing&quot;</em>, said Michael. <em>&quot;But we got tired of lifting them in and out of 
                        the hole, and then finding a place to store them. We are definitely not keen on moving a ton of 
	                    bracing to flatten a <span class="font-bold">light weight </span>ICF wall.&quot;</em></p>
	                    <p><em>&quot;When I heard about the Zont™ Bracing I was very interested.&quot;</em></p></div>`,
                    image: "/images/projects/pacificIcf-1.webp"
                },
                {
                    id: 1,
                    title: "Horizontal vs. Vertical bracing™",
                    body: `<div><p>The photo on the left above shows horizontal bracing, where the first contact with 
                        the wall is a <span class="font-bold">horizontal</span> waler, held in place with the Zont™ bracket. The photo 
                        on the right shows conventional ICF braces where the first contact with the ICF wall is a vertical 
                        member.</p><p>As the critical alignment of the ICF wall is in the horizontal cirection, it makes 
                        sense to align first in the <span class="font-bold">horizontal</span> direction, not vertical. Many ICF 
                        manufacturers recommend the use of a product called 'form-lock', an open wire mesh product 
                        12 1/2' long and the width of the ICF cavity to serve as an internal horizontl waler to 
	                    provide the horizontal alignment. With the use of Zont™ bracing, form-lock is eliminated saving 
	                    the contractor about $350 per typical foundation.</p></div>`,
                    image: "/images/projects/pacificIcf-2.webp"
                },
                {
                    id: 2,
                    title: "Flatter Walls",
                    body: `<div><p>The Zont™,&nbsp; Zuckle™ and angled kicker allow a top of wall accuracy of 1/8&quot;.</p>
	                    <p><em>&quot;We're impressed with the system&quot;</em>, confirmed Michael. <em>&quot;The 
	                    Zuckles™ quickly adjust with an electric drill to get a real flat wall.&quot;</em></p></div>`,
                    image: "/images/projects/pacificIcf-3.webp"
                },
                {
                    id: 3,
                    title: "Zonts™ & Zuckles™",
                    body: `<div><p>Each Zont™ weighs one and one half pounds and the Zuckle™ about twice that much.</p>
	                    <p><em>&quot;Each 'brace' equivalent weighs about one tenth the weight of our old vertical 
	                    braces. All the 2x4s are left on site to be incorporated into the build.&quot;</em></p>
	                    <p>&nbsp;This efficiency leads to cost savings to the contractor and resource savings to the 
	                    environment.</p>
                        <p>See the <a href="/${lang}/${urls.zontBracing.specifications}">Zont™ Bracing specifications</a> for more details.</p>
                        </div>`,
                    image: "/images/projects/pacificIcf-4.webp"
                },
                {
                    id: 4,
                    title: "Placing Concrete",
                    body: `<div><p>Concrete placement is no different with Zonts™ as with conventional ICF bracing. As 
                        the vertical strong backs are located 3 5/8&quot; away from the ICF wall, there's plenty of 
                        room to install reinforcing around window and door openings.</p><p>Zont™ brackets can be located 
                        on each side of the openings to ensure perfect alignment.</p><p><em>&quot;I'm sold on Zont™ 
                        bracing&quot;, </em>confirmed Michael.</p></div>`,
                    image: "/images/projects/pacificIcf-5.webp"
                }
            ]
        },
        {
            id: "gableEndBracing",
            menuItem: {
                en: {
                    title: "Gable End Bracing",
                    url: "zont-bracing/projects/gable-end-bracing",
                    metaTitle: "Bracing Gable Ends with Zont™ for Accurate Foundation Walls",
                    metaDescription: "Zont™ Bracing system is used to brace uneven gable ends, ensuring alignment and stability for ICF walls on a project in Central Scotland.",
                }
            },
            category: "zont-bracing",
            cardTitle: "Bracing of Gable End Walls",
            cardDescription: `Gable end wall bracing is difficult with traditional braces, but with Zonts™...`,
            cardImage: "/images/zont-bracing-gable-end.webp",
            title: "Bracing of Gable Ends with Zonts™",
            body: `<div><p>This project, a single family dwelling built by 
                <a rel="noreferrer" href="https://www.sunflowerinitiatives.com" onclick="window.open(this.href,'_blank');return false;">Sunflower Initiatives</a>, 
	            Central Scotland, consists of a main floor, second floor and a third floor with dormer windows projecting 
	            through the roof structure. <a href="/${lang}/${urls.zontBracing.sunflower}">View more detailed project photos</a>.</p>
	            <p>The construction sequence of the ICF envelope was as follows:</p>
	            <ul>
	            	<li>Main floor walls built and poured to a height of 12.5';</li>
	            	<li>Second floor system installed (to enable bracing off the floor structure);</li>
	            	<li>Second and third floor walls (including gable ends) built and poured in one lift to a height of 19' 4". </li>
	            </ul></div>`,
            images: [],
            videos: [],
            articles: [
                {
                    id: 0,
                    title: "",
                    body: `<div><p>Bracing of uneven gable ends is problematic with conventional ICF vertical braces, 
                        with the wall height varying significantly across the gable end. However with Zont™ horizontal 
                        braces the different heights are easily accomodated by adding additional Zont™ layers for the 
                        taller sections.</p><p>As seen in the photo above, five Zont™ layers progressively followed 
	                    the higher gable ends. Three levels of Zuckles™ ensured that the gable ends were in perfect 
	                    alignment.</p></div>`,
                    image: "/images/projects/gableEndBracing-1.webp"
                },
                {
                    id: 1,
                    title: "™",
                    body: `<div><p>Second floor assembly was used to support the kickers to align the second and third 
                        story walls which were poured in one lift. The side walls (14' high) were aligned with two levels 
                        kickers, the gable end walls (19' 4") with three levels of kicker.</p></div>`,
                    image: "/images/projects/gableEndBracing-2.webp"
                },
                {
                    id: 2,
                    title: "",
                    body: `<div><p>Placing concrete in the second and third floor walls was uneventful. The inset picture 
                        shows pump hose operator filling the gable end.</p><p>President Najem Mahmoud Al-Hasan wrote: 
                        <em>"We could not believe how strong the system was. After the pour had completed, we checked all 
                        the walls and only one brace had moved slightly. When I say slightly, I should perhaps elaborate. 
                        We had to adjust by 3mm."</em></p><p><a href="/${lang}/${urls.zontBracing.sunflower}">View the full project page</a>.</p></div>`,
                    image: "/images/projects/gableEndBracing-3.webp"
                }
            ]
        },
        {
            id: "sunflower",
            menuItem: {
                en: {
                    title: "Sunflower Initiatives",
                    url: "zont-bracing/projects/sunflower-initiatives",
                    metaTitle: "Zont™ Bracing Debuts in Scotland with Sunflower Initiatives",
                    metaDescription: "Sunflower Initiatives shares their experience with Zont™ Bracing in Scotland, highlighting its efficiency in ICF construction and bracing.",
                }
            },
            category: "zont-bracing",
            cardTitle: "Zonts™ Debut in Scotland",
            cardDescription: `<a>Naj discusses why he sold his conventional braces to buy Zonts™ from the other side of the globe...</a>`,
            cardImage: "/images/zont-bracing-sunflower.webp",
            title: "Bracing of Gable Ends with Zonts™",
            body: ``,
            images: ["/images/projects/sunflower-1.webp"],
            videos: [],
            articles: [
                {
                    id: 0,
                    title: "Testimonial - Sunflower Initiatives, Central Scotland",
                    body: `<div><p><a rel="noreferrer" href="https://www.sunflowerinitiatives.com" onclick="window.open(this.href,'_blank');return false;">Sunflower Initiatives</a> 
	                    provides architectural design, construction management and property investment services. President 
	                    Najem Mahmoud Al-Hasan has long believed that ICF construction offers significant advantages in 
	                    thermal performance and construction efficiency over conventional masonry construction. He offers 
	                    his comments on Zont bracing:</p><p><em>Joey, Thought I would put down a few words on our experience 
	                    of the Zonts... </em></p><p><em>We have been constructing with ICF since 2008 and have always used steel 
	                    bracing made up of several components.  As you can imagine, our shiney new equipment did not stay 
	                    pristine for very long and many of the loose components have long since been lost and replaced 
	                    with makeshift items.</em></p><p><em>We were intrigued when we first learnt of the Zonts and were quite 
	                    skeptical. At a fraction of the price of our steel bracing, we felt it was worth a punt. Our first 
	                    order was placed and we received the UK's first shipment of Zonts and Zuckles.  Installing the Zonts 
	                    and Zuckles could not have been easier - and significantly quicker than steel bracing.</em></p>
	                    <p><em>Our first pour was 3.8m and we could not believe how strong the system was. After the pour 
	                    had completed, we checked all the walls and only one brace had moved slightly.  When I say slightly, 
	                    I should perhaps elaborate.  We had to adjust by 3mm.</em></p><p><em>The Zonts and Zuckles are now 
	                    a proud and extremely valued asset in our company. The fact that we no longer need a lorry to transport 
	                    our bracing - we had a whole house worth of bracing in the car - is a major benefit and the space 
	                    freed up by the sale of our steel bracing now allows us to stock more profit making items.</em></p>
	                    <p><em><span class="font-bold">We strongly recommend Zonts and Zuckles for your next project.  You will 
	                    never look back!</span></em></p><p><em>Regards, Najem Mahmoud Al-Hasan</em></p></div>`,
                    image: "/images/projects/sunflower-2.webp"
                },
                {
                    id: 1,
                    title: "",
                    body: `<div><p>Zonts™ were installed 4' on center vertically and 6' on center horizontally. 2x4 walers 
                        and strongbacks have been installed, ready for kickers.</p></div>`,
                    image: "/images/projects/sunflower-3.webp"
                },
                {
                    id: 2,
                    title: "",
                    body: `<div><p>Zonts™ are ideal for openings. A Zont™ can be placed on the edge of each opening, 
                        locking the wall in perfect alignment.</p></div>`,
                    image: "/images/projects/sunflower-4.webp"
                },
                {
                    id: 3,
                    title: "",
                    body: `<div><p>The Zont™ Camlock is twisted counter-clockwise, tightening the ICF wall to the horizontal 
                        waler and vertical strongback. Installation time is reduced in half.</p></div>`,
                    image: "/images/projects/sunflower-5.webp"
                },
                {
                    id: 4,
                    title: "",
                    body: `<div><p>Kickers and catwalk are in place, ready for concrete.</p></div>`,
                    image: "/images/projects/sunflower-6.webp"
                },
                {
                    id: 5,
                    title: "",
                    body: `<div><p>Zuckles™ are ideal for straightening the ICF wall. An electric drill quickly adjusts 
                        the plumb of the strongback.</p></div>`,
                    image: "/images/projects/sunflower-7.webp"
                },
                {
                    id: 6,
                    title: "",
                    body: `<div><p>Zont bracing is quickly adaptable to different wall heights. Here the gable ends extend 
                        about 20' above the second floor structure.</p></div>`,
                    image: "/images/projects/sunflower-8.webp"
                },
                {
                    id: 7,
                    title: "",
                    body: `<div><p>Second and third floor wall bracing was done off the second floor itself. The gable ends 
                        required three levels of kickers for support.</p></div>`,
                    image: "/images/projects/sunflower-9.webp"
                },
                {
                    id: 8,
                    title: "",
                    body: `<div><p>Placing concrete in the second and third floor walls was uneventful. The inset picture 
                        shows pump hose operator filling the gable end.</p></div>`,
                    image: "/images/projects/sunflower-10.webp"
                },
            ]
        },
    ]